import { html, TemplateResult } from 'lit';

export const uiFlagIconSet: TemplateResult = html`
  <svg
    aria-hidden="true"
    style="position: absolute; width: 0; height: 0; overflow: hidden;"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AF">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1AB11F"></stop>
            <stop offset="100%" stop-color="#149818"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DC0D18"></stop>
            <stop offset="100%" stop-color="#BE0711"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
          <path
            fill="#FFF"
            fill-rule="nonzero"
            d="M8 7a2.5 2.5 0 0 0 1.247 2.164.5.5 0 0 0 .502-.865A1.499 1.499 0 0 1 9 7a.5.5 0 0 0-1 0Zm3.846 2.107A2.498 2.498 0 0 0 13 7a.5.5 0 1 0-1 0 1.5 1.5 0 0 1-.693 1.265.5.5 0 1 0 .539.842Z"
            opacity=".75"
          ></path>
          <ellipse cx="10.5" cy="6.5" fill="#FFF" fill-opacity=".5" rx="1" ry="1.5"></ellipse>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="AG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E2243B"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFCF3C"></stop>
            <stop offset="100%" stop-color="#FECB2F"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1984D8"></stop>
            <stop offset="100%" stop-color="#1175C4"></stop>
          </linearGradient>
          <path id="c" d="M0 0h21L10.5 15z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path d="M8.5 7a2 2 0 0 0 .998 1.731m2.078-.045c.556-.355.924-.978.924-1.686" opacity=".75"></path>
          <ellipse cx="10.5" cy="6.5" fill="#FFF" fill-opacity=".5" rx="1" ry="1.5"></ellipse>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <mask id="f" fill="#fff">
            <use xlink:href="#c"></use>
          </mask>
          <use xlink:href="#c" fill="url(#d)"></use>
          <path
            fill="url(#e)"
            d="m10.5 8.25-1.722 1.907.131-2.566-2.566.131L8.25 6 6 4l2.909.5-.409-3 2 2.5 2-2.5-.409 3L15 4l-2.25 2 1.907 1.722-2.566-.131.131 2.566z"
            mask="url(#f)"
          ></path>
          <path fill="url(#g)" d="M0 6h21v4H0z" mask="url(#f)"></path>
          <path fill="url(#a)" d="M0 10h21v5H0z" mask="url(#f)"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="AI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A17A7"></stop>
            <stop offset="100%" stop-color="#030E88"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFA51B"></stop>
            <stop offset="100%" stop-color="#FF9A00"></stop>
          </linearGradient>
          <filter id="e" width="112.5%" height="120%" x="-6.2%" y="-5%" filterUnits="objectBoundingBox">
            <feOffset dy=".5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <path id="d" d="M0 2.5V0l1 .5L2 0l1 .5L4 0v2.5C4 4 2 5 2 5S0 4 0 2.5Z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#c)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#c)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <g transform="translate(13 5)">
            <mask id="f" fill="#fff">
              <use xlink:href="#d"></use>
            </mask>
            <use xlink:href="#d" fill="#000" filter="url(#e)"></use>
            <use xlink:href="#d" fill="url(#a)"></use>
            <path fill="#9ACCFF" d="M0 4h4v1H0z" mask="url(#f)"></path>
            <path
              fill="url(#g)"
              d="M2 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM1 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
              mask="url(#f)"
            ></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AL">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EE343C"></stop>
            <stop offset="100%" stop-color="#E2222A"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#c)"
            d="m9.348 3.348.804.804a.496.496 0 0 0 .696 0l.804-.804a.631.631 0 0 1 .758-.075L13.5 4l-1.548.774a.892.892 0 0 0-.452.726c0 .268.224.5.5.5.268 0 .699-.1.944-.222l1.112-.556a.734.734 0 0 1 .794.128l.3.3c.194.194.151.45-.094.572l-1.112.556c-.245.122-.26.344-.034.495l.68.454c.226.15.194.316-.072.37l-1.536.307c-.269.053-.3.232-.077.4l1.19.892c.22.166.181.304-.095.304a4.93 4.93 0 0 1-.984-.121l-1.032-.258c-.27-.067-.362.063-.21.289l.453.68c.15.226.046.41-.235.41h-.484a.74.74 0 0 0-.666.475l-.184.55c-.088.266-.229.263-.316 0l-.184-.55A.741.741 0 0 0 9.492 11h-.484c-.287 0-.386-.184-.235-.41l.454-.68c.15-.226.056-.356-.211-.289l-1.032.258A4.85 4.85 0 0 1 7 10c-.268 0-.319-.136-.095-.304l1.19-.892c.22-.166.19-.347-.077-.4l-1.536-.308c-.269-.053-.298-.218-.072-.37l.68-.453c.226-.15.211-.372-.034-.495l-1.112-.556c-.245-.122-.287-.379-.094-.572l.3-.3a.733.733 0 0 1 .794-.128l1.112.556C8.301 5.9 8.724 6 9 6c.268 0 .5-.224.5-.5 0-.268-.199-.6-.444-.722l-1.112-.556c-.245-.122-.26-.344-.034-.495l.68-.454a.626.626 0 0 1 .758.075Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1047B9"></stop>
            <stop offset="100%" stop-color="#06379D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F01C31"></stop>
            <stop offset="100%" stop-color="#D70A1F"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F5B23E"></stop>
            <stop offset="100%" stop-color="#F0A728"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#d)" d="M0 10h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF323E"></stop>
            <stop offset="100%" stop-color="#FD0D1B"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DD2137"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F8D84B"></stop>
            <stop offset="100%" stop-color="#F9D536"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 8h21v7H0z"></path>
          <path fill="url(#d)" d="M0 0h21v8H0z"></path>
          <path
            fill="url(#e)"
            fill-rule="nonzero"
            d="m10.63 8.855-1.407-.939a.5.5 0 0 1 .554-.832l1.536 1.024a2 2 0 0 0-1.253-2.863.5.5 0 1 1 .259-.966 3 3 0 0 1 1.83 4.386l.628.419a.5.5 0 0 1-.554.832l-.713-.475a2.995 2.995 0 0 1-2.744.633.5.5 0 0 1 .259-.966c.57.153 1.147.044 1.606-.253ZM9.5 6.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#88BBE8"></stop>
            <stop offset="100%" stop-color="#76ADDD"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0zm0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path fill="#DB7A2C" fill-rule="nonzero" d="M10.5 9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"></path>
          <circle cx="10.5" cy="7.5" r="1.5" fill="#F4B32E"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#071585"></stop>
            <stop offset="100%" stop-color="#000B64"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D32636"></stop>
            <stop offset="100%" stop-color="#BA1827"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="35.4%" y1="0%" y2="89.131%">
            <stop offset="0%" stop-color="#AB5423"></stop>
            <stop offset="100%" stop-color="#5A3719"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" fill-rule="nonzero" d="m22 15.5-22-8 22-8z"></path>
          <path fill="url(#a)" fill-rule="nonzero" d="M21 .928 2.926 7.5 21 14.072z"></path>
          <path
            fill="url(#d)"
            d="M16 7.038c-.118-.118-.806.156-.806.156L14 6s-.062-.663.5-1c.425-.255 1.22-.16 1.999-.5C17.746 3.956 19 3 19 3l-.802 2.206s.919.473.802.794c-.034.093-.93.385-1 .5-.132.22.524.286.32.538C17.733 7.765 17 8.5 17 8.5L16 8s.15-.811 0-.962Z"
          ></path>
          <circle cx="13.5" cy="7.5" r="1" fill="#FFC322"></circle>
          <path fill="#FFC322" fill-rule="nonzero" d="M12.5 9h5a.5.5 0 1 0 0-1h-5a.5.5 0 1 0 0 1Z"></path>
          <path
            fill="#FFC322"
            fill-rule="nonzero"
            d="m14.197 10.46 3.5-1.5a.5.5 0 0 0-.394-.92l-3.5 1.5a.5.5 0 0 0 .394.92Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F64253"></stop>
            <stop offset="100%" stop-color="#EA2D3F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0zm0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A17A7"></stop>
            <stop offset="100%" stop-color="#030E88"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#c)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#c)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <path
            fill="#FFF"
            d="m4.5 12.25-.882.464.169-.982-.714-.696.986-.143L4.5 10l.441.893.986.143-.714.696.169.982zM15 13l-.707.207.207-.707-.207-.707L15 12l.707-.207-.207.707.207.707zm0-9.5-.707.207L14.5 3l-.207-.707L15 2.5l.707-.207L15.5 3l.207.707zm3 3-.707.207L17.5 6l-.207-.707L18 5.5l.707-.207L18.5 6l.207.707zm-6 1-.707.207L11.5 7l-.207-.707L12 6.5l.707-.207L12.5 7l.207.707zm4.5 1.25-.354.104.104-.354-.104-.354.354.104.354-.104-.104.354.104.354z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#5098EA"></stop>
            <stop offset="100%" stop-color="#458BDB"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E82045"></stop>
            <stop offset="100%" stop-color="#D01739"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M1.803 4.96a.5.5 0 0 1 0-.92l1.566-.67.671-1.567a.5.5 0 0 1 .92 0l.67 1.566 1.567.671a.5.5 0 0 1 0 .92l-1.566.67-.671 1.567a.5.5 0 0 1-.92 0l-.67-1.566-1.567-.671Z"
          ></path>
          <path fill="url(#c)" d="M3.75 5.25 2 4.5l1.75-.75L4.5 2l.75 1.75L7 4.5l-1.75.75L4.5 7z"></path>
          <path fill="#F9D536" d="M0 11h21v1H0zm0-2h21v1H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AX">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#157CBB"></stop>
            <stop offset="100%" stop-color="#0E6CA5"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD34D"></stop>
            <stop offset="100%" stop-color="#FECB2F"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EB363A"></stop>
            <stop offset="100%" stop-color="#D52B2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
          <path fill="url(#d)" d="M0 8h7v7h1V8h13V7H8V0H7v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#24AAD5"></stop>
            <stop offset="100%" stop-color="#1899C2"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#ED1845"></stop>
            <stop offset="100%" stop-color="#DE0C39"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#21BF75"></stop>
            <stop offset="100%" stop-color="#19AD68"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="M0 10h21v5H0z"></path>
          <path
            fill="url(#a)"
            d="M11.334 6.253a1.25 1.25 0 1 0 0 2.495 1.5 1.5 0 1 1 0-2.495ZM11.5 8a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0B36B2"></stop>
            <stop offset="100%" stop-color="#042993"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD045"></stop>
            <stop offset="100%" stop-color="#FECA2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M17 15V0H6.5z"></path>
          <path
            fill="url(#a)"
            d="m13 14-.707.207.207-.707-.207-.707L13 13l.707-.207-.207.707.207.707zm-2-3-.707.207.207-.707-.207-.707L11 10l.707-.207-.207.707.207.707zM9 8l-.707.207L8.5 7.5l-.207-.707L9 7l.707-.207L9.5 7.5l.207.707zM7 5l-.707.207L6.5 4.5l-.207-.707L7 4l.707-.207L7.5 4.5l.207.707zM5 2l-.707.207L4.5 1.5 4.293.793 5 1l.707-.207L5.5 1.5l.207.707z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BB">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1132C7"></stop>
            <stop offset="100%" stop-color="#0522A5"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#08379D"></stop>
            <stop offset="100%" stop-color="#042A7D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFCC50"></stop>
            <stop offset="100%" stop-color="#FFC63C"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M10 0h11v15H10zM0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
          <path
            fill="url(#e)"
            d="M10.378 4.709c.079-.116.206-.11.278 0l.708 1.082c.075.116.019.209-.118.209h-.242a.221.221 0 0 0-.23.249l.201 2.002a.285.285 0 0 0 .275.249.695.695 0 0 0 .43-.179l.14-.137c.1-.099.18-.286.18-.432v-.498a.696.696 0 0 0-.18-.435l-.14-.138c-.1-.1-.082-.214.054-.26l1.032-.343c.13-.043.214.03.188.17l-.368 2.003a.918.918 0 0 1-.227.423l-.678.652a.726.726 0 0 1-.431.174.247.247 0 0 0-.25.252v.496a.248.248 0 0 1-.252.252h-.496a.249.249 0 0 1-.252-.252v-.496a.254.254 0 0 0-.25-.252.69.69 0 0 1-.424-.174l-.652-.652a.956.956 0 0 1-.224-.423l-.4-2.002c-.028-.138.048-.216.184-.17l1.032.343c.13.043.156.156.053.259l-.138.138c-.1.1-.181.289-.181.435v.498c0 .14.078.33.18.432l.14.137c.1.1.296.179.43.179a.28.28 0 0 0 .275-.249l.2-2.002A.225.225 0 0 0 9.996 6h-.242c-.14 0-.187-.098-.112-.209l.736-1.082Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BD">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#128363"></stop>
            <stop offset="100%" stop-color="#0C6A4F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F23C53"></stop>
            <stop offset="100%" stop-color="#F22E46"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <circle cx="9.5" cy="7.5" r="4.5" fill="url(#c)"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF4453"></stop>
            <stop offset="100%" stop-color="#EE2A39"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFCF3C"></stop>
            <stop offset="100%" stop-color="#FECB2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BF">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#00B051"></stop>
            <stop offset="100%" stop-color="#009F49"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FA494B"></stop>
            <stop offset="100%" stop-color="#F02B2D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 8h21v7H0z"></path>
          <path fill="url(#c)" d="M0 0h21v8H0z"></path>
          <path
            fill="#FDD216"
            d="m10.5 9.17-1.763 1.257.65-2.065-1.74-1.289 2.165-.02L10.5 5l.688 2.053 2.165.02-1.74 1.289.65 2.065z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#06A77C"></stop>
            <stop offset="100%" stop-color="#00966E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E32E19"></stop>
            <stop offset="100%" stop-color="#D62612"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 0h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BH">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E7243B"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M0 15h7.5L6 14l1.5-1L6 12l1.5-1L6 10l1.5-1L6 8l1.5-1L6 6l1.5-1L6 4l1.5-1L6 2l1.5-1L6 0H0z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E4233B"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#34CD4E"></stop>
            <stop offset="100%" stop-color="#2AB441"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DF2239"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M2.08 1.437h21v15h-21z" transform="translate(-2.08 -1.44)"></path>
          <path fill="url(#c)" d="m2 1.437 9 7.5-9 7.5z" transform="translate(-2.08 -1.44)"></path>
          <path fill="url(#c)" d="m14.08 1.437 9 7.5-9 7.5z" transform="matrix(-1 0 0 1 35.08 -1.44)"></path>
          <path
            fill="url(#a)"
            d="M10.359 6.233 1.119 0 0 1.658 9.24 7.89a3.499 3.499 0 0 0 0 2.094L0 16.217l1.118 1.658 9.24-6.233a3.486 3.486 0 0 0 2.222.795c.844 0 1.617-.298 2.222-.795l9.24 6.233 1.118-1.658-9.24-6.233a3.499 3.499 0 0 0 0-2.094l9.24-6.232L24.042 0l-9.24 6.233a3.486 3.486 0 0 0-2.222-.796c-.843 0-1.617.299-2.221.796Z"
            transform="translate(-2.08 -1.44)"
          ></path>
          <path
            fill="url(#d)"
            d="m12.58 7.937-.707.207.207-.707-.207-.707.707.207.707-.207-.207.707.207.707-.707-.207Zm-1.5 2.5-.707.207.207-.707-.207-.707.707.207.707-.207-.207.707.207.707-.707-.207Zm3 0-.707.207.207-.707-.207-.707.707.207.707-.207-.207.707.207.707-.707-.207Z"
            transform="translate(-2.08 -1.44)"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BJ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F12641"></stop>
            <stop offset="100%" stop-color="#E71834"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD648"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#17A668"></stop>
            <stop offset="100%" stop-color="#118653"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#c)" d="M0 0h21v7H0z"></path>
          <path fill="url(#d)" d="M0 0h8v15H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="BL">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#216CD3"></stop>
            <stop offset="100%" stop-color="#1557B2"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F7E14B"></stop>
            <stop offset="100%" stop-color="#F7DF3E"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E12539"></stop>
            <stop offset="100%" stop-color="#CA192C"></stop>
          </linearGradient>
          <path
            id="b"
            d="M.5 0h7v4.491c0 .557-.336 1.297-.76 1.66L5.147 7.518c-.633.542-1.662.54-2.292 0L1.259 6.15C.84 5.791.5 5.05.5 4.491V0Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <g transform="translate(6.5 5)">
            <mask id="e" fill="#fff">
              <use xlink:href="#b"></use>
            </mask>
            <use xlink:href="#b" fill="url(#c)"></use>
            <path
              fill="url(#d)"
              d="M2 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM2.5 6.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM4 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1.5-.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
              mask="url(#e)"
            ></path>
            <path fill="url(#f)" d="M.5 3h7v2h-7z" mask="url(#e)"></path>
            <circle cx="4" cy="4" r="1" fill="#FFF" mask="url(#e)"></circle>
          </g>
          <path fill="url(#d)" d="M6.5 3.5s2-.5 4-.5 4 .5 4 .5l-.5 2S12.25 5 10.5 5 7 5.5 7 5.5l-.5-2Z"></path>
          <path
            fill="#5E5216"
            d="M10.5 4.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-4 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="BM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DC1F37"></stop>
            <stop offset="100%" stop-color="#CF142C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#042C90"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E20B0C"></stop>
            <stop offset="100%" stop-color="#D40001"></stop>
          </linearGradient>
          <path id="e" d="M0 2.5V0h4v2.5C4 4 2 5 2 5S0 4 0 2.5Z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 0h9v7H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#d)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#d)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <g transform="translate(13 5)">
            <mask id="f" fill="#fff">
              <use xlink:href="#e"></use>
            </mask>
            <use xlink:href="#e" fill="url(#a)"></use>
            <circle cx="2" cy="3" r="1" fill="#65B5D2" mask="url(#f)"></circle>
            <path
              fill="url(#g)"
              d="M2 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM1 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
              mask="url(#f)"
            ></path>
            <path fill="#2F8F22" d="M0 4h4v1H0z" mask="url(#f)"></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F7E250"></stop>
            <stop offset="100%" stop-color="#F7DF38"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M-3.487 4.59h29v3h-29z" transform="rotate(20 11.013 6.09)"></path>
          <path fill="url(#c)" d="M-4.513 7.41h29v3h-29z" transform="rotate(20 9.987 8.91)"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#058C3F"></stop>
            <stop offset="100%" stop-color="#007A34"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E63426"></stop>
            <stop offset="100%" stop-color="#D52B1E"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFEB1F"></stop>
            <stop offset="100%" stop-color="#FAE400"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#d)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="BR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#05AB41"></stop>
            <stop offset="100%" stop-color="#019C39"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#053087"></stop>
            <stop offset="100%" stop-color="#012877"></stop>
          </linearGradient>
          <circle id="c" cx="3.5" cy="3.5" r="3.5"></circle>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="#FDD216"
            d="M2.422 7.773c-.233-.15-.228-.398 0-.546l7.656-4.954a.85.85 0 0 1 .844 0l7.656 4.954c.233.15.228.398 0 .546l-7.656 4.954a.85.85 0 0 1-.844 0L2.422 7.773Z"
          ></path>
          <g transform="translate(7 4)">
            <mask id="e" fill="#fff">
              <use xlink:href="#c"></use>
            </mask>
            <use xlink:href="#c" fill="url(#d)"></use>
            <path
              fill="#FFF"
              fill-rule="nonzero"
              d="M-.1 2.974c.265-.215 1.463-.04 3.534.512 1.474.394 3.173 1.262 3.562 1.742l.314.388.778-.629-.315-.388c-.55-.68-2.421-1.636-4.081-2.079-2.586-.69-3.758-.86-4.422-.323l-.388.314.629.777.389-.314Z"
              mask="url(#e)"
            ></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#22B7D5"></stop>
            <stop offset="100%" stop-color="#1CACC8"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FCE569"></stop>
            <stop offset="100%" stop-color="#FADF52"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0zM0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="m0 0 10 7.5L0 15z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BV">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F14247"></stop>
            <stop offset="100%" stop-color="#ED2F35"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A3A85"></stop>
            <stop offset="100%" stop-color="#032A67"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
          <path fill="url(#c)" d="M0 8h7v7h1V8h13V7H8V0H7v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BY">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E54252"></stop>
            <stop offset="100%" stop-color="#C63442"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#5CBE6B"></stop>
            <stop offset="100%" stop-color="#4EA55B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v10H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path
            fill="url(#a)"
            d="M3 12.75V15H0V0h3v2.25L2.5 3l.5.75v1.5L2.5 6l.5.75v1.5L2.5 9l.5.75v1.5l-.5.75.5.75Z"
          ></path>
          <path
            fill="url(#b)"
            d="m-1.5 3 1-1.5L.5 3l-1 1.5-1-1.5Zm0 3 1-1.5L.5 6l-1 1.5-1-1.5Zm0 3 1-1.5L.5 9l-1 1.5-1-1.5Zm0 3 1-1.5 1 1.5-1 1.5-1-1.5Zm2-10.5 1-1.5 1 1.5-1 1.5-1-1.5Zm0 3 1-1.5 1 1.5-1 1.5-1-1.5Zm0 3 1-1.5 1 1.5-1 1.5-1-1.5Zm0 3 1-1.5 1 1.5-1 1.5-1-1.5Zm0 3 1-1.5 1 1.5-1 1.5-1-1.5Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#8BBDEA"></stop>
            <stop offset="100%" stop-color="#78ABDA"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0zm0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 6h21v3H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF5F38"></stop>
            <stop offset="100%" stop-color="#FD5026"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD951"></stop>
            <stop offset="100%" stop-color="#FFD43B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 15 21 0H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF3131"></stop>
            <stop offset="100%" stop-color="red"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10zM0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M6 0h9v15H6z"></path>
          <path
            fill="url(#b)"
            d="m11.674 7.326.652-.652a.251.251 0 0 1 .355.007L13 7l1-.5-.5 1 .32.32a.247.247 0 0 1 .008.352L12.5 9.5H11l-.25 1.5h-.5L10 9.5H8.5L7.172 8.172a.253.253 0 0 1 .009-.353L7.5 7.5l-.5-1L8 7l.32-.32a.249.249 0 0 1 .354-.006l.652.652c.096.096.152.063.124-.075L9 5l1 .5.5-1.5.5 1.5 1-.5-.45 2.251c-.029.142.028.171.124.075Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="BZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#094995"></stop>
            <stop offset="100%" stop-color="#074185"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D5182F"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 2h21v11H0z"></path>
          <path fill="url(#c)" d="M0 0h21v2H0zm0 13h21v2H0z"></path>
          <circle cx="10.5" cy="7.5" r="4.5" fill="url(#a)"></circle>
          <path
            fill="#118014"
            fill-rule="nonzero"
            d="M10.5 11a.5.5 0 1 1 0-1c.284 0 .56-.047.822-.138a.5.5 0 1 1 .329.944A3.495 3.495 0 0 1 10.5 11Zm2.651-1.215a3.5 3.5 0 0 0 .605-.998.5.5 0 0 0-.93-.368 2.5 2.5 0 0 1-.432.713.5.5 0 0 0 .757.653Zm.817-2.759a3.48 3.48 0 0 0-.348-1.114.5.5 0 0 0-.891.454c.126.248.21.516.248.794a.5.5 0 1 0 .991-.134Zm-1.611-2.493a3.482 3.482 0 0 0-1.08-.446.5.5 0 0 0-.22.975c.273.062.532.17.769.318a.5.5 0 1 0 .53-.847Zm-2.8-.405a3.487 3.487 0 0 0-1.055.498.5.5 0 1 0 .571.82c.23-.159.484-.28.753-.354a.5.5 0 0 0-.268-.964ZM7.35 5.973a3.48 3.48 0 0 0-.327 1.121.5.5 0 1 0 .994.115 2.48 2.48 0 0 1 .232-.8.5.5 0 1 0-.9-.436Zm-.06 2.925c.157.359.373.689.638.976a.5.5 0 1 0 .735-.678 2.503 2.503 0 0 1-.456-.698.5.5 0 1 0-.917.4Zm2.146 1.937a.5.5 0 1 1 .304-.953c.229.073.469.113.714.118a.5.5 0 0 1-.018 1 3.495 3.495 0 0 1-1-.165Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CF">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#083D96"></stop>
            <stop offset="100%" stop-color="#053380"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#37AE39"></stop>
            <stop offset="100%" stop-color="#2E9630"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD13F"></stop>
            <stop offset="100%" stop-color="#FFCD2F"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E42346"></stop>
            <stop offset="100%" stop-color="#D01739"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD03B"></stop>
            <stop offset="100%" stop-color="#FFCD2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v4H0z"></path>
          <path fill="url(#c)" d="M0 7h21v4H0z"></path>
          <path fill="url(#d)" d="M0 11h21v4H0z"></path>
          <path fill="url(#a)" d="M0 4h21v3H0z"></path>
          <path fill="url(#e)" d="M8 0h5v15H8z"></path>
          <path
            fill="url(#f)"
            d="m3.5 2.585-.882.629.326-1.033-.871-.645 1.083-.009L3.5.5l.344 1.027 1.083.009-.871.645.326 1.033z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CD">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#158AFF"></stop>
            <stop offset="100%" stop-color="#007FFF"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#CE1120"></stop>
            <stop offset="100%" stop-color="#E11B2B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M4.294 1.443h21v15h-21z" transform="translate(-4.29 -1.44)"></path>
          <path fill="#FDD216" d="m24.273 3.906-25.84 13.166-2.723-5.346L21.549-1.44z"></path>
          <path fill="url(#c)" d="M.057 7.074h29v4h-29z" transform="rotate(153 12.585 7.839)"></path>
          <path
            fill="#FDD216"
            d="m3.504 4.478-1.47 1.047.542-1.721-1.45-1.074 1.805-.016.573-1.711.573 1.711 1.804.016-1.45 1.074.542 1.721z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F33630"></stop>
            <stop offset="100%" stop-color="#DC241E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#009643"></stop>
            <stop offset="100%" stop-color="#09C15B"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FCDF4A"></stop>
            <stop offset="100%" stop-color="#FCE154"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="m6.062 19.017 15-14h1v15h-16z" transform="translate(-1.06 -5.02)"></path>
          <path fill="url(#c)" d="m1.062 19.017 15-14h1v15h-16z" transform="rotate(180 8.532 10.007)"></path>
          <path fill="url(#d)" d="M-2.629 9.667h29v5h-29z" transform="rotate(134 12.406 9.432)"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1DC87D"></stop>
            <stop offset="100%" stop-color="#169E62"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F89242"></stop>
            <stop offset="100%" stop-color="#F67F22"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A17A7"></stop>
            <stop offset="100%" stop-color="#030E88"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#c)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#c)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <path
            fill="#FFF"
            d="M15.5 5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM13 7.5a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm6 0a.5.5 0 1 1-1 0 .5.5 0 0 1 1 0Zm-5.268 1.768a.5.5 0 1 1-.707.707.5.5 0 0 1 .707-.707Zm4.243-4.243a.5.5 0 1 1-.707.707.5.5 0 0 1 .707-.707Zm-.707 4.243a.5.5 0 1 1 .707.707.5.5 0 0 1-.707-.707Zm-4.243-4.243a.5.5 0 1 1 .707.707.5.5 0 0 1-.707-.707Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFDC44"></stop>
            <stop offset="100%" stop-color="#FDD216"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#059170"></stop>
            <stop offset="100%" stop-color="#007B5E"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E21A30"></stop>
            <stop offset="100%" stop-color="#CE1126"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFDC42"></stop>
            <stop offset="100%" stop-color="#FDD217"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
          <path fill="url(#b)" d="M14 0h7v15h-7z"></path>
          <path
            fill="url(#e)"
            d="M10.5 8.475 9.031 9.523l.542-1.722-1.451-1.074 1.805-.016L10.5 5l.573 1.711 1.805.016-1.451 1.074.542 1.722z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CL">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EA3B2E"></stop>
            <stop offset="100%" stop-color="#D52B1E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0B48C2"></stop>
            <stop offset="100%" stop-color="#0239A7"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#a)" d="M0 0h21v7H0z"></path>
          <path fill="url(#c)" d="M0 0h7v7H0z"></path>
          <path
            fill="url(#a)"
            d="m3.5 4.28-1.176.838.434-1.377-1.16-.859 1.444-.013L3.5 1.5l.458 1.369 1.444.013-1.16.859.434 1.377z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CC">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#229716"></stop>
            <stop offset="100%" stop-color="#1C7E12"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFE244"></stop>
            <stop offset="100%" stop-color="#FFDF32"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#c)"
            d="M4 6a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0-2c.208 0-.16 1.054 0 1 .265-.09 1-1.328 1-1.5 0-.276-.448-.5-1-.5s-1 .224-1 .5.448.5 1 .5Zm12 9-.707.207.207-.707-.207-.707L16 12l.707-.207-.207.707.207.707zm0-9.5-.707.207L15.5 3l-.207-.707L16 2.5l.707-.207L16.5 3l.207.707zm3 3-.707.207L18.5 6l-.207-.707L19 5.5l.707-.207L19.5 6l.207.707zm-5 1-.707.207L13.5 7l-.207-.707L14 6.5l.707-.207L14.5 7l.207.707zm3.5 1.25-.354.104.104-.354-.104-.354.354.104.354-.104-.104.354.104.354zm-5.439-3.203a2.5 2.5 0 1 0 0 3.905 2.083 2.083 0 1 1 0-3.905Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CH">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="red"></stop>
            <stop offset="100%" stop-color="#FF3131"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M9 9H6.256A.255.255 0 0 1 6 8.744V6.256C6 6.115 6.114 6 6.256 6H9V3.256C9 3.115 9.114 3 9.256 3h2.488c.141 0 .256.114.256.256V6h2.744c.141 0 .256.114.256.256v2.488a.255.255 0 0 1-.256.256H12v2.744a.255.255 0 0 1-.256.256H9.256A.255.255 0 0 1 9 11.744V9Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F1361D"></stop>
            <stop offset="100%" stop-color="#DF2910"></stop>
          </linearGradient>
          <linearGradient id="c" x1="37.059%" x2="62.941%" y1="1.704%" y2="98.296%">
            <stop offset="0%" stop-color="#FFDC42"></stop>
            <stop offset="100%" stop-color="#FDD217"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFDC42"></stop>
            <stop offset="100%" stop-color="#FDD217"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#c)"
            d="m10.13 4.483-.63.383.017-.737-.383-.629.737.017.629-.383-.017.737.383.629-.737-.017ZM8.28 2.449l-.726-.123.497-.545.123-.727.545.497.727.123-.497.545-.123.727-.545-.497Zm.366 6.53-.615.404-.01-.737-.404-.615.737-.01.615-.404.01.737.404.615-.737.01Zm1.267-1.987-.732.082.327-.66-.082-.733.66.327.733-.082-.327.66.082.733-.66-.327Z"
          ></path>
          <path
            fill="url(#d)"
            d="M5 6.17 3.237 7.427l.65-2.065-1.74-1.289 2.165-.02L5 2l.688 2.053 2.165.02-1.74 1.289.65 2.065z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0748AE"></stop>
            <stop offset="100%" stop-color="#003993"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DE2035"></stop>
            <stop offset="100%" stop-color="#CE1126"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD935"></stop>
            <stop offset="100%" stop-color="#FDD216"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v4H0z"></path>
          <path fill="url(#c)" d="M0 11h21v4H0z"></path>
          <path fill="url(#d)" d="M0 0h21v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0B389F"></stop>
            <stop offset="100%" stop-color="#052E8D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E12A43"></stop>
            <stop offset="100%" stop-color="#CD1931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v3H0zm0 6h21v3H0z"></path>
          <path fill="url(#a)" d="M0 3h21v3H0z"></path>
          <path fill="url(#b)" d="M0 12h21v3H0z"></path>
          <path fill="url(#a)" d="M0 9h21v3H0z"></path>
          <path fill="url(#c)" d="m0 0 10 7.5L0 15z"></path>
          <path
            fill="url(#a)"
            d="m3.5 8.267-1.176.851.447-1.381-1.173-.855 1.451-.003L3.5 5.5l.451 1.379 1.451.003-1.173.855.447 1.381z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="EC">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0748AE"></stop>
            <stop offset="100%" stop-color="#003993"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DE2035"></stop>
            <stop offset="100%" stop-color="#CE1126"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD935"></stop>
            <stop offset="100%" stop-color="#FDD216"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FBDC44"></stop>
            <stop offset="100%" stop-color="#FFDC32"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v4H0z"></path>
          <path fill="url(#c)" d="M0 11h21v4H0z"></path>
          <path fill="url(#d)" d="M0 0h21v7H0z"></path>
          <path fill="url(#e)" d="M9.3 6a2 2 0 1 0 2.4 0L11 8.1h-1L9.3 6Z"></path>
          <path fill="#5FC0DC" d="M10.5 5.5 11 8h-1z"></path>
          <path
            fill="#3F2821"
            fill-rule="nonzero"
            d="M9.677 3.823a.25.25 0 0 0-.256-.06l-1.5.5a.25.25 0 1 0 .158.474l1.353-.451.891.89a.25.25 0 0 0 .354 0l.89-.89 1.354.451a.25.25 0 1 0 .158-.474l-1.5-.5a.25.25 0 0 0-.256.06l-.823.823-.823-.823Z"
            opacity=".66"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CV">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0C49AE"></stop>
            <stop offset="100%" stop-color="#063B91"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#CD232E"></stop>
            <stop offset="100%" stop-color="#CD232E"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v8H0zm0 11h21v4H0z"></path>
          <path fill="url(#a)" d="M0 8h21v3H0z"></path>
          <path fill="url(#c)" d="M0 9h21v1H0z"></path>
          <path
            fill="#F7D035"
            fill-rule="nonzero"
            d="M8 13a.5.5 0 1 1 0-1c.284 0 .56-.047.822-.138a.5.5 0 0 1 .329.944A3.495 3.495 0 0 1 8 13Zm2.651-1.215a3.5 3.5 0 0 0 .605-.998.5.5 0 0 0-.93-.368 2.5 2.5 0 0 1-.432.713.5.5 0 0 0 .757.653Zm.817-2.759a3.48 3.48 0 0 0-.348-1.114.5.5 0 0 0-.891.454c.126.248.21.516.248.794a.5.5 0 1 0 .991-.134ZM9.857 6.533a3.482 3.482 0 0 0-1.08-.446.5.5 0 1 0-.22.975c.273.062.532.17.769.318a.5.5 0 1 0 .53-.847Zm-2.8-.405a3.487 3.487 0 0 0-1.055.498.5.5 0 1 0 .571.82c.23-.159.484-.28.753-.354a.5.5 0 1 0-.268-.964ZM4.85 7.973a3.48 3.48 0 0 0-.327 1.121.5.5 0 1 0 .994.115 2.48 2.48 0 0 1 .232-.8.5.5 0 1 0-.9-.436Zm-.06 2.925c.157.359.373.689.638.976a.5.5 0 1 0 .735-.678 2.503 2.503 0 0 1-.456-.698.5.5 0 1 0-.917.4Zm2.146 1.937a.5.5 0 1 1 .304-.953c.229.073.469.113.714.118a.5.5 0 0 1-.018 1 3.495 3.495 0 0 1-1-.165Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="DE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F01515"></stop>
            <stop offset="100%" stop-color="#DE0000"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD521"></stop>
            <stop offset="100%" stop-color="#FFCF00"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="M0 10h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="DM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#108753"></stop>
            <stop offset="100%" stop-color="#0B6B41"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FCD449"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E02C42"></stop>
            <stop offset="100%" stop-color="#D22036"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v6H0zm0 9h21v6H0z"></path>
          <path fill="url(#a)" d="M9 6H0v3h9v6h3V9h9V6h-9V0H9v6Z"></path>
          <path fill="url(#c)" d="M10 8v7h1V8h10V7H11V0h-1v7H0v1h10Z"></path>
          <path fill="url(#d)" d="M9 7v8h1V7h11V6H10V0H9v6H0v1h9Z"></path>
          <circle cx="10.5" cy="7.5" r="3.5" fill="url(#e)"></circle>
          <path
            fill="#0E673F"
            fill-rule="nonzero"
            d="M10.5 10.5a.5.5 0 1 1 0-1c.274 0 .538-.055.784-.16a.5.5 0 1 1 .392.92 2.98 2.98 0 0 1-1.176.24Zm2.816-1.965a2.993 2.993 0 0 0 .177-1.242.5.5 0 1 0-.998.068 1.983 1.983 0 0 1-.117.83.5.5 0 1 0 .938.344Zm-.95-3.383a2.992 2.992 0 0 0-1.07-.545.5.5 0 0 0-.264.964c.26.072.502.195.712.363a.5.5 0 1 0 .623-.782Zm-3.422-.217c-.345.21-.645.487-.88.814a.5.5 0 1 0 .811.584c.158-.218.358-.404.588-.544a.5.5 0 0 0-.52-.854ZM7.564 8.12c.084.397.247.771.479 1.101a.5.5 0 0 0 .818-.574 1.987 1.987 0 0 1-.318-.733.5.5 0 1 0-.979.206Zm2.54 2.354a.5.5 0 1 1 .132-.991c.08.01.163.016.245.017a.5.5 0 1 1-.009 1 3.021 3.021 0 0 1-.367-.026Z"
          ></path>
          <path fill="#0E673F" d="M10.5 8.5c.552 0 .5-.448.5-1s.052-1-.5-1-.5.448-.5 1-.052 1 .5 1Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ET">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#20AA46"></stop>
            <stop offset="100%" stop-color="#168835"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E92F3B"></stop>
            <stop offset="100%" stop-color="#D81824"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FADF50"></stop>
            <stop offset="100%" stop-color="#FCDC34"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#205CCA"></stop>
            <stop offset="100%" stop-color="#154BAD"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFDB3D"></stop>
            <stop offset="100%" stop-color="#FDD420"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#d)" d="M0 5h21v5H0z"></path>
          <circle cx="10.5" cy="7.5" r="3.5" fill="url(#e)"></circle>
          <path
            fill="url(#f)"
            fill-rule="nonzero"
            d="M10.5 8.475 9.03 9.523 9.574 7.8l-1.45-1.074 1.804-.016L10.5 5l.573 1.711 1.805.016-1.45 1.074.541 1.722L10.5 8.475Zm0-.614.544.388-.2-.637.536-.398-.668-.006-.212-.634-.212.634-.668.006.537.398-.201.637.544-.388Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#06358F"></stop>
            <stop offset="100%" stop-color="#042E7D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E61F37"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v3H0zm0 12h21v3H0z"></path>
          <path fill="url(#a)" d="M0 3h21v9H0z"></path>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CX">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0637C5"></stop>
            <stop offset="100%" stop-color="#002CAA"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#3BA758"></stop>
            <stop offset="100%" stop-color="#2C8945"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFCC5D"></stop>
            <stop offset="100%" stop-color="#FEC54A"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="#FFF"
            d="m4 13-.707.207.207-.707-.207-.707L4 12l.707-.207-.207.707.207.707zm0-7.5-.707.207L3.5 5l-.207-.707L4 4.5l.707-.207L4.5 5l.207.707zm2 3-.707.207L5.5 8l-.207-.707L6 7.5l.707-.207L6.5 8l.207.707zm-4 1-.707.207L1.5 9l-.207-.707L2 8.5l.707-.207L2.5 9l.207.707zm3.5 1.25-.354.104.104-.354-.104-.354.354.104.354-.104-.104.354.104.354z"
          ></path>
          <path
            fill="url(#c)"
            d="m0 15 8.92-6.372s1.983 1.025 2.74.484c.758-.54.348-2.689.348-2.689L21 0H0v15Z"
            transform="matrix(-1 0 0 1 21 0)"
          ></path>
          <path
            fill="url(#d)"
            d="M14.46 7.5s2.415-.4 2.703-1.527c.288-1.127-2.298-1.934-2.4-2.34-.102-.405.95-.117 1.415 0 .451.115 1.333.696 1.333.696s-.01-.8-.131-1.17c-.202-.62-.836-1.802-.836-1.802s1.075.69 1.536 1.24c.265.315.364 1.738.69 2.226.584.872 1.948-.102 1.369.823-.58.924-1.911 1.05-2.976 1.455-.965.367-3.115.86-3.115.86l.413-.461ZM10.5 10a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5ZM9.258 7.5 9 8s.84-.19 1.123 0c.384.256.377 1 .377 1h.5s-.164-.73.093-1.243C11.35 7.244 12 7 12 7V6s-.681.727-1.5 1S9 7 9 7l.258.5Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E8252A"></stop>
            <stop offset="100%" stop-color="#D7151A"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#17579E"></stop>
            <stop offset="100%" stop-color="#10457F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#a)" d="M0 0h21v7H0z"></path>
          <path fill="url(#c)" d="m0 0 10 7.5L0 15z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="EG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E41D33"></stop>
            <stop offset="100%" stop-color="#CE1126"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="#F4B32E"
            fill-opacity=".25"
            d="M8 6.495C8 6.222 8.232 6 8.5 6h.248c.139 0 .298.092.368.232L9.5 7s.55-1 1-1c.5 0 1 1 1 1l.384-.768A.445.445 0 0 1 12.252 6h.248c.276 0 .5.216.5.495v2.01c0 .273-.184.372-.41.222L11.5 8H11v.5c0 .276-.232.5-.5.5a.505.505 0 0 1-.5-.5V8h-.5l-1.09.727c-.226.15-.41.057-.41-.222v-2.01Z"
          ></path>
          <path
            fill="#C6A846"
            fill-rule="nonzero"
            d="M12.5 8.066V6.5h-.191l-.54 1.079.731.487ZM8.691 6.5h-.19L8.5 6.495v1.57l.73-.486L8.691 6.5Zm1.809 1v1-1h.691l-.138-.276c-.05-.1-.146-.265-.266-.424-.12-.16-.23-.26-.271-.29a1.387 1.387 0 0 0-.29.296c-.126.163-.23.33-.288.435l-.142.259h.704Zm.874-.724c.08.13.126.224.126.224l.112-.224s.231-.195.157-.313l.115-.231A.445.445 0 0 1 12.252 6h.248c.276 0 .5.216.5.495v2.01c0 .273-.184.372-.41.222L11.5 8H11v.5c0 .276-.232.5-.5.5a.505.505 0 0 1-.5-.5V8h-.5l-1.09.727c-.226.15-.41.057-.41-.222v-2.01C8 6.222 8.232 6 8.5 6h.248c.139 0 .298.092.368.232l.12.24c-.071.108.147.293.147.293L9.5 7s.053-.097.14-.23l.178-.253c.195-.255.451-.517.682-.517.25 0 .502.252.69.503l.184.273Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="DK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EF264D"></stop>
            <stop offset="100%" stop-color="#E1143C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="FK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07319C"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1F8BDE"></stop>
            <stop offset="100%" stop-color="#1075C2"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#187536"></stop>
            <stop offset="100%" stop-color="#0E5023"></stop>
          </linearGradient>
          <linearGradient id="i" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <path
            id="c"
            d="M0 3.5V.51C0 .228.215 0 .498 0h4.004C4.777 0 5 .227 5 .51V3.5C5 6 2.5 7 2.5 7S0 6 0 3.5Z"
          ></path>
          <path
            id="h"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <g transform="translate(13 4)">
            <mask id="f" fill="#fff">
              <use xlink:href="#c"></use>
            </mask>
            <use xlink:href="#c" fill="url(#d)"></use>
            <path
              fill="url(#e)"
              fill-rule="nonzero"
              d="M0 3.5V.51C0 .228.215 0 .498 0h4.004C4.777 0 5 .227 5 .51V3.5C5 6 2.5 7 2.5 7S0 6 0 3.5Zm2.644 2.87c.263-.15.527-.334.772-.554C4.099 5.2 4.5 4.439 4.5 3.5V.51C4.5.5.499.5.499.5l.001 3c0 .939.401 1.701 1.084 2.316a4.398 4.398 0 0 0 .916.632c.043-.022.091-.048.144-.078Z"
              mask="url(#f)"
            ></path>
            <path
              fill="url(#g)"
              d="M1.158 3.475C1.071 3.212 1.216 3 1.495 3h2.01c.273 0 .425.209.337.475l-.184.55c-.087.263-.295.306-.524.133 0 0 .088-.158-.634-.158s-.634.158-.634.158c-.202.189-.436.133-.524-.133l-.184-.55Z"
              mask="url(#f)"
            ></path>
            <path
              fill="url(#a)"
              d="M1.5 3c.27.054.59-.5 1-.5.437 0 .726.567 1 .5.246-.06.5-.739.5-1 0-.552-.672-1-1.5-1S1 1.448 1 2c0 .28.223.945.5 1Z"
              mask="url(#f)"
            ></path>
            <path
              fill="url(#a)"
              fill-rule="nonzero"
              d="m-.323 6.177.35-.35.3-.3a.244.244 0 0 1 .346 0l.3.3a.746.746 0 0 0 1.054 0l.3-.3a.244.244 0 0 1 .346 0l.3.3a.746.746 0 0 0 1.054 0l.3-.3a.244.244 0 0 1 .346 0l.3.3.177.177.354-.354-.177-.177-.3-.3a.744.744 0 0 0-1.054 0l-.3.3a.244.244 0 0 1-.346 0l-.3-.3a.744.744 0 0 0-1.054 0l-.3.3a.244.244 0 0 1-.346 0l-.3-.3a.744.744 0 0 0-1.054 0l-.3.3-.35.35L-.854 6l.354.354.177-.177Zm0-1.5.35-.35.3-.3a.244.244 0 0 1 .346 0l.3.3a.746.746 0 0 0 1.054 0l.3-.3a.244.244 0 0 1 .346 0l.3.3a.746.746 0 0 0 1.054 0l.3-.3a.244.244 0 0 1 .346 0l.3.3.177.177.354-.354-.177-.177-.3-.3a.744.744 0 0 0-1.054 0l-.3.3a.244.244 0 0 1-.346 0l-.3-.3a.744.744 0 0 0-1.054 0l-.3.3a.244.244 0 0 1-.346 0l-.3-.3a.744.744 0 0 0-1.054 0l-.3.3-.35.35-.177.177.354.354.177-.177Zm0 3 .35-.35.3-.3a.244.244 0 0 1 .346 0l.3.3a.746.746 0 0 0 1.054 0l.3-.3a.244.244 0 0 1 .346 0l.3.3a.746.746 0 0 0 1.054 0l.3-.3a.244.244 0 0 1 .346 0l.3.3.177.177.354-.354-.177-.177-.3-.3a.744.744 0 0 0-1.054 0l-.3.3a.244.244 0 0 1-.346 0l-.3-.3a.744.744 0 0 0-1.054 0l-.3.3a.244.244 0 0 1-.346 0l-.3-.3a.744.744 0 0 0-1.054 0l-.3.3-.35.35-.177.177.354.354.177-.177Z"
              mask="url(#f)"
            ></path>
          </g>
          <use xlink:href="#h" fill="url(#i)"></use>
          <path
            stroke="#FFF"
            stroke-width=".5"
            d="M3.25 3.115-.676-.25H.5l.145.047L4.08 2.25h.848L9.25-.451V.25c0 .222-.128.47-.313.602L5.75 3.13v.756L8.975 6.65c.282.242.138.601-.225.601-.193 0-.442-.08-.604-.195L4.92 4.75h-.848L-.25 7.451v-1.08l3.5-2.5v-.756Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#i)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="EU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#043CAE"></stop>
            <stop offset="100%" stop-color="#00339A"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD429"></stop>
            <stop offset="100%" stop-color="#FC0"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#c)"
            d="m10.5 3-.707.207L10 2.5l-.207-.707L10.5 2l.707-.207L11 2.5l.207.707L10.5 3Zm0 10-.707.207L10 12.5l-.207-.707.707.207.707-.207L11 12.5l.207.707L10.5 13Zm5-5-.707.207L15 7.5l-.207-.707L15.5 7l.707-.207L16 7.5l.207.707L15.5 8Zm-10 0-.707.207L5 7.5l-.207-.707L5.5 7l.707-.207L6 7.5l.207.707L5.5 8Zm9.33-2.5-.707.207L14.33 5l-.207-.707.707.207.707-.207L15.33 5l.207.707-.707-.207Zm-8.66 5-.707.207L5.67 10l-.207-.707.707.207.707-.207L6.67 10l.207.707-.707-.207ZM13 3.67l-.707.207.207-.707-.207-.707.707.207.707-.207-.207.707.207.707L13 3.67Zm-5 8.66-.707.207.207-.707-.207-.707.707.207.707-.207-.207.707.207.707L8 12.33Zm6.83-1.83-.707.207.207-.707-.207-.707.707.207.707-.207-.207.707.207.707-.707-.207Zm-8.66-5-.707.207L5.67 5l-.207-.707.707.207.707-.207L6.67 5l.207.707L6.17 5.5ZM13 12.33l-.707.207.207-.707-.207-.707.707.207.707-.207-.207.707.207.707L13 12.33ZM8 3.67l-.707.207.207-.707-.207-.707L8 2.67l.707-.207-.207.707.207.707L8 3.67Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="DO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#083D7A"></stop>
            <stop offset="100%" stop-color="#032F61"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DF1E35"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h9v6H0zm12 9h9v6h-9z"></path>
          <path fill="url(#c)" d="M0 9h9v6H0zm12-9h9v6h-9z"></path>
          <path fill="url(#a)" d="M9 6H0v3h9v6h3V9h9V6h-9V0H9v6Z"></path>
          <path fill="#C93127" fill-opacity=".2" d="M9.44 6.44a1.5 1.5 0 0 0 2.12 2.12 1.5 1.5 0 0 0 0-2.12"></path>
          <circle cx="10.5" cy="7.5" r="1" fill="#042F60"></circle>
          <path
            fill="#0F6D1A"
            fill-rule="nonzero"
            d="M11.56 8.56a1.5 1.5 0 0 1-2.12-2.12l.353.353a1 1 0 1 0 1.414 0l.354-.354a1.5 1.5 0 0 1 0 2.122Zm0 0a1.5 1.5 0 0 1-2.12-2.12l.353.353a1 1 0 1 0 1.414 0l.354-.354a1.5 1.5 0 0 1 0 2.122Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="GD">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E42235"></stop>
            <stop offset="100%" stop-color="#CE1225"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#079B77"></stop>
            <stop offset="100%" stop-color="#007B5D"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD938"></stop>
            <stop offset="100%" stop-color="#FDD117"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD93B"></stop>
            <stop offset="100%" stop-color="#FDD117"></stop>
          </linearGradient>
          <linearGradient id="h" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E21C30"></stop>
            <stop offset="100%" stop-color="#CE1225"></stop>
          </linearGradient>
          <path id="c" d="M0 0h17v11H0z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <g transform="translate(2 2)">
            <mask id="f" fill="#fff">
              <use xlink:href="#c"></use>
            </mask>
            <use xlink:href="#c" fill="url(#d)"></use>
            <path
              fill="url(#e)"
              d="M1.295 5.599c.283.453.69.752 1.068.829.209.042-.173-.914-.007-1.018.142-.088.825.706.885.54.137-.38.056-.921-.25-1.411-.439-.703-.456-.239-1.643-.742.124.72-.492 1.1-.053 1.802Z"
              mask="url(#f)"
            ></path>
            <path fill="url(#g)" d="M0 0h17L8.5 5.5 0 0Zm0 11 8.5-5.5L17 11H0Z" mask="url(#f)"></path>
            <circle cx="8.5" cy="5.5" r="2.5" fill="url(#h)" mask="url(#f)"></circle>
            <path
              fill="url(#e)"
              d="m8.5 6.271-1.176.847.442-1.38-1.168-.856 1.449-.006L8.5 3.5l.453 1.376 1.449.006-1.168.856.442 1.38z"
              mask="url(#f)"
            ></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="FI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0848A6"></stop>
            <stop offset="100%" stop-color="#003480"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="EE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#5DA8F1"></stop>
            <stop offset="100%" stop-color="#4892DA"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#a)" d="M0 10h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ES">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DD172C"></stop>
            <stop offset="100%" stop-color="#C60B1F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD133"></stop>
            <stop offset="100%" stop-color="#FFC500"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v4H0zm0 11h21v4H0z"></path>
          <path fill="url(#c)" d="M0 4h21v7H0z"></path>
          <path fill="#FFEDB1" d="M5.5 7h1v.5h-1z"></path>
          <path
            fill="#A41517"
            fill-rule="nonzero"
            d="M4.915 8.46c.025.295.291.54.585.54s.56-.246.585-.54L6.207 7H4.793l.122 1.46Zm-.624-1.465a.456.456 0 0 1 .465-.495h1.488a.45.45 0 0 1 .465.495l-.126 1.506A1.104 1.104 0 0 1 5.5 9.5a1.104 1.104 0 0 1-1.083-.999L4.29 6.995Z"
          ></path>
          <path
            fill="#A41517"
            d="M4.5 7.5h2V8H6l-.5 1L5 8h-.5zM3 6h1v3.5H3zm4 0h1v3.5H7zm-2.5-.5c0-.276.214-.5.505-.5h.99c.279 0 .505.232.505.5v.248A.248.248 0 0 1 6.255 6h-1.51a.245.245 0 0 1-.245-.252V5.5Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GB-ENG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E82739"></stop>
            <stop offset="100%" stop-color="#CA1A2B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M9 6H0v3h9v6h3V9h9V6h-9V0H9v6Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0543A8"></stop>
            <stop offset="100%" stop-color="#00307D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FCC747"></stop>
            <stop offset="100%" stop-color="#FEC539"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 10h21v2H0z"></path>
          <path
            fill="url(#a)"
            d="m6.5 6.267-1.176.851.447-1.381-1.173-.855 1.451-.003L6.5 3.5l.451 1.379 1.451.003-1.173.855.447 1.381zM3 3.575l-.882.639.335-1.036-.88-.642 1.089-.001L3 1.5l.338 1.035 1.089.001-.88.642.335 1.036z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="FM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#95CEF5"></stop>
            <stop offset="100%" stop-color="#78B3DC"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="m10.5 4.32-1.176.798.396-1.365-1.122-.871 1.42-.045L10.5 1.5l.482 1.337 1.42.045-1.122.871.396 1.365L10.5 4.32Zm0 8-1.176.798.396-1.365-1.122-.871 1.42-.045L10.5 9.5l.482 1.337 1.42.045-1.122.871.396 1.365-1.176-.798Zm4-4-1.176.798.396-1.365-1.122-.871 1.42-.045L14.5 5.5l.482 1.337 1.42.045-1.122.871.396 1.365L14.5 8.32Zm-8 0-1.176.798.396-1.365-1.122-.871 1.42-.045L6.5 5.5l.482 1.337 1.42.045-1.122.871.396 1.365L6.5 8.32Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GB-SCT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1479D0"></stop>
            <stop offset="100%" stop-color="#0A68BA"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0-.003h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M10.5 6.291-.962-1.44-2.08.218l10.792 7.28-10.792 7.279 1.118 1.658L10.5 8.704l11.462 7.73 1.118-1.657-10.791-7.28L23.08.218 21.962-1.44 10.5 6.291Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="CY">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E7832C"></stop>
            <stop offset="100%" stop-color="#D7751F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#b)"
            d="M15.547 2.227c.25-.126.33-.043.18.183l-.454.68c-.15.226-.457.533-.683.683l-.68.454c-.226.15-.568.431-.763.626l.206-.206a.496.496 0 0 0-.003.703l.3.3a.494.494 0 0 1 0 .7l-.3.3a.729.729 0 0 1-.803.123l-.094-.046a.5.5 0 0 0-.68.226l-.046.094c-.126.25-.436.523-.702.611l-.55.184A3.743 3.743 0 0 1 9.5 8a.876.876 0 0 0-.727.453l-.046.094a.502.502 0 0 1-.67.231l-1.113-.556a3.651 3.651 0 0 1-.794-.572l-.3-.3a1.4 1.4 0 0 1-.35-.85c0-.276.227-.5.5-.5h-.5c.276 0 .656-.156.85-.35l.3-.3A1.4 1.4 0 0 1 7.5 5c.276 0 .57-.209.658-.475l.184-.55a.574.574 0 0 1 .64-.379l1.536.308c.266.053.696.042.966-.025l1.032-.258a5.4 5.4 0 0 0 .937-.348l.094-.046.906-.454.094-.046.906-.454.094-.046Z"
          ></path>
          <circle cx="10.5" cy="11.5" r="1" fill="#445128"></circle>
          <path
            fill="#445128"
            fill-rule="nonzero"
            d="M12.158 11.474a.5.5 0 1 1-.316-.948 4.528 4.528 0 0 0 .96-.482c.354-.236.615-.497.75-.768a.5.5 0 1 1 .895.448c-.224.449-.603.828-1.09 1.152a5.512 5.512 0 0 1-1.199.598Zm-3-.948a.5.5 0 1 1-.316.948 5.512 5.512 0 0 1-1.2-.598c-.486-.324-.865-.703-1.09-1.152a.5.5 0 0 1 .895-.448c.136.271.397.532.75.768a4.528 4.528 0 0 0 .961.482Z"
            opacity=".75"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F33349"></stop>
            <stop offset="100%" stop-color="#E51D34"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FCE24C"></stop>
            <stop offset="100%" stop-color="#F9DC38"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M9 6H0v3h9v6h3V9h9V6h-9V0H9v6Z"></path>
          <path fill="url(#c)" d="M10 8v4l-.5 1h2l-.5-1V8h4l1 .5v-2L15 7h-4V3l.5-1h-2l.5 1v4H6l-1-.5v2L6 8h4Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GB-WLS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#3ACC55"></stop>
            <stop offset="100%" stop-color="#28A940"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E91C44"></stop>
            <stop offset="100%" stop-color="#D20F35"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#a)" d="M0 0h21v7H0z"></path>
          <path
            fill="url(#c)"
            d="m8.066 11.396 1.236-.21-.957-.452.655-.367s1.104.932 1.104.633c0-.32 1.038-.18.996-.633-.057-.62-1.149-.046-1.344-.82-.109-.432-.454-.377-.454-.377l-1.1.377-.547.82-.272-.82s-.642.522-.855.82c-.228.318-.47 1.029-.47 1.029l1.122.469-1.636-.289-1.194.289-.732.203.322-.338-.657-.334L3.94 11l-.322-.266L5.036 11s.518-.052.714-.266c.247-.27.44-1.187.44-1.187l-.646-.377-.508.921s-.35-.871-.686-1.36c-.249-.364-1.067-1.197-1.067-1.197L2.23 8.09l.588-1.173s.466-.407.17-.825c-.296-.418-.545-1.353-.545-1.353s.618 1.071.841.988c.317-.117-.394-1.094 0-1.268.284-.126.335 1.12.335 1.12l.322-.611v.76s-.187.907.13 1.446c.318.54 1.26.916 1.26.916s-.244-.541 0-1.58c.167-.703.757-1.903 1.035-2.287.146-.204-1.172.745-1.172.745v-.745l-1.254-.13-.322.365-.801-1.314.996.501h1.518l-.295-.362H3.813s.257-.53 1.518-.53l.596-.404s.815.023 1.274.04c.408.016 1.144-.502 1.144-.502l.207.502-.486.755.486.501-.207.31.357.503h-.636l.486.783-.486-.274.28.76-.28.782 1.236-.418s0-1.124.454-1.633c1.386-1.422 3.645-2.571 3.645-2.571s-.12 1.032.215 1.113c.485.118 2.605-.85 2.605-.85s-1.274 1.37-1.013 1.495c.14.067.374.31.374.31s-1.1.899-1.285 1.286c-.184.387.27.85.27.85s-.951 0-1.425.418c1.425 0 2.59.675 3.28.177.463-.334-1.655-.126-1.377-.96.103-.31.373-.668.99-.76.617-.09.835.275.835.275l.333-.503h-.982L18 3l.232 2.241-.602-.503-.27.84C18 7.534 15.045 7.95 15.045 7.95l1.825 1.22-.65.186-.185 1.83.835.679-1.098-.289-2.156.492.429-.672-.903.18.603-.576-.603-.266.77-.214.972.665s.48-.622.534-.952c.054-.341-.21-1.063-.21-1.063s-1.43-.03-1.935-.155a1.539 1.539 0 0 1-.797-.522l-.573.677s1.997.748 1.498 1.063c-.116.073-.687-.142-.687-.142s-.984 1.15-1.614 1.305c-.286.07.803.469.803.469s-.93-.148-1.403-.289c-.495-.147-1.948.289-1.948.289l-.486-.47Zm8.02-5.343a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GH">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E71F37"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#118B56"></stop>
            <stop offset="100%" stop-color="#0B6B41"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FDD64C"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#d)" d="M0 5h21v5H0z"></path>
          <path
            fill="url(#e)"
            d="M10.5 8.709 9.031 9.773l.557-1.727-1.466-1.069 1.814-.003.564-1.724.564 1.724 1.814.003-1.466 1.069.557 1.727z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF2B37"></stop>
            <stop offset="100%" stop-color="#FD0D1B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M9 6H0v3h9v6h3V9h9V6h-9V0H9v6Z"></path>
          <path
            fill="#FD0D1B"
            d="M16.2 2.7 16 1.5h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2Zm-12 0L4 1.5h1l-.2 1.2L6 2.5v1l-1.2-.2.2 1.2H4l.2-1.2-1.2.2v-1l1.2.2Zm0 9L4 10.5h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2H4l.2-1.2-1.2.2v-1l1.2.2Zm12 0-.2-1.2h1l-.2 1.2 1.2-.2v1l-1.2-.2.2 1.2h-1l.2-1.2-1.2.2v-1l1.2.2Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#09B470"></stop>
            <stop offset="100%" stop-color="#019F60"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#508CDE"></stop>
            <stop offset="100%" stop-color="#3A75C5"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD935"></stop>
            <stop offset="100%" stop-color="#FDD216"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#d)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GF">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2DA446"></stop>
            <stop offset="100%" stop-color="#218736"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFE24A"></stop>
            <stop offset="100%" stop-color="#FCDC34"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E7242C"></stop>
            <stop offset="100%" stop-color="#D61C24"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="m0 0 21 15H0z"></path>
          <path
            fill="url(#d)"
            d="m10.5 9.073-1.837 1.33.697-2.158-1.832-1.336 2.268-.004.704-2.155.704 2.155 2.268.004-1.832 1.336.697 2.158z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E71924"></stop>
            <stop offset="100%" stop-color="#D6101B"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EA1824"></stop>
            <stop offset="100%" stop-color="#D6101B"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#ECCE3E"></stop>
            <stop offset="100%" stop-color="#D9BC2D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 0h21v10H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path
            fill="url(#c)"
            d="M9 6H8V4.49A.495.495 0 0 0 7.495 4h-.99A.49.49 0 0 0 6 4.49V8L5 9h11l-1-1V4.49a.495.495 0 0 0-.505-.49h-.99a.49.49 0 0 0-.505.49V6h-1V3.49a.49.49 0 0 0-.495-.49h-2.01A.49.49 0 0 0 9 3.49V6Z"
          ></path>
          <path
            fill="url(#d)"
            d="M7 8a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0-2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm3.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0-3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM14 8a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0-2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
          <path
            fill="url(#e)"
            d="M10 9.943V12H9v1h2V9.943c.583-.137 1-.508 1-.943 0-.552-.672-1-1.5-1S9 8.448 9 9c0 .435.417.806 1 .943Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="FJ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#79CFF6"></stop>
            <stop offset="100%" stop-color="#68BFE6"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#042C90"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EB1D43"></stop>
            <stop offset="100%" stop-color="#D21034"></stop>
          </linearGradient>
          <linearGradient id="h" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <path id="d" d="M0 3.5V0h5v3.5C5 6 2.5 7 2.5 7S0 6 0 3.5Z"></path>
          <path
            id="g"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 0h9v7H0z"></path>
          <g transform="translate(13 4)">
            <mask id="e" fill="#fff">
              <use xlink:href="#d"></use>
            </mask>
            <use xlink:href="#d" fill="url(#a)"></use>
            <path
              fill="#2A915C"
              d="M1 2.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm3 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
              mask="url(#e)"
            ></path>
            <path fill="url(#f)" d="M0 0h5v1H3v2h2v1H3v3H2V4H0V3h2V1H0z" mask="url(#e)"></path>
          </g>
          <use xlink:href="#g" fill="url(#h)"></use>
          <path
            stroke="#FFF"
            stroke-width=".5"
            d="M3.25 3.115-.676-.25H.5l.145.047L4.08 2.25h.848L9.25-.451V.25c0 .222-.128.47-.313.602L5.75 3.13v.756L8.975 6.65c.282.242.138.601-.225.601-.193 0-.442-.08-.604-.195L4.92 4.75h-.848L-.25 7.451v-1.08l3.5-2.5v-.756Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#h)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="FO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1879D6"></stop>
            <stop offset="100%" stop-color="#0F67BB"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F13E4F"></stop>
            <stop offset="100%" stop-color="#EB2D3F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
          <path fill="url(#c)" d="M0 8h7v7h1V8h13V7H8V0H7v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="FR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F44653"></stop>
            <stop offset="100%" stop-color="#EE2A39"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1035BB"></stop>
            <stop offset="100%" stop-color="#042396"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="DZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#048345"></stop>
            <stop offset="100%" stop-color="#04753E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E81B42"></stop>
            <stop offset="100%" stop-color="#D20F34"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h11v15H0z"></path>
          <path fill="url(#a)" d="M11 0h10v15H11z"></path>
          <path
            fill="url(#c)"
            d="m13 8.28-1.176.838.434-1.377-1.16-.859 1.444-.013L13 5.5l.458 1.369 1.444.013-1.16.859.434 1.377z"
          ></path>
          <path
            fill="url(#c)"
            d="M13.26 4.214A4.204 4.204 0 0 0 10.313 3C7.931 3 6 5.015 6 7.5S7.931 12 10.313 12c1.14 0 2.176-.461 2.947-1.214a4.112 4.112 0 0 1-1.77.396c-2.166 0-3.922-1.649-3.922-3.682s1.756-3.682 3.921-3.682c.638 0 1.24.143 1.771.396Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="HN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0884E6"></stop>
            <stop offset="100%" stop-color="#0074D0"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0E88E9"></stop>
            <stop offset="100%" stop-color="#0074D0"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0zm0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="url(#c)"
            d="m10.5 8-.707.207L10 7.5l-.207-.707L10.5 7l.707-.207L11 7.5l.207.707zm4-1-.707.207L14 6.5l-.207-.707L14.5 6l.707-.207L15 6.5l.207.707zm0 2-.707.207L14 8.5l-.207-.707L14.5 8l.707-.207L15 8.5l.207.707zm-8 0-.707.207L6 8.5l-.207-.707L6.5 8l.707-.207L7 8.5l.207.707zm0-2-.707.207L6 6.5l-.207-.707L6.5 6l.707-.207L7 6.5l.207.707z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="DJ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1DC837"></stop>
            <stop offset="100%" stop-color="#13AD2B"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#82C5F5"></stop>
            <stop offset="100%" stop-color="#6AB3E8"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E21C21"></stop>
            <stop offset="100%" stop-color="#D7151A"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#c)" d="M0 0h21v7H0z"></path>
          <path fill="url(#a)" d="m0 0 10 7.5L0 15z"></path>
          <path
            fill="url(#d)"
            d="M3.5 8.475 2.031 9.523l.542-1.722-1.451-1.074 1.805-.016L3.5 5l.573 1.711 1.805.016-1.451 1.074.542 1.722z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1C6DC1"></stop>
            <stop offset="100%" stop-color="#1660AD"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#b)"
            d="M0 0h4v4H0V0Zm6 0h4v4H6V0Zm4 0h11v2H10V0Zm0 4h11v2H10V4Zm0 4h11v2H10V8ZM0 12h21v2H0v-2Zm6-6h4v4H6V6ZM0 6h4v4H0V6Z"
          ></path>
        </g>
      </symbol>
      <symbol
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 21 15"
        id="GB-NIR"
      >
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E82739"></stop>
            <stop offset="100%" stop-color="#CA1A2B"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E6101E"></stop>
            <stop offset="100%" stop-color="#CA0814"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD148"></stop>
            <stop offset="100%" stop-color="#FFCB2F"></stop>
          </linearGradient>
          <path
            id="d"
            d="M9 3.75 10 4l.5-.5.5.5 1-.25-.404 1.009a.4.4 0 0 1-.341.241h-1.51a.39.39 0 0 1-.341-.241L9 3.75ZM10.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M9 6H0v3h9v6h3V9h9V6h-9V0H9v6Z"></path>
          <path
            fill="url(#a)"
            d="M11.516 9.261 10.5 11 9.484 9.261 7.469 9.25l.998-1.75-.998-1.75 2.015-.011L10.5 4l1.016 1.739 2.015.011-.998 1.75.998 1.75z"
          ></path>
          <path
            fill="url(#c)"
            d="M9.55 7.006a.656.656 0 0 1 .425-.664l.55-.184c.263-.087.475.063.475.35V7.5s.321-1.037.5-.5c.179.537-.128 1.526-.128 1.526a.671.671 0 0 1-.63.474h-.484a.577.577 0 0 1-.559-.506l-.148-1.488Z"
          ></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M10.5 2.908c-.511 0-.967.304-1.168.763l-.1.229.457.201.1-.229a.775.775 0 0 1 1.418-.005l.102.228.456-.205-.102-.228a1.275 1.275 0 0 0-1.164-.754Z"
          ></path>
          <mask id="f" fill="#fff">
            <use xlink:href="#d"></use>
          </mask>
          <use xlink:href="#d" fill="url(#e)"></use>
          <circle cx="10.5" cy="4.5" r="1" fill="#5169E2" mask="url(#f)"></circle>
          <circle cx="11.5" cy="4.5" r="1" fill="#D34D43" mask="url(#f)"></circle>
          <circle cx="9.5" cy="4.5" r="1" fill="#D34D43" mask="url(#f)"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="GL">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E82245"></stop>
            <stop offset="100%" stop-color="#CC1838"></stop>
          </linearGradient>
          <filter id="c" width="107.1%" height="118.8%" x="-3.6%" y="-9.4%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius=".25" result="shadowSpreadOuter1"></feMorphology>
            <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <path id="b" d="M0 0h21v8H0z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <use xlink:href="#b" fill="#000" filter="url(#c)"></use>
          <use xlink:href="#b" fill="url(#a)"></use>
          <path fill="url(#d)" d="M3 8H0v7h21V8H11a4 4 0 1 0-8 0Z"></path>
          <path fill="url(#a)" d="M3 8a4 4 0 1 0 8 0H3Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GP">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#25A057"></stop>
            <stop offset="100%" stop-color="#1C8245"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#31B8F4"></stop>
            <stop offset="100%" stop-color="#1EA2DC"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFE149"></stop>
            <stop offset="100%" stop-color="#FFDD32"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <g transform="translate(6 .8)">
            <g transform="translate(0 2.202)">
              <rect width="5" height="5" x="2" fill="url(#b)" rx=".25"></rect>
              <path
                fill="url(#c)"
                d="M2 .241C2 .108 2.115 0 2.25 0h3.5c.138 0 .194.094.125.21L4.538 2.462l-2.356.356-.161 1.932c-.012.138-.021.146-.021.009V.24Z"
              ></path>
              <circle cx="2" cy="2" r="1.5" fill="url(#d)"></circle>
            </g>
            <rect width="5" height="1" x="2" y="10.202" fill="url(#d)" rx=".25"></rect>
            <path
              fill="#000"
              d="M2.14 8.152h.02c.04 0 .07.038.07.088v.246c0 .039.021.073.074.073h.06c.005 0 .01 0 .01-.003 0-.004-.004-.008-.008-.013l-.037-.039a.026.026 0 0 1-.01-.02v-.24a.142.142 0 0 0-.073-.127c.04-.025.084-.077.084-.204 0-.148-.061-.211-.18-.211h-.143c-.005 0-.007.003-.007.007 0 .003.006.007.008.01l.034.033c.008.008.01.019.01.032v.693c0 .014-.002.024-.01.032l-.034.033c-.002.003-.008.007-.008.01 0 .004.002.007.007.007h.18c.004 0 .006-.003.006-.007 0-.003-.006-.007-.008-.01l-.034-.033c-.008-.008-.01-.018-.01-.032v-.325Zm0-.393h.018c.056 0 .079.038.079.154 0 .138-.023.182-.08.182h-.016V7.76Zm.39 0h.064c.015 0 .025.007.03.022l.062.215c0 .004.004.008.009.008.003 0 .006-.003.006-.007v-.285a.01.01 0 0 0-.01-.01h-.296c-.004 0-.006.003-.006.007 0 .003.005.007.008.01l.034.033c.008.008.01.019.01.032v.693c0 .014-.002.024-.01.032l-.034.033c-.003.005-.008.007-.008.01 0 .004.002.007.006.007h.296c.006 0 .01-.004.01-.01v-.287c0-.003-.003-.007-.006-.007-.004 0-.007.002-.008.007l-.062.22c-.004.013-.016.02-.03.02h-.066v-.347h.025c.006 0 .01.002.013.008l.039.083c.002.005.003.008.008.008.003 0 .004-.002.004-.006v-.242c0-.005 0-.007-.004-.007s-.005.002-.007.007l-.04.08c-.002.006-.007.008-.013.008H2.53v-.335Zm.44.591c0 .109-.026.152-.061.152-.042 0-.055-.064-.055-.393 0-.241.013-.35.061-.35.05 0 .1.148.124.233.002.007.006.012.01.012s.006-.004.006-.008V7.72c0-.011-.002-.019-.008-.019s-.013.006-.023.015c-.011.01-.023.018-.029.018a.036.036 0 0 1-.017-.007.11.11 0 0 0-.072-.026c-.14 0-.146.265-.146.406 0 .19.006.451.149.451.025 0 .048-.014.072-.035a.015.015 0 0 1 .011-.005c.005 0 .007.001.011.005l.035.03a.017.017 0 0 0 .011.005c.004 0 .006-.002.006-.006v-.358c0-.012.003-.02.011-.026l.033-.027c.004-.005.006-.007.006-.011 0-.005-.003-.007-.008-.007h-.169c-.006 0-.01.002-.01.007 0 .004.002.006.007.011l.032.027a.03.03 0 0 1 .012.026v.155Zm.201.127c0 .014-.002.024-.01.032l-.034.033c-.002.003-.008.007-.008.01 0 .004.002.007.007.007h.18c.004 0 .006-.003.006-.007 0-.003-.006-.007-.008-.01l-.034-.033c-.008-.008-.01-.018-.01-.032v-.693c0-.013.002-.024.01-.032l.034-.033c.002-.003.008-.007.008-.01 0-.004-.002-.007-.007-.007h-.18c-.004 0-.006.003-.006.007 0 .003.006.007.008.01l.034.033c.008.008.01.019.01.032v.693Zm.339-.775c-.137 0-.152.241-.152.406 0 .216.015.451.152.451.138 0 .153-.235.153-.451 0-.165-.015-.406-.153-.406Zm0 .057c.034 0 .06.096.06.35 0 .297-.026.393-.06.393-.033 0-.059-.096-.059-.393 0-.254.026-.35.059-.35Zm.245.718a.049.049 0 0 1-.01.032l-.028.033c-.003.003-.008.007-.008.011 0 .003.002.006.006.006h.151c.005 0 .007-.003.007-.006 0-.004-.004-.008-.008-.011l-.03-.034c-.009-.008-.012-.017-.012-.031v-.57h.002l.134.624c.003.017.012.028.023.028h.048c.008 0 .011-.004.011-.012v-.763c0-.013.004-.023.01-.032l.029-.033c.003-.003.008-.007.008-.011 0-.003-.002-.006-.007-.006h-.15c-.005 0-.008.003-.008.006 0 .004.006.008.008.011l.032.034c.008.008.01.018.01.031v.429h-.002l-.105-.492c-.002-.011-.005-.019-.013-.019h-.138c-.004 0-.006.003-.006.006 0 .004.005.008.008.011l.028.033a.05.05 0 0 1 .01.032v.693ZM2.227 9.493c0 .108-.025.152-.06.152-.041 0-.055-.064-.055-.393 0-.241.014-.35.062-.35.05 0 .1.147.123.233.002.007.006.012.01.012s.006-.004.006-.008v-.275c0-.011-.002-.02-.008-.02s-.012.007-.023.016c-.011.01-.023.018-.028.018a.036.036 0 0 1-.017-.007.11.11 0 0 0-.072-.026c-.141 0-.147.265-.147.406 0 .19.006.451.149.451.025 0 .048-.014.072-.035a.015.015 0 0 1 .011-.005c.005 0 .007.001.012.005l.034.03a.017.017 0 0 0 .011.005c.004 0 .006-.002.006-.006v-.359a.03.03 0 0 1 .012-.025l.033-.027c.003-.005.005-.007.005-.012 0-.004-.003-.006-.008-.006h-.169c-.005 0-.009.002-.009.006 0 .005.001.007.006.012l.032.027a.03.03 0 0 1 .012.025v.156Zm.191.086c0 .07.047.123.137.123.078 0 .133-.053.133-.123v-.652a.05.05 0 0 1 .01-.032l.035-.033c.003-.003.005-.007.005-.01 0-.004-.002-.007-.007-.007h-.156c-.005 0-.007.003-.007.007 0 .003.002.007.006.01l.035.033c.007.007.01.018.01.032v.622c0 .05-.012.096-.054.096-.054 0-.059-.046-.059-.096v-.622a.05.05 0 0 1 .01-.032l.035-.033c.003-.003.006-.007.006-.01a.007.007 0 0 0-.007-.007h-.175c-.005 0-.007.003-.007.007 0 .003.002.007.006.01l.035.033c.007.007.01.018.01.032v.652Zm.567.052c.001.01-.001.018-.006.023l-.03.03c-.004.004-.008.008-.008.011 0 .004.002.007.008.007h.164c.006 0 .008-.003.008-.007 0-.003-.003-.007-.007-.01l-.033-.03c-.008-.007-.011-.02-.012-.03l-.109-.768c-.001-.006-.005-.012-.01-.012h-.043c-.005 0-.008.004-.009.01l-.104.768c0 .01-.002.022-.009.029l-.032.032c-.003.003-.008.008-.008.011 0 .004.002.007.007.007h.131c.006 0 .008-.003.008-.007 0-.003-.006-.008-.011-.014l-.025-.026a.026.026 0 0 1-.006-.02l.017-.126c.001-.005.004-.008.007-.008h.085c.005 0 .009.004.01.01l.017.12Zm-.105-.19c-.002 0-.005-.003-.003-.008l.037-.28h.003l.04.28c0 .004-.002.007-.005.007H2.88Zm.31.179a.047.047 0 0 1-.01.032l-.035.033c-.002.004-.008.007-.008.01 0 .004.002.007.007.007h.15c.116 0 .185-.078.185-.45 0-.296-.069-.407-.184-.407h-.151c-.005 0-.007.003-.007.007 0 .003.006.007.008.01l.034.033c.008.008.01.018.01.032v.693Zm.088-.718h.02c.045 0 .087.043.087.35 0 .35-.042.393-.087.393h-.02v-.743Zm.387 0h.065c.015 0 .025.007.03.022l.062.215c0 .004.004.008.009.008.003 0 .006-.003.006-.007v-.285a.01.01 0 0 0-.01-.01h-.296c-.004 0-.006.003-.006.007 0 .003.005.007.008.01l.034.033c.008.008.01.018.01.032v.693c0 .013-.002.024-.01.032l-.034.033c-.003.004-.008.007-.008.01 0 .004.002.007.006.007h.296a.01.01 0 0 0 .01-.01v-.287c0-.004-.003-.007-.006-.007-.004 0-.007.002-.008.007l-.062.22c-.004.013-.016.02-.03.02h-.066v-.348h.025c.006 0 .01.003.013.008l.039.084c.002.004.003.008.008.008.003 0 .004-.002.004-.006V9.15c0-.005 0-.007-.004-.007s-.005.002-.007.007l-.04.08c-.002.006-.007.008-.013.008h-.025v-.335Zm.265.718c0 .013-.002.024-.01.032l-.034.033c-.003.004-.008.007-.008.01 0 .004.002.007.007.007h.28c.009 0 .012-.006.012-.016v-.28c0-.005-.002-.008-.006-.008s-.004.003-.006.008l-.071.222c-.005.013-.016.017-.03.017h-.046v-.718c0-.014.003-.024.01-.032l.035-.033c.002-.003.008-.007.008-.01 0-.004-.002-.007-.007-.007h-.18c-.004 0-.006.003-.006.007 0 .003.005.007.008.01l.034.033c.008.008.01.018.01.032v.693Zm.459-.775c-.138 0-.152.241-.152.406 0 .216.014.451.152.451.138 0 .153-.235.153-.451 0-.165-.015-.406-.153-.406Zm0 .057c.034 0 .059.096.059.35 0 .297-.025.393-.06.393-.033 0-.058-.096-.058-.393 0-.254.025-.35.059-.35Zm.24.677c0 .07.046.123.137.123.077 0 .132-.053.132-.123v-.652a.05.05 0 0 1 .01-.032l.035-.033c.003-.003.006-.007.006-.01a.007.007 0 0 0-.007-.007h-.157a.007.007 0 0 0-.007.007c0 .003.003.007.006.01l.035.033c.007.007.01.018.01.032v.622c0 .05-.012.096-.054.096-.054 0-.058-.046-.058-.096v-.622a.05.05 0 0 1 .009-.032l.035-.033c.004-.003.006-.007.006-.01 0-.004-.002-.007-.007-.007h-.175a.007.007 0 0 0-.007.007c0 .003.003.007.006.01l.035.033c.007.007.01.018.01.032v.652Zm.39.04c0 .014-.002.025-.01.033l-.034.033c-.002.004-.008.007-.008.01 0 .004.002.007.007.007h.187c.005 0 .007-.003.007-.007 0-.003-.005-.007-.008-.01l-.042-.033c-.01-.007-.01-.019-.01-.032v-.317h.038c.103 0 .151-.089.151-.236 0-.175-.062-.222-.15-.222h-.173c-.005 0-.007.003-.007.007 0 .003.006.007.008.01l.034.033c.008.008.01.018.01.032v.693Zm.088-.717h.034c.048 0 .062.038.062.165 0 .126-.014.179-.062.179h-.034v-.344Zm.372 0h.065c.015 0 .025.007.03.022l.061.215c.002.004.005.008.01.008.003 0 .005-.003.005-.007v-.285c0-.006-.004-.01-.009-.01h-.296a.007.007 0 0 0-.007.007c0 .003.006.007.008.01l.035.033c.008.008.01.018.01.032v.693c0 .013-.002.024-.01.032l-.035.033c-.002.004-.008.007-.008.01 0 .004.003.007.007.007h.296a.01.01 0 0 0 .01-.01v-.287c0-.004-.003-.007-.006-.007-.004 0-.007.002-.008.007l-.062.22c-.005.013-.016.02-.031.02h-.065v-.348h.025c.006 0 .01.003.013.008l.038.084c.003.004.004.008.008.008s.005-.002.005-.006V9.15c0-.005-.001-.007-.005-.007-.003 0-.004.002-.006.007l-.04.08c-.003.006-.007.008-.013.008h-.025v-.335Z"
            ></path>
            <path
              fill="#FFF"
              fill-rule="nonzero"
              d="M6.974.783C8.35.367 8.762.294 8.954.901A1 1 0 0 1 8.3 2.156a8.466 8.466 0 0 0-.972.382c-.31.145-.535.284-.62.37a2.514 2.514 0 0 0-.267.35 8.576 8.576 0 0 0-.334.556c-.217.389-2.058 1.91-2.44 2.001-.299.072-.522.154-.586.2a1.741 1.741 0 0 0-.25.254 5.7 5.7 0 0 0-.343.448 12.244 12.244 0 0 0-.617.974 1 1 0 0 1-1.361.383c-.662-.371.304-2.522.797-3.102.212-.248.41-.44.61-.583.312-.223.726-.384 1.28-.518.27-.065.563-.12.871-.166-.15.022-.172.044-.19.071a2.65 2.65 0 0 0 .144-.254c.024-.046.038-.076.077-.155l.134-.278c.054-.11.091-.185.127-.248.143-.258.281-.487.413-.687.18-.272.349-.488.517-.657.2-.202.879-.47 1.683-.714Z"
            ></path>
            <path
              fill="#29568D"
              fill-rule="nonzero"
              d="M5.646 1.85a3.82 3.82 0 0 0-.455.58c-.127.192-.259.412-.394.654-.166.298-.486 1.09-.654 1.116a9.237 9.237 0 0 0-.827.157c-.473.114-.846.252-1.107.438-.167.12-.339.288-.52.501C1.551 5.46.514 7.503.755 7.638a.5.5 0 0 0 .681-.191 12.763 12.763 0 0 1 .644-1.018 7.12 7.12 0 0 1 .37-.485 2.12 2.12 0 0 1 .34-.335c.13-.093.403-.194.76-.28.233-.056 1.966-1.479 2.121-1.759a9.07 9.07 0 0 1 .354-.588c.126-.19.238-.336.33-.427.136-.138.407-.303.762-.47a8.977 8.977 0 0 1 1.034-.406.5.5 0 0 0 .326-.628c-.083-.263-2.593.559-2.831.798Z"
            ></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GB-ZET">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#187AE5"></stop>
            <stop offset="100%" stop-color="#0F68C9"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GY">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#08C55F"></stop>
            <stop offset="100%" stop-color="#009F49"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD831"></stop>
            <stop offset="100%" stop-color="#FDD117"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E92034"></stop>
            <stop offset="100%" stop-color="#CE1225"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" fill-rule="nonzero" d="M-1 15V0h1l21 7v1L0 15z"></path>
          <path fill="url(#d)" fill-rule="nonzero" d="M0 1.054v12.892L19.338 7.5z"></path>
          <path fill="url(#e)" fill-rule="nonzero" d="M-1 15V0h1l11.5 7.5L0 15z"></path>
          <path fill="url(#f)" fill-rule="nonzero" d="M0 13.806 9.669 7.5 0 1.194z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#63AEE3"></stop>
            <stop offset="100%" stop-color="#4998D0"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10zM0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
          <path
            fill="#628A40"
            fill-rule="nonzero"
            d="M8 7a2.5 2.5 0 0 0 1.247 2.164.5.5 0 0 0 .502-.865A1.499 1.499 0 0 1 9 7a.5.5 0 0 0-1 0Zm3.846 2.107A2.498 2.498 0 0 0 13 7a.5.5 0 1 0-1 0 1.5 1.5 0 0 1-.693 1.265.5.5 0 1 0 .539.842Z"
          ></path>
          <circle cx="10.5" cy="7" r="1" fill="#DCC26D"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DF2237"></stop>
            <stop offset="100%" stop-color="#CE1126"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#4B9334"></stop>
            <stop offset="100%" stop-color="#3B7828"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1526A7"></stop>
            <stop offset="100%" stop-color="#0C1B8D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="M0 6h21v3H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GB">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A17A7"></stop>
            <stop offset="100%" stop-color="#030E88"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E6273E"></stop>
            <stop offset="100%" stop-color="#CF152B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M-.002 0h21v15h-21z"></path>
          <path
            fill="url(#a)"
            d="M5.003 10H-.002V5h5.005L-2.082.22l1.118-1.657 8.962 6.045V-1h5v5.608l8.962-6.045L23.078.22 15.993 5h5.005v5h-5.005l7.085 4.78-1.118 1.657-8.962-6.045V16h-5v-5.608l-8.962 6.045-1.118-1.658L5.003 10Z"
          ></path>
          <path
            fill="#DB1F35"
            fill-rule="nonzero"
            d="m14.136 4.958 9.5-6.25a.25.25 0 0 0-.275-.417l-9.5 6.25a.25.25 0 1 0 .275.417Zm.732 5.522 8.515 5.74a.25.25 0 1 0 .28-.415l-8.516-5.74a.25.25 0 0 0-.279.415ZM6.142 4.526-2.74-1.461a.25.25 0 0 0-.28.415L5.863 4.94a.25.25 0 0 0 .279-.414Zm.685 5.469-9.845 6.53a.25.25 0 1 0 .276.416l9.846-6.529a.25.25 0 0 0-.277-.417Z"
          ></path>
          <path fill="url(#c)" d="M-.002 9h9v6h3V9h9V6h-9V0h-3v6h-9z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="HM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A17A7"></stop>
            <stop offset="100%" stop-color="#030E88"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="#FFF"
            d="m4.5 12.25-.882.464.169-.982-.714-.696.986-.143L4.5 10l.441.893.986.143-.714.696.169.982z"
          ></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#c)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#c)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <path
            fill="#FFF"
            d="m15 13-.707.207.207-.707-.207-.707L15 12l.707-.207-.207.707.207.707zm0-9.5-.707.207L14.5 3l-.207-.707L15 2.5l.707-.207L15.5 3l.207.707zm3 3-.707.207L17.5 6l-.207-.707L18 5.5l.707-.207L18.5 6l.207.707zm-6 1-.707.207L11.5 7l-.207-.707L12 6.5l.707-.207L12.5 7l.207.707zm4.5 1.25-.354.104.104-.354-.104-.354.354.104.354-.104-.104.354.104.354z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="HR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF202D"></stop>
            <stop offset="100%" stop-color="#FD0D1B"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2027AC"></stop>
            <stop offset="100%" stop-color="#191F94"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF212E"></stop>
            <stop offset="100%" stop-color="#FD0D1B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path
            fill="#1895DB"
            d="m8 4 .5-.5.5.5v1H8V4Zm2 0 .5-.5.5.5v1h-1V4Zm2 0 .5-.5.5.5v1h-1V4Z"
            opacity=".5"
          ></path>
          <path fill="#191F94" d="m9 4 .5-.5.5.5v1H9V4Zm2 0 .5-.5.5.5v1h-1V4Z" opacity=".5"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path
            fill="url(#a)"
            d="M0 10V5h21v5H0Zm12 0h1l-.273.547c-.126.25-.454.453-.727.453v-1Zm-2 0h1v1h-1v-1Zm-2 0h1v1a.876.876 0 0 1-.727-.453L8 10Z"
          ></path>
          <path
            fill="url(#d)"
            d="M10 5h1v1h-1V5Zm2 0h.5l.5 1h-1V5ZM8.5 5H9v1H8l.5-1ZM9 6h1v1H9V6Zm2 0h1v1h-1V6Zm-1 1h1v1h-1V7Zm2 0h1v1h-1V7Zm-1 1h1v1h-1V8ZM8 7h1v1H8V7Zm1 1h1v1H9V8ZM8 9h1v1H8V9Zm2 0h1v1h-1V9Zm2 0h1v1h-1V9Zm-1 1h1v1h-1v-1Zm-2 0h1v1H9v-1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="GS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07319C"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1E1E1E"></stop>
            <stop offset="100%"></stop>
          </linearGradient>
          <linearGradient id="h" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#A2ADB0"></stop>
            <stop offset="100%" stop-color="#8B9497"></stop>
          </linearGradient>
          <linearGradient id="i" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#4F4F4F"></stop>
            <stop offset="100%" stop-color="#2B2B2B"></stop>
          </linearGradient>
          <linearGradient id="k" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FEC241"></stop>
            <stop offset="100%" stop-color="#FEBB2C"></stop>
          </linearGradient>
          <linearGradient id="l" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#A84B14"></stop>
            <stop offset="100%" stop-color="#913F0E"></stop>
          </linearGradient>
          <linearGradient id="m" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#CFB063"></stop>
            <stop offset="100%" stop-color="#BEA157"></stop>
          </linearGradient>
          <linearGradient id="n" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2D42FF"></stop>
            <stop offset="100%" stop-color="#0B24FC"></stop>
          </linearGradient>
          <linearGradient id="o" x1="0%" x2="100%" y1="0%" y2="50%">
            <stop offset="0%" stop-color="#E3DC3D"></stop>
            <stop offset="100%" stop-color="#CFC82A"></stop>
          </linearGradient>
          <linearGradient id="p" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#7F7D7D"></stop>
            <stop offset="100%" stop-color="#656263"></stop>
          </linearGradient>
          <linearGradient id="s" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0F8012"></stop>
            <stop offset="100%" stop-color="#0B6A0D"></stop>
          </linearGradient>
          <linearGradient id="t" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFCF44"></stop>
            <stop offset="100%" stop-color="#FCC72E"></stop>
          </linearGradient>
          <ellipse id="d" cx=".5" cy="1.5" rx="1" ry="1.5"></ellipse>
          <ellipse id="g" cx=".5" cy="1.5" rx="1" ry="1.5"></ellipse>
          <path
            id="q"
            d="M.007.506A.489.489 0 0 1 .495 0h2.01c.273 0 .498.23.502.506L3.03 2.25a.52.52 0 0 1-.207.388l-1.095.722a.414.414 0 0 1-.417 0L.24 2.639a.526.526 0 0 1-.21-.388L.007.506Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#c)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#c)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <g transform="translate(18 8)">
            <mask id="f" fill="#fff">
              <use xlink:href="#d"></use>
            </mask>
            <use xlink:href="#d" fill="url(#e)"></use>
            <ellipse cy="2" fill="url(#a)" mask="url(#f)" rx="1" ry="1.5"></ellipse>
          </g>
          <g transform="translate(14 8)">
            <mask id="j" fill="#fff">
              <use xlink:href="#g"></use>
            </mask>
            <use xlink:href="#g" fill="url(#h)"></use>
            <ellipse cx="1" cy="2" fill="url(#i)" mask="url(#j)" rx="1" ry="1.5"></ellipse>
          </g>
          <path fill="url(#k)" d="M16.5 12.5c.828.5 1.5.276 1.5 0s-.672-.5-1.5-.5-1.5.224-1.5.5.672.5 1.5 0Z"></path>
          <circle cx="18.5" cy="5.5" r="1" fill="url(#a)"></circle>
          <circle cx="16.5" cy="4.5" r="1" fill="url(#l)"></circle>
          <circle cx="16.5" cy="3.75" r="1" fill="url(#m)"></circle>
          <circle cx="16.5" cy="11.5" r="1" fill="url(#a)"></circle>
          <circle cx="14.5" cy="5.5" r="1" fill="url(#a)"></circle>
          <circle cx="15" cy="6.5" r="1" fill="url(#n)"></circle>
          <circle cx="18" cy="6.5" r="1" fill="url(#n)"></circle>
          <circle cx="19" cy="8" r="1" fill="url(#o)"></circle>
          <path fill="url(#p)" d="m16 7.5-.5.5h2l-.5-.5.5-1.5s-.448-1-1-1-1 1-1 1l.5 1.5Z"></path>
          <path fill="#5D0543" d="M16.5 6.5s.5-.112.5-.38c0-.008-.5-.12-.5-.12s-.5.112-.5.12c0 .268.5.38.5.38Z"></path>
          <g transform="translate(15 8)">
            <mask id="r" fill="#fff">
              <use xlink:href="#q"></use>
            </mask>
            <use xlink:href="#q" fill="url(#a)"></use>
            <circle cx="2.5" cy="2.5" r="1" fill="#225DA4" mask="url(#r)"></circle>
            <circle cx=".5" cy="1.5" r="1" fill="#225DA4" mask="url(#r)"></circle>
            <path fill="url(#s)" d="M0 0h3L1.5 3z" mask="url(#r)"></path>
            <circle cx="1.5" cy="1.5" r="1" fill="url(#t)" mask="url(#r)"></circle>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1AB558"></stop>
            <stop offset="100%" stop-color="#169E4D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD952"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E72B42"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#c)" d="M0 0h21v7H0z"></path>
          <path fill="url(#d)" d="M0 0h8v15H0z"></path>
          <path
            fill="url(#e)"
            d="M4 8.459 2.531 9.523l.557-1.727-1.466-1.069 1.814-.003L4 5l.564 1.724 1.814.003-1.466 1.069.557 1.727z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="HT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#112EBC"></stop>
            <stop offset="100%" stop-color="#0620A0"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E3264A"></stop>
            <stop offset="100%" stop-color="#D20F34"></stop>
          </linearGradient>
          <path id="f" d="m0 5 1.105-.553C1.6 4.2 2.443 4 3 4h1.002c.552 0 1.404.202 1.894.447L7 5v1H0V5Z"></path>
          <path
            id="g"
            d="M1 3.006c0-.28.18-.362.39-.193l1.72 1.374a.66.66 0 0 0 .78 0l1.72-1.375c.215-.172.39-.081.39.194v1.488c0 .28-.215.506-.498.506H1.498A.505.505 0 0 1 1 4.494V3.006Z"
          ></path>
          <rect id="d" width="7" height="6" x="0" y="0" rx=".5"></rect>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v7H0z"></path>
          <path fill="url(#c)" d="M0 7h21v8H0z"></path>
          <g transform="translate(7 5)">
            <mask id="e" fill="#fff">
              <use xlink:href="#d"></use>
            </mask>
            <use xlink:href="#d" fill="url(#a)"></use>
            <g mask="url(#e)">
              <use xlink:href="#f" fill="#AABCAE"></use>
              <path
                stroke="#366C14"
                stroke-width=".5"
                d="M.25 5.155v.595h6.5v-.595l-.967-.484C5.326 4.443 4.513 4.25 4 4.25H2.999c-.516 0-1.321.19-1.782.421l-.967.484Z"
              ></path>
            </g>
            <circle cx="3.5" cy="2.5" r="1.5" fill="#D4B872" mask="url(#e)"></circle>
            <g mask="url(#e)">
              <use xlink:href="#g" fill="#C28321"></use>
              <path
                stroke="#0D3488"
                stroke-width=".5"
                d="M1.25 3.02v1.474c0 .14.114.256.248.256h4.004c.14 0 .248-.11.248-.256V3.02L4.047 4.383a.91.91 0 0 1-1.094 0L1.25 3.02Z"
              ></path>
            </g>
            <path
              fill="#216C30"
              d="M2.172 1.172C2.077 1.077 2.114 1 2.256 1h2.488c.141 0 .175.08.084.172L3.672 2.328a.247.247 0 0 1-.344 0L2.172 1.172Z"
              mask="url(#e)"
            ></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1DBE5E"></stop>
            <stop offset="100%" stop-color="#169E4D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E72B42"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD952"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="GU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DE3149"></stop>
            <stop offset="100%" stop-color="#C2273D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#053B94"></stop>
            <stop offset="100%" stop-color="#002E7A"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DE3149"></stop>
            <stop offset="100%" stop-color="#C2273D"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#81C1F3"></stop>
            <stop offset="100%" stop-color="#6AB1E9"></stop>
          </linearGradient>
          <linearGradient id="h" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#27A07E"></stop>
            <stop offset="100%" stop-color="#1F9171"></stop>
          </linearGradient>
          <linearGradient id="i" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1E8CE8"></stop>
            <stop offset="100%" stop-color="#107FDC"></stop>
          </linearGradient>
          <linearGradient id="j" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF048"></stop>
            <stop offset="100%" stop-color="#FFEF36"></stop>
          </linearGradient>
          <linearGradient id="k" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#8F5715"></stop>
            <stop offset="100%" stop-color="#7A480D"></stop>
          </linearGradient>
          <path id="e" d="M2.5 8.5s2.5-2 2.5-4-2.5-4-2.5-4-2.5 2-2.5 4 2.5 4 2.5 4Z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <rect width="19" height="13" x="1" y="1" fill="url(#c)" rx=".75"></rect>
          <path fill="url(#d)" d="M10.5 12s3-2.015 3-4.5-3-4.5-3-4.5-3 2.015-3 4.5 3 4.5 3 4.5Z"></path>
          <g transform="translate(8 3)">
            <mask id="g" fill="#fff">
              <use xlink:href="#e"></use>
            </mask>
            <use xlink:href="#e" fill="url(#a)"></use>
            <path fill="url(#f)" d="M0 0h5v5H0z" mask="url(#g)"></path>
            <path
              fill="url(#h)"
              d="m2.5 4.1-.882.614.311-1.029-.856-.649 1.074-.021L2.5 2l.353 1.015 1.074.021-.856.649.311 1.029z"
              mask="url(#g)"
            ></path>
            <path fill="url(#i)" d="M0 5h5v4H0z" mask="url(#g)"></path>
            <path
              fill="url(#j)"
              d="M0 6s1.59 1.5 2 1.5c.488 0 .496-.723 1-1 .794-.436 2-.5 2-.5v3H0V6Z"
              mask="url(#g)"
            ></path>
          </g>
          <path
            fill="url(#k)"
            fill-rule="nonzero"
            d="M10.251 6.475a14.974 14.974 0 0 0-.067 1.084c-.01.467.01.812.079 1.02.087.261.284.506.557.742.208.18.415.316.557.397a.25.25 0 0 0 .246-.436 3.148 3.148 0 0 1-.477-.34c-.21-.182-.356-.363-.409-.521-.044-.134-.063-.442-.053-.85a13.917 13.917 0 0 1 .065-1.046.25.25 0 1 0-.498-.05Z"
          ></path>
          <path fill="#FFF" d="M9 7.5 10 9H9z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="HK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F0371D"></stop>
            <stop offset="100%" stop-color="#DE290F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M12 7.19c-.798-.5-1 .409-1 0 0-.828.895-1.5 2-1.5s2 .672 2 1.5c-.949 0-1.044.5-1.5.5-.56 0-.702 0-1.5-.5ZM13.25 7a.25.25 0 1 0 0-.5.25.25 0 0 0 0 .5Zm-1.81 1.962c.228-.913-.698-.824-.31-.95.788-.257 1.703.387 2.045 1.438.341 1.05-.021 2.11-.809 2.366-.293-.903-.798-.838-.939-1.272-.173-.533-.217-.668.012-1.582Zm.566 1.13a.25.25 0 1 0 .476-.154.25.25 0 0 0-.476.154ZM9.58 8.977c.94-.065.57-.919.81-.588.486.67.157 1.74-.737 2.389-.894.65-2.013.632-2.5-.038.768-.558.55-1.018.92-1.286.453-.33.568-.413 1.507-.477Zm-.899.888a.25.25 0 1 0 .294.405.25.25 0 0 0-.294-.405Zm.312-2.652c.351.874 1.049.258.809.588-.487.67-1.606.687-2.5.038-.894-.65-1.223-1.719-.736-2.39.767.559 1.138.21 1.507.478.453.33.568.413.92 1.286Zm-1.124-.58a.25.25 0 1 0-.293.404.25.25 0 0 0 .293-.404Zm2.619-.524c-.722.605.08 1.078-.309.951-.788-.256-1.15-1.315-.809-2.365.342-1.05 1.257-1.695 2.045-1.439-.293.903.153 1.147.012 1.581-.173.533-.217.668-.939 1.272Zm.205-1.247a.25.25 0 1 0-.475-.155.25.25 0 0 0 .475.155Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="GQ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EC3938"></stop>
            <stop offset="100%" stop-color="#E12524"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#51B422"></stop>
            <stop offset="100%" stop-color="#429919"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#258DE7"></stop>
            <stop offset="100%" stop-color="#1276CC"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="#159940"
            d="M10.066 8.932a.73.73 0 0 0 .175-.425l.008-1.264A.25.25 0 0 0 9.996 7h-.242c-.14 0-.176-.078-.08-.174l.652-.652a.247.247 0 0 1 .348 0l.652.652c.096.096.057.174-.08.174h-.242a.253.253 0 0 0-.254.243v1.264c0 .134.08.322.17.414l-.09-.092c.093.094.063.171-.082.171h-.496c-.139 0-.176-.08-.078-.182l-.108.114Z"
          ></path>
          <path fill="url(#d)" d="m0 0 7 7.5L0 15z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ER">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#29C53F"></stop>
            <stop offset="100%" stop-color="#21AC35"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#579DED"></stop>
            <stop offset="100%" stop-color="#458BDB"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F42D56"></stop>
            <stop offset="100%" stop-color="#E9103D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v7.5H0z"></path>
          <path fill="url(#c)" d="M0 7.5h21v8H0z"></path>
          <path fill="url(#d)" d="m0 15 21-7.5L0 0z"></path>
          <path
            fill="#FFC63C"
            fill-rule="nonzero"
            d="M6.5 10a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5Zm0 1a3.5 3.5 0 1 1 0-7 3.5 3.5 0 0 1 0 7Z"
          ></path>
          <circle cx="6" cy="6.5" r="1" fill="#FFC63C"></circle>
          <circle cx="7" cy="7" r="1" fill="#FFC63C"></circle>
          <circle cx="6.5" cy="6" r="1" fill="#FFC63C"></circle>
          <circle cx="6" cy="7.5" r="1" fill="#FFC63C"></circle>
          <circle cx="7" cy="8" r="1" fill="#FFC63C"></circle>
          <circle cx="6" cy="8.5" r="1" fill="#FFC63C"></circle>
          <circle cx="7" cy="9" r="1" fill="#FFC63C"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="HU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E03D52"></stop>
            <stop offset="100%" stop-color="#CD2A3F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#5A9165"></stop>
            <stop offset="100%" stop-color="#44704D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="IE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF8515"></stop>
            <stop offset="100%" stop-color="#FF7A00"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07BB59"></stop>
            <stop offset="100%" stop-color="#029C48"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="IL">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0E46D4"></stop>
            <stop offset="100%" stop-color="#0538B9"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v3H0zm0 12h21v3H0z"></path>
          <path fill="url(#a)" d="M0 3h21v9H0z"></path>
          <path stroke="#093EC5" stroke-width=".5" d="M7.575 9.25 10.5 3.985l2.925 5.265h-5.85Z"></path>
          <path stroke="#093EC5" stroke-width=".5" d="m7.575 5.75 2.925 5.265 2.925-5.265h-5.85Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ID">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E12237"></stop>
            <stop offset="100%" stop-color="#CE1126"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v8H0z"></path>
          <path fill="url(#a)" d="M0 8h21v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="IM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E52D42"></stop>
            <stop offset="100%" stop-color="#CB1D31"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F8DD4E"></stop>
            <stop offset="100%" stop-color="#F9DA38"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M12.5 1.5h-2L9 5 7.5 4S6.411 1.411 6 1c-.411-.411-.828-.03-2.13.349-1.301.38-1.352.815-1.86.815-.207 0-.862-.76-1.228-.987C.244.844.051 1 .18 1.5c.056.216.483.483.754.87.355.51.566 1.13.566 1.13s.488-.456.75-.53c.398-.114.846.08 1.372 0C4.289 2.865 5 2.5 5 2.5l.174 1.907S2.795 6.617 3 7.5c.205.883 2.469 1.966 3 2.74.531.773-.316 1.061-.316 1.433 0 .371-.088.866.316.717.404-.148.453-.792.823-1.377.255-.402.46-.614.496-.773.086-.39-1.028-1.415-1.635-2.14-.289-.346-.871-.815-.871-.815L6.53 6s2.966 1.225 3.635.817C10.836 6.409 11 2.5 11 2.5l2.062-.5-.562-.5Z"
            transform="translate(4 1.5)"
          ></path>
          <path
            fill="url(#c)"
            d="M7.5 10a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2-8a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-6 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2-6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 4C6.224 6 6 5.552 6 5s.224-1 .5-1 .5.448.5 1-.224 1-.5 1Zm-5-2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
            transform="translate(4 1.5)"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="IN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFA44A"></stop>
            <stop offset="100%" stop-color="#FF9934"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1A9F0B"></stop>
            <stop offset="100%" stop-color="#138806"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <circle cx="10.5" cy="7.5" r="1.5" fill="#181A93" fill-opacity=".15"></circle>
          <path
            fill="#181A93"
            fill-rule="nonzero"
            d="M10.5 9.5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Zm0-.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
          ></path>
          <circle cx="10.5" cy="7.5" r="1" fill="#181A93"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="IS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0E4CB5"></stop>
            <stop offset="100%" stop-color="#063B95"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EB363A"></stop>
            <stop offset="100%" stop-color="#D52B2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
          <path fill="url(#c)" d="M0 8h7v7h1V8h13V7H8V0H7v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="IQ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DF1E35"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="#0F7A40"
            d="M14 6.256c0-.141.092-.21.232-.14l.536.268a.444.444 0 0 1 .232.365V8.75a.247.247 0 0 1-.252.249h-.496A.254.254 0 0 1 14 8.744V6.256Zm-6 0c0-.141.092-.21.232-.14l.536.268A.444.444 0 0 1 9 6.749V8.75a.247.247 0 0 1-.252.25h-.496A.254.254 0 0 1 8 8.744V6.256Zm4 .493c0-.138.092-.295.232-.365l.536-.268c.128-.064.232-.002.232.14v2.488a.25.25 0 0 1-.252.256h-.496A.248.248 0 0 1 12 8.751V6.75Z"
          ></path>
          <path
            fill="#0F7A40"
            d="M10 7.748c0-.137.092-.294.232-.364l.536-.268c.128-.064.232-.004.232.126v.803h1.5V9h-2.248A.255.255 0 0 1 10 8.752V7.748Zm-4 0c0-.137.092-.294.232-.364l.536-.268c.128-.064.232-.004.232.126v.803h1.5V9H6.252A.255.255 0 0 1 6 8.752V7.748Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="JO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#199E56"></stop>
            <stop offset="100%" stop-color="#0F7A40"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E6223A"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="m0 0 10 7.5L0 15z"></path>
          <path
            fill="url(#a)"
            d="m3.5 8.25-.651.601.065-.883-.876-.134.731-.501-.442-.768.848.259L3.5 6l.325.824.848-.259-.442.768.731.501-.876.134.065.883z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="JM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1DBE4F"></stop>
            <stop offset="100%" stop-color="#159B3F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD646"></stop>
            <stop offset="100%" stop-color="#FED02F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0-.003h21v15H0z"></path>
          <path fill="url(#c)" d="m0-.003 9 7.5-9 7.5z"></path>
          <path fill="url(#c)" d="m12-.003 9 7.5-9 7.5z" transform="matrix(-1 0 0 1 33 0)"></path>
          <path
            fill="url(#d)"
            d="M10.5 6.291-.962-1.44-2.08.218l10.792 7.28-10.792 7.279 1.118 1.658L10.5 8.704l11.462 7.73 1.118-1.657-10.791-7.28L23.08.218 21.962-1.44 10.5 6.291Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="IT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E43D4C"></stop>
            <stop offset="100%" stop-color="#CC2E3C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1BB65D"></stop>
            <stop offset="100%" stop-color="#139149"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="IO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07319C"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M2.164.908h21v15h-21z" transform="translate(-2.16 -.91)"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M5.16 4.14.808.41H2.82l3.5 2.5h.697L11.66.008V1.16c0 .303-.167.627-.418.806L8.16 4.167v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L7 5.91h-.697L1.66 8.812v-1.66l3.5-2.5V4.14Z"
            transform="translate(-2.16 -.91)"
          ></path>
          <path
            fill="url(#c)"
            d="m5.66 3.91-3.5-3h.5l3.5 2.5h1l4-2.5v.25a.537.537 0 0 1-.208.399L7.66 3.91v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L7.16 5.41h-1l-4 2.5v-.5l3.5-2.5v-1Z"
            transform="translate(-2.16 -.91)"
          ></path>
          <path
            fill="url(#a)"
            d="M2.16 3.41v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V5.41h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H7.66V.91h-2v2.5h-3.5Z"
            transform="translate(-2.16 -.91)"
          ></path>
          <path fill="url(#c)" d="M2.16 3.91h4v-3h1v3h4v1h-4v3h-1v-3h-4z" transform="translate(-2.16 -.91)"></path>
          <path
            fill="#FFF"
            fill-rule="nonzero"
            d="m.423 6.998-1.109.37-.474.157.316.949.475-.158 2.062-.688c.153-.05.467-.051.621 0l2.063.688c.357.119.894.12 1.254 0l2.062-.688c.153-.05.467-.051.621 0l2.063.688c.357.119.894.12 1.254 0l2.062-.688c.153-.05.467-.051.621 0l2.063.688c.357.119.894.12 1.254 0l2.062-.688c.153-.05.467-.051.621 0l2.063.688.469.156.474.158.316-.948-.474-.159-.469-.156-2.062-.687c-.36-.12-.897-.12-1.254 0l-2.063.687a1.275 1.275 0 0 1-.62 0L14.63 6.68c-.36-.12-.897-.12-1.254 0l-2.063.687a1.275 1.275 0 0 1-.62 0l-1.69-.563v.194h-2.58l-1.109.37a1.3 1.3 0 0 1-.62 0l-1.11-.37H.424Zm8.58-1.64 1.374.458c.357.119.894.12 1.254 0l2.062-.688c.153-.05.467-.051.621 0l2.063.688c.357.119.894.12 1.254 0l2.062-.688c.153-.05.467-.051.621 0l2.063.688.469.156.474.158.316-.948-.474-.159-.469-.156-2.062-.687c-.36-.12-.897-.12-1.254 0l-2.063.687a1.275 1.275 0 0 1-.62 0L14.63 4.18c-.36-.12-.897-.12-1.254 0l-2.063.687a1.275 1.275 0 0 1-.62 0l-1.69-.563v1.054Zm-9 .333-.372.125-.475.158-.316-.949.474-.158.69-.23v1.054Zm9-2.833 1.374.458c.357.119.894.12 1.254 0l2.062-.688c.153-.05.467-.051.621 0l2.063.688c.357.119.894.12 1.254 0l2.062-.688c.153-.05.467-.051.621 0l2.063.688.469.156.474.158.316-.948-.474-.159-.469-.156-2.062-.687c-.36-.12-.897-.12-1.254 0l-2.063.687a1.275 1.275 0 0 1-.62 0L14.63 1.68c-.36-.12-.897-.12-1.254 0l-2.063.687a1.275 1.275 0 0 1-.62 0l-1.69-.563v1.054Zm-9 .333-.372.125-.475.158-.316-.949.474-.158.69-.23v1.054Zm9-2.833 1.374.458c.357.119.894.12 1.254 0l2.062-.688c.153-.05.467-.051.621 0l2.063.688c.357.119.894.12 1.254 0l2.062-.688c.153-.05.467-.051.621 0l2.063.688.469.156.474.158.316-.948-.474-.159-.469-.156-2.062-.687c-.36-.12-.897-.12-1.254 0l-2.063.687a1.275 1.275 0 0 1-.62 0L14.63-.82c-.36-.12-.897-.12-1.254 0l-2.063.687a1.275 1.275 0 0 1-.62 0L8.63-.82c-.36-.12-.897-.12-1.254 0l-2.063.687a1.275 1.275 0 0 1-.62 0L2.63-.82c-.36-.12-.897-.12-1.254 0l-2.063.687-.474.158.316.949.475-.158L.004.69v-.693h9v.36Zm14.159 14.665.474.159-.316.948-.474-.158-.47-.156-2.062-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688-.475.158-.316-.949.474-.158 2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687.469.156Zm0-2.5.474.159-.316.948-.474-.158-.47-.156-2.062-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688-.475.158-.316-.949.474-.158 2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687.469.156Zm0-2.5.474.159-.316.948-.474-.158-.47-.156-2.062-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688-.475.158-.316-.949.474-.158 2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687.469.156Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="KE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#018301"></stop>
            <stop offset="100%" stop-color="#006700"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DC0808"></stop>
            <stop offset="100%" stop-color="#BC0000"></stop>
          </linearGradient>
          <path id="e" d="M2.5 10.5c1 0 2.5-1.962 2.5-5 0-3.038-1.5-5-2.5-5S0 2.462 0 5.5c0 3.038 1.5 5 2.5 5Z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v4H0z"></path>
          <path fill="url(#c)" d="M0 11h21v4H0z"></path>
          <path fill="url(#a)" d="M0 4h21v7H0z"></path>
          <path fill="url(#d)" d="M0 5h21v5H0z"></path>
          <g transform="translate(8 2)">
            <mask id="f" fill="#fff">
              <use xlink:href="#e"></use>
            </mask>
            <use xlink:href="#e" fill="#BC0000"></use>
            <ellipse cx="-1.5" cy="5.5" fill="url(#b)" mask="url(#f)" rx="2.5" ry="5.5"></ellipse>
            <ellipse cx="6.5" cy="5.5" fill="url(#b)" mask="url(#f)" rx="2.5" ry="5.5"></ellipse>
            <path
              fill="url(#a)"
              d="M2.5 7C2.224 7 2 6.328 2 5.5S2.224 4 2.5 4s.5.672.5 1.5S2.776 7 2.5 7Zm0-3C2.224 4 2 3.105 2 2s.224-2 .5-2 .5.895.5 2-.224 2-.5 2Zm0 7c-.276 0-.5-.895-.5-2s.224-2 .5-2 .5.895.5 2-.224 2-.5 2Z"
              mask="url(#f)"
            ></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="JE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EF273F"></stop>
            <stop offset="100%" stop-color="#DB1C33"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F22A41"></stop>
            <stop offset="100%" stop-color="#E51D34"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FADF46"></stop>
            <stop offset="100%" stop-color="#F9DC38"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#b)"
            d="M10.5 6.291-.962-1.44-2.08.218l10.792 7.28-10.792 7.279 1.118 1.658L10.5 8.704l11.462 7.73 1.118-1.657-10.791-7.28L23.08.218 21.962-1.44 10.5 6.291Z"
          ></path>
          <path
            fill="url(#c)"
            d="M9 2.502c0-.279.216-.505.496-.505h2.009c.273 0 .495.214.495.505v.99c0 .28-.16.666-.348.853l-.804.804a.496.496 0 0 1-.696 0l-.804-.804A1.354 1.354 0 0 1 9 3.493v-.991Z"
          ></path>
          <path
            fill="url(#d)"
            d="M10.5 3.997a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0-2c-.828 0-1.5-.224-1.5-.5s.672-.5 1.5-.5c.829 0 1.5.224 1.5.5s-.671.5-1.5.5Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="IR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#38BB56"></stop>
            <stop offset="100%" stop-color="#2B9F45"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DE1B27"></stop>
            <stop offset="100%" stop-color="#D80915"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="#FFF"
            fill-opacity=".5"
            d="M1 4.252C1 4.113 1.107 4 1.252 4h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 1.748 5h-.496A.249.249 0 0 1 1 4.748v-.496Zm2 0C3 4.113 3.107 4 3.252 4h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 3.748 5h-.496A.249.249 0 0 1 3 4.748v-.496Zm2 0C5 4.113 5.107 4 5.252 4h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 5.748 5h-.496A.249.249 0 0 1 5 4.748v-.496Zm2 0C7 4.113 7.107 4 7.252 4h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 7.748 5h-.496A.249.249 0 0 1 7 4.748v-.496Zm2 0C9 4.113 9.107 4 9.252 4h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 9.748 5h-.496A.249.249 0 0 1 9 4.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 11 4.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 13 4.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 15 4.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 17 4.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 19 4.748v-.496Zm-18 6c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 1 10.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 3 10.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 5 10.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 7 10.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 9 10.748v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496a.249.249 0 0 1-.252-.252v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496a.249.249 0 0 1-.252-.252v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496a.249.249 0 0 1-.252-.252v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496a.249.249 0 0 1-.252-.252v-.496Zm2 0c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496a.249.249 0 0 1-.252-.252v-.496Z"
          ></path>
          <path stroke="#D80915" stroke-width=".5" d="M9.591 6.642a1.25 1.25 0 1 0 1.83.014l-1.83-.014Z"></path>
          <rect width="1" height="2" x="10" y="7" fill="#D80915" rx=".5"></rect>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="KH">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0F3EB6"></stop>
            <stop offset="100%" stop-color="#09339F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#ED1A3C"></stop>
            <stop offset="100%" stop-color="#DE0B2D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v4H0zm0 11h21v4H0z"></path>
          <path fill="url(#c)" d="M0 4h21v7H0z"></path>
          <path
            fill="url(#a)"
            d="M7.5 8h1v2h-2l1-2ZM9 8h3v2H9V8Zm3.5 0h1l1 2h-2V8Zm0-1.492A.51.51 0 0 1 13 6a.5.5 0 0 1 .5.508V7.5h-1v-.992ZM9 6.545h1v-.547c0-.275.232-.498.5-.498.276 0 .5.222.5.498v.547h1V7.5H9v-.955Zm-1.5-.037A.51.51 0 0 1 8 6a.5.5 0 0 1 .5.508V7.5h-1v-.992Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="JP">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D81441"></stop>
            <stop offset="100%" stop-color="#BB0831"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <circle cx="10.5" cy="7.5" r="4.5" fill="url(#b)"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="KM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFCB49"></stop>
            <stop offset="100%" stop-color="#FFC638"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DC1D34"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#4985D4"></stop>
            <stop offset="100%" stop-color="#3D77C2"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#4BA343"></stop>
            <stop offset="100%" stop-color="#408D39"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v4H0z"></path>
          <path fill="url(#c)" d="M0 7h21v4H0z"></path>
          <path fill="url(#d)" d="M0 11h21v4H0z"></path>
          <path fill="url(#a)" d="M0 4h21v3H0z"></path>
          <path fill="url(#e)" d="m0 15 10-7.5L0 0z"></path>
          <path
            fill="url(#a)"
            d="M4.75 4.595a3 3 0 1 0 0 5.811 3.001 3.001 0 0 1 0-5.811ZM5.5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="KN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1EC160"></stop>
            <stop offset="100%" stop-color="#169E4D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DF2A40"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="16.742%" y2="82.422%">
            <stop offset="0%" stop-color="#FFD956"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="m.001 10 21-10h-21z"></path>
          <path fill="url(#c)" d="M.001 15h21V5z"></path>
          <path fill="url(#d)" d="M.589 19 25.183 3.632 20.413-4-4.18 11.368z"></path>
          <path fill="url(#e)" d="M-.471 17.304 24.123 1.936l-2.65-4.24L-3.12 13.064z"></path>
          <path
            fill="url(#a)"
            d="m15.233 5.848-.709 1.123-.46-1.246-1.287-.327 1.043-.823-.087-1.325 1.105.738 1.234-.492-.36 1.278.848 1.022zm-8 4.85-.709 1.123-.46-1.246-1.287-.327 1.043-.823L5.733 8.1l1.105.738 1.234-.492-.36 1.278.848 1.022z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="KR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E01B41"></stop>
            <stop offset="100%" stop-color="#C51335"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0E4B9C"></stop>
            <stop offset="100%" stop-color="#053677"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <circle id="b" cx="3.5" cy="3.5" r="3.5"></circle>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <g transform="translate(7 4)">
            <mask id="e" fill="#fff">
              <use xlink:href="#b"></use>
            </mask>
            <use xlink:href="#b" fill="url(#c)"></use>
            <path
              fill="url(#d)"
              d="M0 4c1 .937 2.5 1.5 3.5 0s3-1.5 3.5 0 0 3 0 3H0s-1-3.937 0-3Z"
              mask="url(#e)"
            ></path>
          </g>
          <path
            fill="url(#f)"
            d="M14.208 3.922a.25.25 0 0 1 .09-.347l.43-.248a.254.254 0 0 1 .346.095l1.244 2.156a.25.25 0 0 1-.09.347l-.43.248a.254.254 0 0 1-.346-.095l-1.244-2.156Zm1.3-.75a.25.25 0 0 1 .09-.347l.429-.248a.254.254 0 0 1 .346.095l1.244 2.156a.25.25 0 0 1-.09.347l-.43.248a.254.254 0 0 1-.346-.095l-1.244-2.156Zm-12.125 7a.25.25 0 0 1 .09-.347l.43-.248a.254.254 0 0 1 .346.095l1.244 2.156a.25.25 0 0 1-.09.347l-.43.248a.254.254 0 0 1-.346-.095l-1.244-2.156Zm1.299-.75a.25.25 0 0 1 .09-.347l.43-.248a.254.254 0 0 1 .346.095l1.244 2.156a.25.25 0 0 1-.09.347l-.43.248a.254.254 0 0 1-.346-.095L4.682 9.422Zm10.77-.5a.25.25 0 0 1 .347-.095l.429.248c.12.07.161.225.09.347l-1.244 2.156a.25.25 0 0 1-.346.095l-.43-.248a.254.254 0 0 1-.09-.347l1.244-2.156Zm1.3.75a.25.25 0 0 1 .346-.095l.429.248c.12.07.161.225.09.347l-1.244 2.156a.25.25 0 0 1-.346.095l-.43-.248a.254.254 0 0 1-.09-.347l1.244-2.156Zm-12.125-7a.25.25 0 0 1 .346-.095l.43.248c.12.07.16.225.09.347L4.249 5.328a.25.25 0 0 1-.347.095l-.429-.248a.254.254 0 0 1-.09-.347l1.244-2.156Zm1.299.75a.25.25 0 0 1 .346-.095l.43.248c.12.07.16.225.09.347L5.548 6.078a.25.25 0 0 1-.347.095l-.429-.248a.254.254 0 0 1-.09-.347l1.244-2.156Z"
            opacity=".75"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="KW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D72238"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#169A53"></stop>
            <stop offset="100%" stop-color="#0F7A40"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="m0 0 7 5v5l-7 5z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="KP">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1461B6"></stop>
            <stop offset="100%" stop-color="#0B52A1"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F53846"></stop>
            <stop offset="100%" stop-color="#EB2130"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v3H0zm0 12h21v3H0z"></path>
          <path fill="url(#a)" d="M0 3h21v9H0z"></path>
          <path fill="url(#c)" d="M0 4h21v7H0z"></path>
          <path
            fill="url(#a)"
            d="M7.5 10a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5Zm0-1.497 1.47 1.02-.516-1.713 1.424-1.083-1.788-.039L7.5 5l-.59 1.688-1.788.04L6.546 7.81 6.03 9.523l1.47-1.02Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="KG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F22A46"></stop>
            <stop offset="100%" stop-color="#E71834"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF04D"></stop>
            <stop offset="100%" stop-color="#FFEE35"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <circle cx="10.5" cy="7.5" r="2.5" fill="url(#c)"></circle>
          <path
            fill="url(#c)"
            d="m10.5 11.035-1.224 1.827-.31-2.177L7.071 11.8l.665-2.096-2.191.182 1.508-1.6L5 7.5l2.053-.787-1.508-1.6 2.191.183L7.071 3.2l1.895 1.115.31-2.177L10.5 3.965l1.224-1.827.31 2.177L13.929 3.2l-.665 2.096 2.191-.182-1.508 1.6L16 7.5l-2.053.787 1.508 1.6-2.191-.183.665 2.096-1.895-1.115-.31 2.177-1.224-1.827Zm0-.035a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="KI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E62B3F"></stop>
            <stop offset="100%" stop-color="#CA1A2C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFDA57"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0752A2"></stop>
            <stop offset="100%" stop-color="#034285"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v8H0z"></path>
          <circle cx="10.5" cy="8.5" r="2.5" fill="url(#c)"></circle>
          <path
            fill="url(#c)"
            d="m10.5 12.035-1.224 1.827-.31-2.177L7.071 12.8l.665-2.096-2.191.182 1.508-1.6L5 8.5l2.053-.787-1.508-1.6 2.191.183L7.071 4.2l1.895 1.115.31-2.177L10.5 4.965l1.224-1.827.31 2.177L13.929 4.2l-.665 2.096 2.191-.182-1.508 1.6L16 8.5l-2.053.787 1.508 1.6-2.191-.183.665 2.096-1.895-1.115-.31 2.177-1.224-1.827Zm0-.035a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM8.86 2.403l-.047-.234.982-.164s-1.318-.311-1.753-.467c-.625-.224-.538-.398-.538-.398s1.785.35 2.665.35c.188 0 .561.468.561.468s.649-.655.959-.677C13.095 1.178 14.61 1 14.61 1s-.44.294-.702.374c-.711.216-2.22.514-2.22.514l-.21.328h1.495l-.63.187.326.304s-.343-.178-.794-.094c-.31.058-.673.265-1.006.35-.818.211-1.309-.56-1.309-.56h-.7Z"
          ></path>
          <path fill="url(#d)" d="M0 8h21v7H0z"></path>
          <path
            fill="#FFF"
            fill-rule="nonzero"
            d="m23.322 12.933.474.159-.316.948-.474-.158-.47-.156-2.062-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688-.475.158-.316-.949.474-.158 2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687.469.156Zm0-2.5.474.159-.316.948-.474-.158-.47-.156-2.062-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688-.475.158-.316-.949.474-.158 2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687.469.156Zm0-2.5.474.159-.316.948-.474-.158-.47-.156-2.062-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688c-.36.12-.897.119-1.254 0l-2.063-.688a1.278 1.278 0 0 0-.62 0l-2.063.688-.475.158L-1 7.935l.474-.158 2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687c.153.051.467.051.621 0l2.063-.687c.357-.12.894-.12 1.254 0l2.062.687.469.156Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="KZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#30C6E0"></stop>
            <stop offset="100%" stop-color="#1CB0C9"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFCD4B"></stop>
            <stop offset="100%" stop-color="#FEC531"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <circle cx="10.5" cy="7.5" r="3" fill="url(#c)"></circle>
          <path
            fill="url(#c)"
            d="m10.5 11.035-1.224 1.827-.31-2.177L7.071 11.8l.665-2.096-2.191.182 1.508-1.6L5 7.5l2.053-.787-1.508-1.6 2.191.183L7.071 3.2l1.895 1.115.31-2.177L10.5 3.965l1.224-1.827.31 2.177L13.929 3.2l-.665 2.096 2.191-.182-1.508 1.6L16 7.5l-2.053.787 1.508 1.6-2.191-.183.665 2.096-1.895-1.115-.31 2.177-1.224-1.827Zm0-.035a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7ZM1 1.252C1 1.113 1.107 1 1.252 1h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 1.748 2h-.496A.249.249 0 0 1 1 1.748v-.496Zm0 2C1 3.113 1.107 3 1.252 3h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 1.748 4h-.496A.249.249 0 0 1 1 3.748v-.496Zm0 2C1 5.113 1.107 5 1.252 5h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 1.748 6h-.496A.249.249 0 0 1 1 5.748v-.496Zm0 2C1 7.113 1.107 7 1.252 7h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 1.748 8h-.496A.249.249 0 0 1 1 7.748v-.496Zm0 2C1 9.113 1.107 9 1.252 9h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 1 9.748v-.496Zm0 2c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 1 11.748v-.496Zm0 2c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 1 13.748v-.496Zm1-1c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 2 12.748v-.496Zm0-2c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 2 10.748v-.496Zm0-2C2 8.113 2.107 8 2.252 8h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 2.748 9h-.496A.249.249 0 0 1 2 8.748v-.496Zm0-2C2 6.113 2.107 6 2.252 6h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 2.748 7h-.496A.249.249 0 0 1 2 6.748v-.496Zm0-2C2 4.113 2.107 4 2.252 4h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 2.748 5h-.496A.249.249 0 0 1 2 4.748v-.496Zm0-2C2 2.113 2.107 2 2.252 2h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 2.748 3h-.496A.249.249 0 0 1 2 2.748v-.496Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LC">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#86D7FF"></stop>
            <stop offset="100%" stop-color="#6BCDFE"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFDA57"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M10.5 2 15 13H6z"></path>
          <path fill="url(#c)" d="m10.5 4 3.5 9H7z"></path>
          <path fill="url(#d)" d="m10.5 7 4.5 6H6z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="KY">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07319C"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#125FBA"></stop>
            <stop offset="100%" stop-color="#0C50A1"></stop>
          </linearGradient>
          <path id="d" d="M0 3.5V0h5v3.5C5 6 2.5 7 2.5 7S0 6 0 3.5Z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#c)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#c)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <ellipse cx="15.5" cy="4" fill="#FAD051" rx="1.5" ry="1"></ellipse>
          <g transform="translate(13 4)">
            <mask id="e" fill="#fff">
              <use xlink:href="#d"></use>
            </mask>
            <use xlink:href="#d" fill="url(#a)"></use>
            <path fill="#CF142C" d="M0 0h5v1H0z" mask="url(#e)"></path>
            <path fill="url(#f)" d="M0 6h5v1H0V6Zm0-2h5v1H0V4Zm0-2h5v1H0V2Z" mask="url(#e)"></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#073A88"></stop>
            <stop offset="100%" stop-color="#032A67"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E2273E"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 4h21v7H0z"></path>
          <path fill="url(#c)" d="M0 0h21v4H0zm0 11h21v4H0z"></path>
          <circle cx="10.5" cy="7.5" r="2.5" fill="url(#a)"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A3B97"></stop>
            <stop offset="100%" stop-color="#042E7D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E6273E"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v8H0z"></path>
          <path fill="url(#c)" d="M0 8h21v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LB">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F03340"></stop>
            <stop offset="100%" stop-color="#EB212E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1FC065"></stop>
            <stop offset="100%" stop-color="#17A555"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v4H0zm0 11h21v4H0z"></path>
          <path fill="url(#a)" d="M0 4h21v7H0z"></path>
          <path
            fill="url(#c)"
            d="M9.65 9.35a.497.497 0 0 0-.003-.703l.206.206a.972.972 0 0 0-.837-.232l-1.032.258c-.267.067-.3-.017-.08-.183l1.191-.892c.224-.168.184-.304-.103-.304h-.484c-.28 0-.309-.1-.064-.222l1.112-.556c.245-.123.223-.222-.064-.222h-.484c-.28 0-.323-.138-.103-.304l1.19-.892a.719.719 0 0 1 .81 0l1.19.892c.224.168.184.304-.103.304h-.484c-.28 0-.309.1-.064.222l1.112.556c.245.123.223.222-.064.222h-.484c-.28 0-.323.138-.103.304l1.19.892c.224.168.191.25-.08.183l-1.03-.258a.977.977 0 0 0-.838.232l.206-.206a.496.496 0 0 0-.003.703l.3.3c.193.193.134.35-.145.35h-2.01c-.273 0-.339-.156-.145-.35l.3-.3Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0C33B8"></stop>
            <stop offset="100%" stop-color="#05279D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1DB158"></stop>
            <stop offset="100%" stop-color="#149447"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="url(#d)"
            d="m10 7.5.342-1.025c.087-.263.228-.266.316 0L11 7.5l.861 1.291c.077.116.057.279-.055.356 0 0-.306.353-1.306.353s-1.306-.353-1.306-.353a.27.27 0 0 1-.055-.356L10 7.5Z"
          ></path>
          <path
            fill="#242424"
            fill-rule="nonzero"
            d="M10.5 7.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Zm0 0c.276 0 .5-.724.5-1a.5.5 0 1 0-1 0c0 .276.224 1 .5 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LV">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#B9414B"></stop>
            <stop offset="100%" stop-color="#9D323B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v6H0zm0 9h21v6H0z"></path>
          <path fill="url(#a)" d="M0 6h21v3H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFBF19"></stop>
            <stop offset="100%" stop-color="#FFB800"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#A52531"></stop>
            <stop offset="100%" stop-color="#8E1F29"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#03664F"></stop>
            <stop offset="100%" stop-color="#005642"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF6816"></stop>
            <stop offset="100%" stop-color="#FF5B01"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFBF18"></stop>
            <stop offset="100%" stop-color="#FFB800"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M8 1h11.25a.75.75 0 0 1 .75.755v11.49a.751.751 0 0 1-.75.755H8V1Z"></path>
          <path fill="url(#d)" d="M1 1.755A.76.76 0 0 1 1.757 1H4v13H1.757A.754.754 0 0 1 1 13.245V1.755Z"></path>
          <rect width="3" height="13" x="4" y="1" fill="url(#e)" rx=".5"></rect>
          <path
            fill="url(#f)"
            d="M9.5 3a.5.5 0 0 1-.5-.5V2h.5a.5.5 0 0 1 0 1Zm9 0a.5.5 0 1 1 0-1h.5v.5a.5.5 0 0 1-.5.5Zm0 9a.5.5 0 0 1 .5.5v.5h-.5a.5.5 0 1 1 0-1Zm-9 0a.5.5 0 1 1 0 1H9v-.5a.5.5 0 0 1 .5-.5ZM12 9.5c0-.276-.227-.5-.5-.5h.5a3.04 3.04 0 0 1-.975-.185S10 8.5 10 8c0-.5.203-.614.203-.614.164-.213.215-.588.112-.86 0 0-.415-.926-.315-1.526.1-.6.57-.749.57-.749.238-.139.43-.035.43.244v2.01c0 .273.193.591.453.722l.094.046c.25.126.611.069.806-.126l-.206.206c.195-.195.16-.45-.1-.58L11.5 6.5V6h.5c.276 0 .307-.096.047-.227L11.5 5.5V5h.5c.276 0 .658-.158.853-.353l-.206.206c.195-.195.585-.353.853-.353.276 0 .596.193.727.453l.046.094c.126.25.157.662.069.928l-.184.55c-.087.263.073.475.348.475h1.488c.28 0 .664-.158.859-.353l-.206.206c.195-.195.16-.45-.1-.58l-.094-.046A2.566 2.566 0 0 0 15.5 6a.505.505 0 0 1-.5-.5c0-.276.158-.658.353-.853L15.5 4.5V5c0 .276.227.5.5.5h-.5 1c.276 0 .596.193.727.453l.046.094c.126.25.247.673.264.947 0 0 .069.476-.037 1.006-.106.53-.226.589-.226.589a1.898 1.898 0 0 0-.274.916v.99a.508.508 0 0 1-.5.505c-.276 0-.404-.193-.273-.453l.046-.094a1.12 1.12 0 0 0 0-.906l-.046-.094C16.1 9.203 16 9.232 16 9.5c0 .276-.096.693-.227.953l-.046.094c-.126.25-.459.453-.727.453-.276 0-.404-.193-.273-.453l.046-.094c.126-.25.227-.685.227-.953 0-.276-.214-.5-.505-.5h-.99a.508.508 0 0 0-.505.5c0 .276-.096.693-.227.953l-.046.094c-.126.25-.459.453-.727.453-.276 0-.404-.193-.273-.453l.046-.094c.126-.25.227-.685.227-.953Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E33B44"></stop>
            <stop offset="100%" stop-color="#C02A32"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="#0A6135"
            fill-rule="nonzero"
            d="m10.5 9.255-2.645 1.886.976-3.099L6.22 6.11l3.247-.029L10.5 3l1.032 3.08 3.248.03-2.61 1.932.975 3.099L10.5 9.255Zm0-1.228.794.566-.293-.93.784-.58-.975-.01-.31-.924-.31.925-.975.008.784.58-.293.931.794-.566Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="LR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E1244A"></stop>
            <stop offset="100%" stop-color="#BE1134"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0C3F8E"></stop>
            <stop offset="100%" stop-color="#032A67"></stop>
          </linearGradient>
          <filter id="e" width="108.3%" height="116.7%" x="-4.2%" y="-4.2%" filterUnits="objectBoundingBox">
            <feOffset dy=".5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <path
            id="d"
            d="M5 6.17 3.237 7.427l.65-2.065-1.74-1.289 2.165-.02L5 2l.688 2.053 2.165.02-1.74 1.289.65 2.065z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v2H10V0Zm0 4h11v2H10V4Zm0 4h11v2H10V8ZM0 12h21v2H0v-2Z"></path>
          <path fill="url(#c)" d="M0 0h10v10H0z"></path>
          <use xlink:href="#d" fill="#000" filter="url(#e)"></use>
          <use xlink:href="#d" fill="url(#a)"></use>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MC">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EA233B"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v8H0z"></path>
          <path fill="url(#a)" d="M0 8h21v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F14455"></stop>
            <stop offset="100%" stop-color="#EB2D3F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#29B4EE"></stop>
            <stop offset="100%" stop-color="#1AA3DC"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="MD">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EB1C43"></stop>
            <stop offset="100%" stop-color="#CA1134"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#115BCB"></stop>
            <stop offset="100%" stop-color="#094AAC"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD953"></stop>
            <stop offset="100%" stop-color="#FFD130"></stop>
          </linearGradient>
          <filter id="e" width="121.4%" height="110%" x="-10.7%" y="-5%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius=".25" result="shadowSpreadOuter1"></feMorphology>
            <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <path id="d" d="M7 0h7v15H7z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <use xlink:href="#d" fill="#000" filter="url(#e)"></use>
          <use xlink:href="#d" fill="url(#f)"></use>
          <path fill="#AF7F59" d="M9 6h1l.5-1.5L11 6h1v3l-1.5 1L9 9V6Zm1 1v1.5h1V7h-1Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MF">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F44653"></stop>
            <stop offset="100%" stop-color="#EE2A39"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1035BB"></stop>
            <stop offset="100%" stop-color="#042396"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#118357"></stop>
            <stop offset="100%" stop-color="#0B6A45"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D8343D"></stop>
            <stop offset="100%" stop-color="#C02A32"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FEC34B"></stop>
            <stop offset="100%" stop-color="#FCB931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#d)" d="M0 0h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ME">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E6BE53"></stop>
            <stop offset="100%" stop-color="#D3AD46"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E01826"></stop>
            <stop offset="100%" stop-color="#C30A17"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <rect width="19" height="13" x="1" y="1" fill="url(#c)" rx=".75"></rect>
          <path
            fill="url(#b)"
            d="M10.147 5.147a.5.5 0 0 0 .706 0l-.206.206L11.65 4.35a.729.729 0 0 1 .803-.123l.094.046c.25.126.295.385.1.58l.206-.206L11.85 5.65a.729.729 0 0 0-.123.803l.046.094c.126.25.227.68.227.953V7c0 .276.193.404.453.273l.094-.046c.25-.126.295-.385.1-.58l.206.206a.499.499 0 0 1 0-.706l-.206.206a3.64 3.64 0 0 0 .58-.806l.046-.094c.126-.25.28-.667.348-.937l.258-1.032c.067-.267.26-.3.425-.08l.892 1.191c.168.224.304.619.304.91v.99c0 .279-.096.698-.227.958l-.046.094a3.69 3.69 0 0 1-.577.803l-.3.3a3.62 3.62 0 0 1-.803.577l-.094.046c-.25.126-.685.227-.953.227-.276 0-.307.096-.047.227l.094.046c.25.126.611.385.806.58l-.206-.206a.5.5 0 0 0 .706 0l-.206.206a.499.499 0 0 1 .706 0l-.206-.206a.732.732 0 0 1 .126.806l-.046.094c-.126.25-.459.453-.727.453a2.48 2.48 0 0 1-.953-.227l-.094-.046a1.74 1.74 0 0 1-.68-.68l-.046-.094c-.126-.25-.385-.295-.58-.1l.206-.206a.63.63 0 0 0-.08.763l.454.68c.15.226.09.533-.137.683l-.68.454a.8.8 0 0 1-.82 0l-.68-.454a.493.493 0 0 1-.137-.683l.454-.68a.63.63 0 0 0-.08-.763l.206.206c-.195-.195-.45-.16-.58.1l-.046.094c-.126.25-.42.55-.68.68l-.094.046c-.25.126-.685.227-.953.227a.876.876 0 0 1-.727-.453l-.046-.094a.744.744 0 0 1 .126-.806l-.206.206a.499.499 0 0 1 .706 0l-.206-.206a.5.5 0 0 0 .706 0l-.206.206a3.64 3.64 0 0 1 .806-.58l.094-.046c.25-.126.221-.227-.047-.227a2.48 2.48 0 0 1-.953-.227l-.094-.046a3.69 3.69 0 0 1-.803-.577l-.3-.3a3.62 3.62 0 0 1-.577-.803l-.046-.094a2.488 2.488 0 0 1-.227-.958v-.99c0-.279.138-.69.304-.91l.892-1.19c.168-.224.358-.191.425.08l.258 1.03a5.4 5.4 0 0 0 .348.938l.046.094c.126.25.385.611.58.806l-.206-.206a.499.499 0 0 1 0 .706l.206-.206c-.195.195-.16.45.1.58l.094.046C8.797 7.4 9 7.273 9 7v.5c0-.276.096-.693.227-.953l.046-.094a.74.74 0 0 0-.123-.803L8.147 4.647l.206.206c-.195-.195-.16-.45.1-.58l.094-.046a.74.74 0 0 1 .803.123l1.003 1.003-.206-.206ZM9.35 3.35c-.193-.193-.141-.42.125-.508l.55-.184c.263-.087.684-.088.95 0l.55.184c.263.087.319.314.125.508l-.3.3a1.4 1.4 0 0 1-.85.35c-.276 0-.656-.156-.85-.35l-.3-.3Z"
          ></path>
          <path
            fill="#215F90"
            d="M9.5 9.006c0 .273.076.285.185.02C9.685 9.025 10 8 10.5 8c.5 0 .823 1.042.823 1.042.098.253.177.236.177-.047V8.5c0-.828-.448-1.5-1-1.5s-1 .672-1 1.5v.506Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#149047"></stop>
            <stop offset="100%" stop-color="#0F7E3D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F84F4B"></stop>
            <stop offset="100%" stop-color="#FA3F3B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#c)" d="M0 0h21v7H0z"></path>
          <path fill="url(#a)" d="M0 0h7v15H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MH">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#064DAE"></stop>
            <stop offset="100%" stop-color="#003D91"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F18D36"></stop>
            <stop offset="100%" stop-color="#DB761E"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M21 0v4L0 15z"></path>
          <path
            fill="url(#a)"
            d="M21 8V4L0 15zM4.839 4.372 4.5 2l-.339 2.372-.911-1.037.468 1.383-1.383-.468 1.037.911L1 5.5l2.372.339-1.037.911 1.383-.468-.468 1.383.911-1.037L4.5 9l.339-2.372.911 1.037-.468-1.383 1.383.468-1.037-.911L8 5.5l-2.372-.339 1.037-.911-1.383.468.468-1.383-.911 1.037Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="LY">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#34B857"></stop>
            <stop offset="100%" stop-color="#2B9E4A"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F41F34"></stop>
            <stop offset="100%" stop-color="#E60B21"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#d)" d="M0 0h21v5H0z"></path>
          <path
            fill="url(#a)"
            d="M11.334 6.253a1.25 1.25 0 1 0 0 2.495 1.5 1.5 0 1 1 0-2.495ZM11.5 8a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E81B26"></stop>
            <stop offset="100%" stop-color="#D00914"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFE94F"></stop>
            <stop offset="100%" stop-color="#FFE633"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M-.004-.002h21v15h-21z"></path>
          <circle cx="10.496" cy="7.498" r="2.5" fill="url(#c)"></circle>
          <path
            fill="url(#c)"
            d="m13.961 7.993 7.035 1.005v-3l-7.035 1.005a3.53 3.53 0 0 1 0 .99Zm-6.93-.99L-.004 5.998v3l7.035-1.005a3.53 3.53 0 0 1 0-.99Zm4.152-2.938.813-4.067h-3l.814 4.067a3.517 3.517 0 0 1 1.373 0ZM9.81 10.931l-.814 4.067h3l-.813-4.067a3.517 3.517 0 0 1-1.373 0ZM7.652 9.539-.54 15.417l2.007 2.229 6.703-7.533a3.52 3.52 0 0 1-.518-.574Zm5.688-4.082L21.532-.42l-2.007-2.23-6.702 7.533c.192.172.366.364.517.574Zm-.517 4.656 6.702 7.533 2.007-2.23L13.34 9.54a3.52 3.52 0 0 1-.517.574ZM8.17 4.883 1.467-2.65-.54-.42l8.192 5.877a3.52 3.52 0 0 1 .518-.574Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ML">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E2233A"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2ECB4D"></stop>
            <stop offset="100%" stop-color="#24B441"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD749"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F13D4F"></stop>
            <stop offset="100%" stop-color="#E92C3F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#4AC94B"></stop>
            <stop offset="100%" stop-color="#3BB13C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD043"></stop>
            <stop offset="100%" stop-color="#FECA2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="M0 0h21v5H0z"></path>
          <path
            fill="url(#a)"
            d="m10.5 9.255-2.645 1.886.976-3.099L6.22 6.109l3.248-.029L10.5 3l1.032 3.08 3.248.029-2.611 1.933.976 3.099z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MP">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1E8BD6"></stop>
            <stop offset="100%" stop-color="#1074BA"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#A9A7A9"></stop>
            <stop offset="100%" stop-color="#8C8A8C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M10.5 12.5a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0-1a4 4 0 1 1 0-8 4 4 0 0 1 0 8Z"
          ></path>
          <path
            fill="url(#c)"
            d="M8.938 5.997C8.972 5.447 9.443 5 9.999 5h1.002c.552 0 1.027.453 1.061.997l.376 6.006a.927.927 0 0 1-.947.997H9.509a.935.935 0 0 1-.947-.997l.376-6.006Z"
          ></path>
          <path
            fill="url(#a)"
            d="m10.5 9.515-2.057 1.467.759-2.41-2.031-1.504 2.527-.022.802-2.396.802 2.396 2.527.022-2.031 1.504.759 2.41z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#079D7B"></stop>
            <stop offset="100%" stop-color="#01795E"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M2.452 6.902c.143.038.284.07.423.098H.5c.119.356.278.691.473 1h7.054A4.61 4.61 0 0 0 8.5 7H6.093c.143-.027.289-.059.437-.097C6.076 6.918 5.336 7 4.5 7c-.847 0-1.596-.084-2.048-.098Zm-.417-.125C.915 6.398.146 5.792.267 5.34c.134-.503 1.325-.62 2.659-.263.07.018.139.038.206.059a4.342 4.342 0 0 1-.046-.637C3.086 3.12 3.72 2 4.5 2c.78 0 1.414 1.12 1.414 2.5 0 .219-.016.431-.046.634.077-.024.155-.047.234-.068 1.334-.357 2.524-.24 2.659.264.122.454-.66 1.067-1.797 1.445C6.764 6.18 5.737 6 4.5 6c-1.238 0-2.266.18-2.465.777ZM7.166 9c-.728.625-1.656 1-2.666 1a4.076 4.076 0 0 1-2.666-1h5.332Z"
            transform="translate(6 2)"
          ></path>
          <path
            fill="#FCD117"
            d="M10.5 3a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-4 2.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm8 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM13 4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM8 4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MQ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#345CB3"></stop>
            <stop offset="100%" stop-color="#23448D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M15.917 1.603a4.37 4.37 0 0 1 .47.008c.207.015.352.061.341.018-.017-.067-.005-.084-.029-.067-.05.038.025-.007-.278.167-.442.253-.634.445-.537.791.085.304.31.387.839.47l.07.011c.211.033.306.053.369.081.014.006-.013-.037-.005-.064-.007.023-.148.078-.5.148l-.176.034c-.68.14-1.02.32-1.07.79-.055.516.479.875 1.15.963.685.09 1.28-.136 1.341-.692.039-.354-.207-.565-.596-.643-.264-.053-.611-.052-1.028-.011a11.378 11.378 0 0 0-1.386.235.25.25 0 1 0 .116.486 10.906 10.906 0 0 1 1.32-.223c.371-.037.675-.038.88.003.167.033.201.063.197.099-.02.19-.335.309-.779.25-.436-.057-.734-.257-.718-.413.017-.16.201-.257.673-.354l.172-.034c.582-.114.794-.198.883-.496.073-.244-.048-.436-.272-.535-.12-.053-.235-.078-.495-.118l-.069-.01c-.301-.048-.43-.096-.434-.112-.005-.015.068-.088.303-.222l.164-.094a1.87 1.87 0 0 0 .161-.103c.173-.126.269-.268.218-.463-.07-.273-.34-.357-.786-.39a4.847 4.847 0 0 0-.526-.01l-.075.003a.25.25 0 0 0 .029.5l.063-.003Zm-11.6 0a4.37 4.37 0 0 1 .47.008c.207.015.352.061.341.018-.017-.067-.005-.084-.029-.067-.05.038.025-.007-.278.167-.442.253-.634.445-.537.791.085.304.31.387.839.47l.07.011c.211.033.306.053.369.081.014.006-.013-.037-.005-.064-.007.023-.148.078-.5.148L4.88 3.2c-.68.14-1.02.32-1.07.79-.055.516.479.875 1.15.963.685.09 1.28-.136 1.341-.692.039-.354-.207-.565-.596-.643-.264-.053-.611-.052-1.028-.011a11.378 11.378 0 0 0-1.386.235.25.25 0 1 0 .116.486 10.906 10.906 0 0 1 1.32-.223c.371-.037.675-.038.88.003.167.033.201.063.197.099-.02.19-.335.309-.779.25-.436-.057-.734-.257-.718-.413.017-.16.201-.257.673-.354l.172-.034c.582-.114.794-.198.883-.496.073-.244-.048-.436-.272-.535-.12-.053-.235-.078-.495-.118l-.069-.01c-.301-.048-.43-.096-.434-.112-.005-.015.068-.088.303-.222l.164-.094a1.87 1.87 0 0 0 .161-.103c.173-.126.269-.268.218-.463-.07-.273-.34-.357-.786-.39a4.847 4.847 0 0 0-.526-.01l-.075.003a.25.25 0 0 0 .029.5l.063-.003Zm11.6 9a4.37 4.37 0 0 1 .47.008c.207.015.352.061.341.018-.017-.067-.005-.084-.029-.067-.05.038.025-.007-.278.167-.442.253-.634.445-.537.791.085.304.31.387.839.47l.07.011c.211.033.306.053.369.081.014.006-.013-.037-.005-.064-.007.023-.148.078-.5.148l-.176.034c-.68.14-1.02.32-1.07.79-.055.516.479.875 1.15.963.685.09 1.28-.136 1.341-.692.039-.354-.207-.565-.596-.643-.264-.053-.611-.052-1.028-.011a11.378 11.378 0 0 0-1.386.235.25.25 0 0 0 .116.486 10.906 10.906 0 0 1 1.32-.223c.371-.037.675-.038.88.003.167.033.201.063.197.099-.02.19-.335.309-.779.25-.436-.057-.734-.257-.718-.413.017-.16.201-.257.673-.354l.172-.034c.582-.114.794-.198.883-.496.073-.244-.048-.436-.272-.535-.12-.053-.235-.078-.495-.118l-.069-.01c-.301-.048-.43-.096-.434-.112-.005-.015.068-.088.303-.222l.164-.094a1.87 1.87 0 0 0 .161-.103c.173-.126.269-.268.218-.463-.07-.273-.34-.357-.786-.39a4.847 4.847 0 0 0-.526-.01l-.075.003a.25.25 0 0 0 .029.5l.063-.003Zm-11.6 0a4.37 4.37 0 0 1 .47.008c.207.015.352.061.341.018-.017-.067-.005-.084-.029-.067-.05.038.025-.007-.278.167-.442.253-.634.445-.537.791.085.304.31.387.839.47l.07.011c.211.033.306.053.369.081.014.006-.013-.037-.005-.064-.007.023-.148.078-.5.148l-.176.034c-.68.14-1.02.32-1.07.79-.055.516.479.875 1.15.963.685.09 1.28-.136 1.341-.692.039-.354-.207-.565-.596-.643-.264-.053-.611-.052-1.028-.011a11.378 11.378 0 0 0-1.386.235.25.25 0 0 0 .116.486 10.906 10.906 0 0 1 1.32-.223c.371-.037.675-.038.88.003.167.033.201.063.197.099-.02.19-.335.309-.779.25-.436-.057-.734-.257-.718-.413.017-.16.201-.257.673-.354l.172-.034c.582-.114.794-.198.883-.496.073-.244-.048-.436-.272-.535-.12-.053-.235-.078-.495-.118l-.069-.01c-.301-.048-.43-.096-.434-.112-.005-.015.068-.088.303-.222l.164-.094a1.87 1.87 0 0 0 .161-.103c.173-.126.269-.268.218-.463-.07-.273-.34-.357-.786-.39a4.847 4.847 0 0 0-.526-.01l-.075.003a.25.25 0 0 0 .029.5l.063-.003Z"
          ></path>
          <path fill="url(#a)" d="M9 6H0v3h9v6h3V9h9V6h-9V0H9v6Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#108B4D"></stop>
            <stop offset="100%" stop-color="#0A6135"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFC941"></stop>
            <stop offset="100%" stop-color="#FFC42E"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#c)"
            d="M14.86 5.8a4.5 4.5 0 1 1-8.89 0 4.501 4.501 0 0 0 8.89 0Zm-4.36.623-1.236.881.456-1.448-1.22-.903 1.518-.014L10.5 3.5l.482 1.44 1.518.013-1.22.903.456 1.448-1.236-.88Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="MS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07319C"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#08B9D6"></stop>
            <stop offset="100%" stop-color="#00A3BE"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <path id="d" d="M0 3.5V1c0-.553.444-1 1-1h3c.552 0 1 .441 1 1v2.5C5 6 2.5 7 2.5 7S0 6 0 3.5Z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#c)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#c)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <g transform="translate(13 4)">
            <mask id="f" fill="#fff">
              <use xlink:href="#d"></use>
            </mask>
            <use xlink:href="#d" fill="url(#e)"></use>
            <path fill="#A63D09" d="M0 5h5v2H0z" mask="url(#f)"></path>
            <path fill="url(#g)" d="M3 2V1H2v1H1v1h1v2h1V3h1V2H3Z" mask="url(#f)"></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="MT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DE233C"></stop>
            <stop offset="100%" stop-color="#CD1931"></stop>
          </linearGradient>
          <path id="c" d="M4 3V2H3v1H2v1h1v1h1V4h1V3H4Z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M11 0h10v15H11z"></path>
          <path fill="url(#a)" d="M0 0h11v15H0z"></path>
          <use xlink:href="#c" fill="#CCCCCD"></use>
          <path
            stroke="#7B716A"
            stroke-opacity=".66"
            stroke-width=".5"
            d="M4.25 2.75h1v1.5h-1v1h-1.5v-1h-1v-1.5h1v-1h1.5v1Z"
          ></path>
          <circle cx="3.5" cy="3.5" r="1" fill="#7B716A"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1DBB63"></stop>
            <stop offset="100%" stop-color="#17A455"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#222B82"></stop>
            <stop offset="100%" stop-color="#1B236C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD741"></stop>
            <stop offset="100%" stop-color="#FFD430"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F4374A"></stop>
            <stop offset="100%" stop-color="#E92C3F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 12h21v3H0z"></path>
          <path fill="url(#c)" d="M0 4h21v4H0z"></path>
          <path fill="url(#d)" d="M0 8h21v4H0z"></path>
          <path fill="url(#e)" d="M0 0h21v4H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MV">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F32249"></stop>
            <stop offset="100%" stop-color="#D01739"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#15A04F"></stop>
            <stop offset="100%" stop-color="#0F7E3D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <rect width="15" height="9" x="3" y="3" fill="url(#c)" rx=".5"></rect>
          <path fill="url(#a)" d="M12.25 4.08a3.5 3.5 0 1 0 0 6.839 3.501 3.501 0 0 1 0-6.838Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E42038"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#47B849"></stop>
            <stop offset="100%" stop-color="#399E3B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <circle cx="10.5" cy="5.5" r="3.5" fill="url(#c)"></circle>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="M0 10h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MX">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E3283E"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#128A60"></stop>
            <stop offset="100%" stop-color="#0B6848"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
          <path
            fill="#8C9157"
            fill-rule="nonzero"
            d="M8 7a2.5 2.5 0 0 0 1.247 2.164.5.5 0 0 0 .502-.865A1.499 1.499 0 0 1 9 7a.5.5 0 0 0-1 0Zm3.846 2.107A2.498 2.498 0 0 0 13 7a.5.5 0 1 0-1 0 1.5 1.5 0 0 1-.693 1.265.5.5 0 1 0 .539.842Z"
          ></path>
          <ellipse cx="10.5" cy="6.5" fill="#C59262" rx="1" ry="1.5"></ellipse>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MY">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E1244A"></stop>
            <stop offset="100%" stop-color="#BE1134"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0C3F8E"></stop>
            <stop offset="100%" stop-color="#032A67"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD34F"></stop>
            <stop offset="100%" stop-color="#FFCB2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#b)"
            d="M10 0h11v1H10V0Zm0 2h11v1H10V2Zm0 2h11v1H10V4Zm0 2h11v1H10V6ZM0 8h21v1H0V8Zm0 2h21v1H0v-1Zm0 2h21v1H0v-1Zm0 2h21v1H0v-1Z"
          ></path>
          <path fill="url(#c)" d="M0 0h12v8H0z"></path>
          <path
            fill="url(#d)"
            d="M6.874 1.657a2.5 2.5 0 1 0 0 4.686 3 3 0 1 1 0-4.686ZM8 4.82l-.868.982.227-1.29-1.309-.067 1.15-.627-.764-1.065 1.208.508L8 2l.356 1.261 1.208-.508-.765 1.065 1.15.627-1.308.066.227 1.29L8 4.82Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="MZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFE547"></stop>
            <stop offset="100%" stop-color="#FCE032"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#118C81"></stop>
            <stop offset="100%" stop-color="#0D7168"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EF2147"></stop>
            <stop offset="100%" stop-color="#D01739"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FDE444"></stop>
            <stop offset="100%" stop-color="#FCE032"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 11h21v4H0z"></path>
          <path fill="url(#c)" d="M0 0h21v4H0z"></path>
          <path fill="url(#a)" d="M0 4h21v7H0z"></path>
          <path fill="url(#d)" d="M0 5h21v5H0z"></path>
          <path fill="url(#e)" d="m0 0 10 7.5L0 15z"></path>
          <path
            fill="url(#f)"
            d="M3.5 8.456 2.031 9.523l.56-1.728-1.469-1.068h1.816L3.5 5l.562 1.727h1.816L4.409 7.795l.56 1.728z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="NA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0C4799"></stop>
            <stop offset="100%" stop-color="#05387E"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD243"></stop>
            <stop offset="100%" stop-color="#FFCD2F"></stop>
          </linearGradient>
          <linearGradient id="j" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1BAC55"></stop>
            <stop offset="100%" stop-color="#149447"></stop>
          </linearGradient>
          <linearGradient id="m" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E52347"></stop>
            <stop offset="100%" stop-color="#D01739"></stop>
          </linearGradient>
          <filter id="c" width="107.1%" height="115%" x="-3.6%" y="-7.5%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius=".25" result="shadowSpreadOuter1"></feMorphology>
            <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <filter id="f" width="112.5%" height="125%" x="-6.2%" y="-6.2%" filterUnits="objectBoundingBox">
            <feOffset dy=".5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <filter id="i" width="107.1%" height="115%" x="-3.6%" y="-7.5%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius=".25" result="shadowSpreadOuter1"></feMorphology>
            <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <filter id="l" width="106.2%" height="107.9%" x="-3.1%" y="-3.9%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius=".25" result="shadowSpreadOuter1"></feMorphology>
            <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <path id="b" d="m3.121 12.304 21-10h-21z"></path>
          <path
            id="e"
            d="m6.621 6.804-.765.848.058-1.141-1.14.058.847-.765-.847-.765 1.14.058-.058-1.141.765.848.766-.848-.058 1.141 1.14-.058-.848.765.848.765-1.14-.058.058 1.141z"
          ></path>
          <path id="h" d="M3.121 17.304h21v-10z"></path>
          <path id="k" d="M5.433 19.304 25.75 6.609 21.81.304 1.493 12.999z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <g transform="translate(-3.12 -2.3)">
            <use xlink:href="#b" fill="#000" filter="url(#c)"></use>
            <use xlink:href="#b" fill="url(#d)"></use>
          </g>
          <g transform="translate(-3.12 -2.3)">
            <use xlink:href="#e" fill="#000" filter="url(#f)"></use>
            <use xlink:href="#e" fill="url(#g)"></use>
          </g>
          <g transform="translate(-3.12 -2.3)">
            <use xlink:href="#h" fill="#000" filter="url(#i)"></use>
            <use xlink:href="#h" fill="url(#j)"></use>
          </g>
          <g transform="translate(-3.12 -2.3)">
            <use xlink:href="#k" fill="#000" filter="url(#l)"></use>
            <use xlink:href="#k" fill="url(#a)"></use>
          </g>
          <path fill="url(#m)" d="M2.65 19.608 27.243 4.24 24.593 0 0 15.368z" transform="translate(-3.12 -2.3)"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NC">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#094CC7"></stop>
            <stop offset="100%" stop-color="#003CAB"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2AAD55"></stop>
            <stop offset="100%" stop-color="#219447"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F65D55"></stop>
            <stop offset="100%" stop-color="#E9443C"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FAE749"></stop>
            <stop offset="100%" stop-color="#FBE533"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#d)" d="M0 5h21v5H0z"></path>
          <circle cx="10.5" cy="7.5" r="3.5" fill="url(#e)"></circle>
          <path
            fill="url(#f)"
            d="M10.092 6.211a.5.5 0 1 0 .514-.2c.048-.024.096-.05.144-.078.598-.345.97-.819.833-1.058-.139-.24-.735-.153-1.333.192s-.97.819-.833 1.058c.086.148.347.171.675.086ZM10.5 10.5c-.828 0-1-.724-1-1s.172-.5 1-.5c.828 0 1 .224 1 .5s-.172 1-1 1Zm0-1.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0-1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F0642F"></stop>
            <stop offset="100%" stop-color="#DF531D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2DCC45"></stop>
            <stop offset="100%" stop-color="#1FAF35"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E85C27"></stop>
            <stop offset="100%" stop-color="#DF531D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <circle cx="10.5" cy="7.5" r="2" fill="url(#d)"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NF">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#219646"></stop>
            <stop offset="100%" stop-color="#197837"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#259D4B"></stop>
            <stop offset="100%" stop-color="#197837"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10zM0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M6 0h9v15H6z"></path>
          <path
            fill="url(#c)"
            d="m9.444 4.003.422-1.52A.705.705 0 0 1 10.5 2a.7.7 0 0 1 .634.484l.422 1.52a.5.5 0 1 0 .248.893l.31 1.116a.501.501 0 0 0-.614.487.5.5 0 0 0 .85.358l.325 1.174a.499.499 0 1 0 .217.779L13.5 11H11v2h-1v-2H7.5l.608-2.19a.5.5 0 1 0 .217-.778l.326-1.174A.498.498 0 0 0 9.5 6.5a.5.5 0 0 0-.615-.487l.31-1.116a.5.5 0 1 0 .248-.893Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#189B62"></stop>
            <stop offset="100%" stop-color="#118653"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10zM0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1A78D6"></stop>
            <stop offset="100%" stop-color="#106AC4"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0zm0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="#DBCD92"
            fill-rule="nonzero"
            d="M10.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 .5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
          ></path>
          <path fill="#9CDDEE" d="m10.5 6.5 1 2h-2z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NL">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#CA2B39"></stop>
            <stop offset="100%" stop-color="#AC1F2C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2C56A2"></stop>
            <stop offset="100%" stop-color="#244889"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F14247"></stop>
            <stop offset="100%" stop-color="#ED2F35"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A3A85"></stop>
            <stop offset="100%" stop-color="#032A67"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
          <path fill="url(#c)" d="M0 8h7v7h1V8h13V7H8V0H7v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="NP">
        <defs>
          <path
            id="a"
            d="M0 0h1.495c.279 0 .693.126.918.275L13.175 7.45c.456.304.372.55-.172.55H6l7.247 6.341c.416.364.303.659-.254.659H0V0Z"
          ></path>
        </defs>
        <defs>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EE1B44"></stop>
            <stop offset="100%" stop-color="#DD153C"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0543A8"></stop>
            <stop offset="100%" stop-color="#003893"></stop>
          </linearGradient>
          <use xlink:href="#a" id="d"></use>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <mask id="c" fill="#fff">
            <use xlink:href="#a"></use>
          </mask>
          <use xlink:href="#a" fill="url(#b)"></use>
          <g mask="url(#c)">
            <use xlink:href="#d" fill="url(#e)"></use>
            <path stroke="url(#f)" d="M.5.5v14h12.17l-8-7h7.679L2.136.691A1.483 1.483 0 0 0 1.496.5H.5Z"></path>
          </g>
          <path
            fill="url(#b)"
            d="M5.138 5.85a3.52 3.52 0 0 0 .789-.318 2 2 0 0 1-3.857 0c.236.132.502.24.791.32L3.25 5.5l-.636-.574.856.044-.044-.856L4 4.75l.574-.636-.044.856.856-.044-.636.574.388.35ZM4 12l-.765.848.058-1.14-1.14.057L3 11l-.848-.765 1.14.058-.057-1.14L4 10l.765-.848-.058 1.14 1.14-.057L5 11l.848.765-1.14-.058.057 1.14L4 12Z"
            mask="url(#c)"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0744A7"></stop>
            <stop offset="100%" stop-color="#00307D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FCC747"></stop>
            <stop offset="100%" stop-color="#FEC539"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 6h21v2H0z"></path>
          <path
            fill="url(#a)"
            d="m5.5 12.25-.773 1.128.038-1.367-1.288.458.834-1.083L3 11l1.311-.386-.834-1.083 1.288.458-.038-1.367L5.5 9.75l.773-1.128-.038 1.367 1.288-.458-.834 1.083L8 11l-1.311.386.834 1.083-1.288-.458.038 1.367z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FCD54E"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#053C8A"></stop>
            <stop offset="100%" stop-color="#002B67"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FDD650"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 0h9v7H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#d)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#d)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <circle cx="4.5" cy="3.5" r="1" fill="url(#c)"></circle>
          <path
            fill="url(#e)"
            d="M4.5 4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-4 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2-2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="NZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A17A7"></stop>
            <stop offset="100%" stop-color="#030E88"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#c)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#c)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
          <path
            fill="#CA1931"
            d="m15 13-.707.207.207-.707-.207-.707L15 12l.707-.207-.207.707.207.707zm0-9.5-.707.207L14.5 3l-.207-.707L15 2.5l.707-.207L15.5 3l.207.707zm3 3-.707.207L17.5 6l-.207-.707L18 5.5l.707-.207L18.5 6l.207.707zm-6 1-.707.207L11.5 7l-.207-.707L12 6.5l.707-.207L12.5 7l.207.707z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="OM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#138E16"></stop>
            <stop offset="100%" stop-color="#0F7F12"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#ED2B35"></stop>
            <stop offset="100%" stop-color="#D91B25"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 15h7v-5h14V5H7V0H0z"></path>
          <path
            fill="url(#a)"
            d="m3.5 3.534-.868 1.268.451-1.469-1.533.112 1.43-.564-1.044-1.128 1.332.766L3.5 1l.232 1.519 1.332-.766L4.02 2.881l1.43.564-1.533-.112.451 1.469zM7 0h14v5H7z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E52448"></stop>
            <stop offset="100%" stop-color="#D01739"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1367AE"></stop>
            <stop offset="100%" stop-color="#0A5492"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v7H0z"></path>
          <path fill="url(#c)" d="M0 7h21v8H0z"></path>
          <path fill="url(#a)" d="M0 7V0h10v7H0Zm10 8V7h11v8H10Z"></path>
          <path
            fill="url(#c)"
            d="m5 4.32-1.176.798.396-1.365-1.122-.871 1.42-.045L5 1.5l.482 1.337 1.42.045-1.122.871.396 1.365z"
          ></path>
          <path
            fill="url(#b)"
            d="m15.5 11.82-1.176.798.396-1.365-1.122-.871 1.42-.045L15.5 9l.482 1.337 1.42.045-1.122.871.396 1.365z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E82438"></stop>
            <stop offset="100%" stop-color="#D7172B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10zM0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="PF">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E02639"></stop>
            <stop offset="100%" stop-color="#CA1A2C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DC2235"></stop>
            <stop offset="100%" stop-color="#CA1A2C"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFA135"></stop>
            <stop offset="100%" stop-color="#FD9C2D"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DF2034"></stop>
            <stop offset="100%" stop-color="#CA1A2C"></stop>
          </linearGradient>
          <linearGradient id="h" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0B4BAD"></stop>
            <stop offset="100%" stop-color="#08429A"></stop>
          </linearGradient>
          <circle id="d" cx="2.5" cy="2.5" r="2.5"></circle>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v4H0z"></path>
          <path fill="url(#c)" d="M0 11h21v4H0z"></path>
          <path fill="url(#a)" d="M0 4h21v7H0z"></path>
          <g transform="translate(8 5)">
            <mask id="f" fill="#fff">
              <use xlink:href="#d"></use>
            </mask>
            <path fill="url(#e)" d="M0 0h5v2.5H0z" mask="url(#f)"></path>
            <path fill="#FFF" d="M1 1.5h3l-.5 1h-2z" mask="url(#f)"></path>
            <path
              fill="url(#g)"
              d="M2 0h1v1.495A.508.508 0 0 1 2.5 2a.495.495 0 0 1-.5-.505V0ZM1 1s.75 1.5 1.5 1.5S4 1 4 1v1c0 .552-.443 1-.999 1H1.999A.997.997 0 0 1 1 2V1Z"
              mask="url(#f)"
            ></path>
            <path fill="url(#h)" d="M0 3h5v2H0z" mask="url(#f)"></path>
            <path fill="#FFF" d="M0 3.5h5V4H0z" mask="url(#f)"></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E8283F"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD84E"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 0h21v15z"></path>
          <path
            fill="url(#a)"
            d="m5 12.5-.707.207L4.5 12l-.207-.707L5 11.5l.707-.207L5.5 12l.207.707zm0-6-.707.207L4.5 6l-.207-.707L5 5.5l.707-.207L5.5 6l.207.707zM2.5 9l-.707.207L2 8.5l-.207-.707L2.5 8l.707-.207L3 8.5l.207.707zM7 8.5l-.707.207L6.5 8l-.207-.707L7 7.5l.707-.207L7.5 8l.207.707z"
          ></path>
          <path
            fill="url(#d)"
            d="M14.146 6.95a.49.49 0 0 1-.217-.377V5.65c0-.136-.098-.213-.246-.164l-.568.19a.87.87 0 0 1-.492 0l-.57-.19c-.135-.045-.15-.14-.028-.212l1.334-.8a.322.322 0 0 0 .135-.377l-.19-.568c-.045-.136.016-.214.164-.164l.569.19a.332.332 0 0 0 .376-.136l.8-1.334c.072-.12.163-.119.212.03l.19.568a.87.87 0 0 1 0 .492l-.19.569c-.045.136.03.246.165.246h.921c.136 0 .304.095.377.216l.8 1.335c.072.12.014.24-.116.266l-1.276.255a.414.414 0 0 0-.295.295l-.255 1.276c-.027.136-.144.189-.266.116l-1.334-.8Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PH">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DD1C34"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0D4BC3"></stop>
            <stop offset="100%" stop-color="#073DA6"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FDD64D"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#c)" d="M0 0h21v7H0z"></path>
          <path fill="url(#a)" d="m0 0 10 7.5L0 15z"></path>
          <path
            fill="url(#d)"
            d="M3.4 8.495 2.542 9.81l.325-1.535c-.052-.043-.1-.09-.143-.143l-1.535.325L2.505 7.6a1.012 1.012 0 0 1 0-.202L1.19 6.543l1.535.325c.043-.052.09-.1.143-.143L2.543 5.19 3.4 6.505a1.012 1.012 0 0 1 .202 0l.856-1.315-.325 1.535c.052.043.1.09.143.143l1.535-.325-1.315.856a1.012 1.012 0 0 1 0 .202l1.315.856-1.535-.325c-.043.052-.09.1-.143.143l.325 1.535L3.6 8.495a1.012 1.012 0 0 1-.202 0ZM7.5 8a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-6-5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 10a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="PK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A632F"></stop>
            <stop offset="100%" stop-color="#05411E"></stop>
          </linearGradient>
          <filter id="d" width="105.6%" height="111.1%" x="-2.8%" y="-2.8%" filterUnits="objectBoundingBox">
            <feOffset dy=".5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <path
            id="c"
            d="M15.978 10.878a4.182 4.182 0 0 1-2.65.95c-2.383 0-4.314-2.015-4.314-4.5 0-2.486 1.931-4.5 4.314-4.5.999 0 1.919.354 2.65.95a4.165 4.165 0 0 0-1.043-.132c-2.165 0-3.92 1.648-3.92 3.682 0 2.033 1.755 3.681 3.92 3.681.361 0 .711-.045 1.043-.131Zm.036-2.77-1.175.838.434-1.377-1.16-.86 1.443-.013.458-1.368.459 1.368 1.443.013-1.16.86.434 1.377-1.176-.838Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0-.002h21v15H0z"></path>
          <path fill="url(#a)" d="M0-.002h6v15H0z"></path>
          <g transform="rotate(-45 13.465 7.328)">
            <use xlink:href="#c" fill="#000" filter="url(#d)"></use>
            <use xlink:href="#c" fill="url(#a)"></use>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="PM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#138E16"></stop>
            <stop offset="100%" stop-color="#0F7F12"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#26A7DC"></stop>
            <stop offset="100%" stop-color="#1B94C6"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FBCD3F"></stop>
            <stop offset="100%" stop-color="#FFCE2F"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F03633"></stop>
            <stop offset="100%" stop-color="#D82A28"></stop>
          </linearGradient>
          <linearGradient id="g" x1="82.842%" x2="20.426%" y1="18.137%" y2="78.479%">
            <stop offset="0%" stop-color="#2AA854"></stop>
            <stop offset="100%" stop-color="#219447"></stop>
          </linearGradient>
          <linearGradient id="i" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="j" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D7181D"></stop>
            <stop offset="100%" stop-color="#C60E13"></stop>
          </linearGradient>
          <linearGradient id="k" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FBCD3F"></stop>
            <stop offset="100%" stop-color="#FECB2F"></stop>
          </linearGradient>
          <path id="e" d="M0 0h7v5H0z"></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 15h21V0H0z"></path>
          <path
            fill="url(#d)"
            d="M17.326 6.429C18.353 6.176 19 6.109 19 7c0 1.657-2.239 3-5 3S9 8.657 9 7c0-.89.647-.824 1.674-.571a4.114 4.114 0 0 1-.161-.563c-.287-1.35.137-2.584.947-2.757.81-.172 1.7.783 1.987 2.134.136.636.113 1.247-.034 1.733a7.414 7.414 0 0 0 1.174 0c-.147-.486-.17-1.097-.034-1.733.287-1.35 1.176-2.306 1.987-2.134.81.173 1.234 1.407.947 2.757a4.114 4.114 0 0 1-.161.563Z"
          ></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M15.776 12.947a.5.5 0 0 0 .448 0l2-1a.5.5 0 0 0-.448-.894L16 11.94l-1.776-.888a.5.5 0 0 0-.448 0L12 11.94l-1.776-.888a.5.5 0 0 0-.448.894l2 1a.5.5 0 0 0 .448 0L14 12.06l1.776.888Z"
          ></path>
          <mask id="h" fill="#fff">
            <use xlink:href="#e"></use>
          </mask>
          <use xlink:href="#e" fill="url(#f)"></use>
          <path
            fill="url(#g)"
            d="M4 2v-4H3v4h-4v1h4v4h1V3h4V2H4Z"
            mask="url(#h)"
            transform="rotate(-45 3.5 2.5)"
          ></path>
          <path fill="url(#a)" d="M4 2v-3H3v3H0v1h3v3h1V3h3V2H4Z" mask="url(#h)"></path>
          <path fill="url(#a)" d="M0 5h7v5H0z"></path>
          <path
            fill="url(#i)"
            d="M1.5 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-1 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
          <path fill="url(#j)" d="M0 10h7v5H0z"></path>
          <path
            fill="url(#k)"
            d="M3.5 12c-1.38 0-2.5-.224-2.5-.5s1.12-.5 2.5-.5 2.5.224 2.5.5-1.12.5-2.5.5Zm0 2c-1.38 0-2.5-.224-2.5-.5s1.12-.5 2.5-.5 2.5.224 2.5.5-1.12.5-2.5.5Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PL">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EB2A50"></stop>
            <stop offset="100%" stop-color="#DA1B40"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#a)" d="M0 0h21v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="PN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07319C"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1F8BDE"></stop>
            <stop offset="100%" stop-color="#1075C2"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F7E14A"></stop>
            <stop offset="100%" stop-color="#F7DE38"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#4B8C36"></stop>
            <stop offset="100%" stop-color="#397127"></stop>
          </linearGradient>
          <linearGradient id="h" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <path
            id="c"
            d="M0 3.5V.51C0 .228.215 0 .498 0h4.004C4.777 0 5 .227 5 .51V3.5C5 6 2.5 7 2.5 7S0 6 0 3.5Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <g transform="translate(13 6)">
            <mask id="f" fill="#fff">
              <use xlink:href="#c"></use>
            </mask>
            <use xlink:href="#c" fill="url(#d)"></use>
            <path fill="url(#e)" fill-rule="nonzero" d="m-.5 6 3-6 3 6v2h-6z" mask="url(#f)"></path>
            <path fill="url(#g)" fill-rule="nonzero" d="M0 6.118V7.5h5V6.118l-2.5-5z" mask="url(#f)"></path>
          </g>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#h)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#h)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FA2222"></stop>
            <stop offset="100%" stop-color="#ED0000"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1D63F9"></stop>
            <stop offset="100%" stop-color="#0650F0"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 3h21v3H0zm0 6h21v3H0z"></path>
          <path fill="url(#c)" d="m0 0 10 7.5L0 15z"></path>
          <path
            fill="url(#a)"
            d="M3.5 8.456 2.031 9.523l.56-1.728-1.469-1.068h1.816L3.5 5l.562 1.727h1.816L4.409 7.795l.56 1.728z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#20934F"></stop>
            <stop offset="100%" stop-color="#197940"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E62539"></stop>
            <stop offset="100%" stop-color="#CA1A2C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="m0 0 10 7.5L0 15z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF2936"></stop>
            <stop offset="100%" stop-color="#FD0D1B"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#128415"></stop>
            <stop offset="100%" stop-color="#0A650C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FAF94F"></stop>
            <stop offset="100%" stop-color="#F8F736"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1D50B5"></stop>
            <stop offset="100%" stop-color="#15439D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 0h8v15H0z"></path>
          <path
            fill="url(#d)"
            fill-rule="nonzero"
            d="M8 9.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm0 1a3 3 0 1 1 0-6 3 3 0 0 1 0 6Z"
          ></path>
          <path
            fill="url(#a)"
            d="M7 6.256A.25.25 0 0 1 7.245 6h1.51A.25.25 0 0 1 9 6.256V8a.997.997 0 0 1-1 1c-.552 0-1-.443-1-.999V6.256Z"
          ></path>
          <path fill="url(#e)" d="M8 8c.276 0 .5-.724.5-1a.5.5 0 0 0-1 0c0 .276.224 1 .5 1Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#65C6EE"></stop>
            <stop offset="100%" stop-color="#4FAED5"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFE044"></stop>
            <stop offset="100%" stop-color="#FFDD32"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <circle cx="9.5" cy="7.5" r="4.5" fill="url(#c)"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="PY">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E33F39"></stop>
            <stop offset="100%" stop-color="#D32E28"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#124BBA"></stop>
            <stop offset="100%" stop-color="#073DA6"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="#398153"
            fill-rule="nonzero"
            d="M10.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm0 .5a2 2 0 1 1 0-4 2 2 0 0 1 0 4Z"
          ></path>
          <circle cx="10.5" cy="7.5" r="1" fill="#E5CF58"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="QA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#A6264C"></stop>
            <stop offset="100%" stop-color="#8C1E3E"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M0 15h7.5L6 14l1.5-1L6 12l1.5-1L6 10l1.5-1L6 8l1.5-1L6 6l1.5-1L6 4l1.5-1L6 2l1.5-1L6 0H0z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="RE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F44653"></stop>
            <stop offset="100%" stop-color="#EE2A39"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1035BB"></stop>
            <stop offset="100%" stop-color="#042396"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="RO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E5253D"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A3D9C"></stop>
            <stop offset="100%" stop-color="#042E7D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD955"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="RS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#17508F"></stop>
            <stop offset="100%" stop-color="#114175"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E1444D"></stop>
            <stop offset="100%" stop-color="#C53840"></stop>
          </linearGradient>
          <path
            id="d"
            d="M.5 2.5C.5 1.826.874.485.874.485A.672.672 0 0 1 1.495 0h2.01c.273 0 .552.214.621.481 0 0 .374 1.33.374 2.019 0 .645-.376 2.02-.376 2.02-.069.265-.269.654-.457.852 0 0-.417.628-1.167.628s-1.167-.628-1.167-.628a2.428 2.428 0 0 1-.46-.86S.5 3.162.5 2.5Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#a)" d="M0 10h21v5H0z"></path>
          <g transform="translate(4 5)">
            <mask id="e" fill="#fff">
              <use xlink:href="#d"></use>
            </mask>
            <use xlink:href="#d" fill="url(#a)"></use>
            <path
              fill="#C43840"
              fill-rule="nonzero"
              d="M4.422-.203-.203 5.578l.781.625L5.203.422z"
              mask="url(#e)"
            ></path>
            <path
              fill="#C43840"
              fill-rule="nonzero"
              d="m-.203.422 4.625 5.781.781-.625L.578-.203z"
              mask="url(#e)"
            ></path>
          </g>
          <ellipse cx="6.5" cy="7.5" fill="#FFF" rx="1" ry="1.5"></ellipse>
          <path
            fill="#D1A43A"
            d="m5 4-.5-1 1 .5 1-.5 1 .5 1-.5L8 4v.5c0 .276-.216.5-.495.5h-2.01A.503.503 0 0 1 5 4.5V4Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="RU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0C47B7"></stop>
            <stop offset="100%" stop-color="#073DA4"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E53B35"></stop>
            <stop offset="100%" stop-color="#D32E28"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 0h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="RW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2D754D"></stop>
            <stop offset="100%" stop-color="#235F3E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#25B1EB"></stop>
            <stop offset="100%" stop-color="#1AA3DC"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FAD546"></stop>
            <stop offset="100%" stop-color="#FAD12F"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EDC738"></stop>
            <stop offset="100%" stop-color="#E5BE2A"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 11h21v4H0z"></path>
          <path fill="url(#c)" d="M0 0h21v7H0z"></path>
          <path fill="url(#d)" d="M0 7h21v4H0z"></path>
          <path
            fill="url(#e)"
            d="m16 4.5-.765.848.058-1.141-1.141.058L15 3.5l-.848-.765 1.141.058-.058-1.141L16 2.5l.765-.848-.058 1.141 1.141-.058L17 3.5l.848.765-1.141-.058.058 1.141z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#128C4B"></stop>
            <stop offset="100%" stop-color="#0B6C38"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M5 9h8v-.992c0-.28.193-.412.453-.281L14 8v1h1.495c.279 0 .505.214.505.505V10c0 .552-.443 1-.999 1h-1.506a.503.503 0 0 1-.495-.5V10H6.503c-.278 0-.66-.156-.853-.35L5 9Zm0-2.748c0-.139.078-.33.18-.433l.14-.138c.1-.1.102-.26 0-.362l-.14-.138A.69.69 0 0 1 5 4.748v-.496C5 4.113 5.107 4 5.252 4h.496c.139 0 .252.107.252.252v.496c0 .139.046.16.116.02l.268-.536A.459.459 0 0 1 6.748 4h1.004C7.89 4 8 4.116 8 4.25c0 .138-.107.25-.252.25h-.496A.254.254 0 0 0 7 4.75c0 .138.107.25.252.25h.496c.139 0 .252.108.252.245v1.51A.245.245 0 0 1 7.748 7h-.496A.249.249 0 0 1 7 6.748v-.496C7 6.113 7.116 6 7.25 6c.138 0 .25-.116.25-.25a.247.247 0 0 0-.252-.25h-.496a.255.255 0 0 0-.252.248v1.004A.251.251 0 0 1 6.25 7 .247.247 0 0 1 6 6.748v-.496A.254.254 0 0 0 5.75 6a.247.247 0 0 0-.25.252v.496A.254.254 0 0 1 5.25 7 .247.247 0 0 1 5 6.748v-.496Zm8 0c0-.139.078-.33.18-.433l.14-.138c.1-.1.102-.26 0-.362l-.14-.138a.69.69 0 0 1-.18-.433v-.496c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496c0 .139.046.16.116.02l.268-.536A.459.459 0 0 1 14.748 4h1.004c.137 0 .248.116.248.25 0 .138-.107.25-.252.25h-.496a.254.254 0 0 0-.252.25c0 .138.107.25.252.25h.496c.139 0 .252.108.252.245v1.51a.245.245 0 0 1-.252.245h-.496A.249.249 0 0 1 15 6.748v-.496c0-.139.116-.252.25-.252.138 0 .25-.116.25-.25a.247.247 0 0 0-.252-.25h-.496a.255.255 0 0 0-.252.248v1.004a.251.251 0 0 1-.25.248.247.247 0 0 1-.25-.252v-.496A.254.254 0 0 0 13.75 6a.247.247 0 0 0-.25.252v.496a.254.254 0 0 1-.25.252.247.247 0 0 1-.25-.252v-.496Zm-1-1.504c0 .139-.078.33-.18.433l-.14.138c-.1.1-.102.26 0 .362l.14.138c.1.1.18.288.18.433v.496a.248.248 0 0 1-.252.252h-.496A.249.249 0 0 1 11 6.748v-.496c0-.139-.046-.16-.116-.02l-.268.536a.459.459 0 0 1-.364.232H9.248A.251.251 0 0 1 9 6.75c0-.138.107-.25.252-.25h.496A.254.254 0 0 0 10 6.25.247.247 0 0 0 9.748 6h-.496A.247.247 0 0 1 9 5.755v-1.51C9 4.11 9.107 4 9.252 4h.496c.139 0 .252.107.252.252v.496A.254.254 0 0 1 9.75 5a.253.253 0 0 0-.25.25c0 .138.107.25.252.25h.496a.255.255 0 0 0 .252-.248V4.248c0-.137.116-.248.25-.248.138 0 .25.107.25.252v.496c0 .139.116.252.25.252.138 0 .25-.107.25-.252v-.496c0-.139.116-.252.25-.252.138 0 .25.107.25.252v.496Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SB">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1DBE4F"></stop>
            <stop offset="100%" stop-color="#159B3F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0660D4"></stop>
            <stop offset="100%" stop-color="#0051BB"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2C7442"></stop>
            <stop offset="100%" stop-color="#225B34"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD646"></stop>
            <stop offset="100%" stop-color="#FED02F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M5.92 5.812c0-.139.078-.33.18-.433l.14-.138c.1-.1.102-.26 0-.362l-.14-.138a.69.69 0 0 1-.18-.433v-.496c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496c0 .139.046.16.116.02l.268-.536a.459.459 0 0 1 .364-.232h1.004c.137 0 .248.116.248.25 0 .138-.107.25-.252.25h-.496a.254.254 0 0 0-.252.25c0 .138.107.25.252.25h.496c.139 0 .252.108.252.245v1.51a.245.245 0 0 1-.252.245h-.496a.249.249 0 0 1-.252-.252v-.496c0-.139.116-.252.25-.252.138 0 .25-.116.25-.25a.247.247 0 0 0-.252-.25h-.496a.255.255 0 0 0-.252.248v1.004a.251.251 0 0 1-.25.248.247.247 0 0 1-.25-.252v-.496a.254.254 0 0 0-.25-.252.247.247 0 0 0-.25.252v.496a.254.254 0 0 1-.25.252.247.247 0 0 1-.25-.252v-.496Z"
          ></path>
          <path fill="url(#b)" d="M0-.003h21v15H0z"></path>
          <path fill="url(#c)" d="M0-.003h21l-21 15z"></path>
          <path fill="url(#d)" d="m0-.003 21 15H0z" transform="matrix(-1 0 0 1 21 0)"></path>
          <path fill="url(#e)" d="M-4 6.497h29v2H-4z"></path>
          <path
            fill="#FFF"
            d="m2.25 2.872-.734.387.14-.819-.595-.579.822-.12.367-.744.368.745.821.12-.594.578.14.819-.735-.387Zm5 0-.734.387.14-.819-.595-.579.822-.12.367-.744.368.745.821.12-.594.578.14.819-.735-.387Zm0 3-.734.387.14-.819-.595-.579.822-.12.367-.744.368.745.821.12-.594.578.14.819-.735-.387Zm-5 0-.734.387.14-.819-.595-.579.822-.12.367-.744.368.745.821.12-.594.578.14.819-.735-.387Zm2.5-1.5-.734.387.14-.819-.595-.579.822-.12.367-.744.368.745.821.12-.594.578.14.819-.735-.387Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SC">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1DBE4F"></stop>
            <stop offset="100%" stop-color="#159B3F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0858B4"></stop>
            <stop offset="100%" stop-color="#013F87"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#ED3535"></stop>
            <stop offset="100%" stop-color="#D62828"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#08964F"></stop>
            <stop offset="100%" stop-color="#017B3E"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFDD67"></stop>
            <stop offset="100%" stop-color="#FDD856"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 0h7L0 15z"></path>
          <path fill="url(#d)" d="M14 0h7v5L0 15z"></path>
          <path fill="url(#e)" d="M21 15v-5L0 15z"></path>
          <path fill="url(#f)" d="M7 0h7L0 15z"></path>
          <path fill="url(#a)" d="M21 10V5L0 15z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SD">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EA1F44"></stop>
            <stop offset="100%" stop-color="#D01739"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#12933B"></stop>
            <stop offset="100%" stop-color="#0D722D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="m0 0 10 7.5L0 15z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#157CBB"></stop>
            <stop offset="100%" stop-color="#0E6CA5"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD34D"></stop>
            <stop offset="100%" stop-color="#FECB2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E12237"></stop>
            <stop offset="100%" stop-color="#CE1126"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v8H0z"></path>
          <path
            fill="url(#a)"
            d="M0 8h21v7H0zm6.874-6.343a2.5 2.5 0 1 0 0 4.686 3 3 0 1 1 0-4.686ZM5.5 4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1-2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2-1.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="SH">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07319C"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#A7D2FF"></stop>
            <stop offset="100%" stop-color="#91C6FD"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EE7B2D"></stop>
            <stop offset="100%" stop-color="#CC621A"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFFC4B"></stop>
            <stop offset="100%" stop-color="#FFFC38"></stop>
          </linearGradient>
          <linearGradient id="h" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
          <path
            id="c"
            d="M0 3.5V.51C0 .228.215 0 .498 0h4.004C4.777 0 5 .227 5 .51V3.5C5 5.5 2.5 6 2.5 6S0 5.5 0 3.5Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <g transform="translate(13 6)">
            <mask id="f" fill="#fff">
              <use xlink:href="#c"></use>
            </mask>
            <use xlink:href="#c" fill="url(#d)"></use>
            <path
              fill="url(#e)"
              d="M.5 6.5c.828 0 1-1.395 1-2.5s-.172-1.5-1-1.5C-.328 2.5-1 2.895-1 4S-.328 6.5.5 6.5Z"
              mask="url(#f)"
            ></path>
            <ellipse cx="2.5" cy="4.5" fill="#A75113" mask="url(#f)" rx="1.5" ry="1"></ellipse>
            <circle cx="2.5" cy="3.5" r="1" fill="#FFF" mask="url(#f)"></circle>
            <path fill="url(#g)" d="M0 0h5v2H0z" mask="url(#f)"></path>
          </g>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#h)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#h)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0C47B7"></stop>
            <stop offset="100%" stop-color="#073DA4"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E53B35"></stop>
            <stop offset="100%" stop-color="#D32E28"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 3h21v7H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path
            fill="url(#a)"
            d="M0 5V0h21v5H6.933V4s-.705-.5-1.433-.5C4.772 3.5 4 4 4 4v1H0Zm5.5 2a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SJ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F14247"></stop>
            <stop offset="100%" stop-color="#ED2F35"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A3A85"></stop>
            <stop offset="100%" stop-color="#032A67"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 9h6v6h3V9h12V6H9V0H6v6H0z"></path>
          <path fill="url(#c)" d="M0 8h7v7h1V8h13V7H8V0H7v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="SK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0C47B7"></stop>
            <stop offset="100%" stop-color="#073DA4"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E53B35"></stop>
            <stop offset="100%" stop-color="#D32E28"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F73744"></stop>
            <stop offset="100%" stop-color="#EC212F"></stop>
          </linearGradient>
          <path
            id="e"
            d="M1.711 2.001A1.048 1.048 0 0 1 2.751 1H7.25c.553 0 1.018.447 1.04 1.001L8.46 6.5c.022.553-.297 1.289-.72 1.652L6.146 9.518c-.633.542-1.662.54-2.292 0L2.259 8.15c-.419-.36-.742-1.098-.72-1.652L1.71 2Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 0h21v5H0z"></path>
          <g transform="translate(2.5 2)">
            <path
              fill="url(#d)"
              fill-rule="nonzero"
              d="M2.751 0H7.25c1.09 0 1.997.872 2.039 1.963L9.46 6.46c.033.86-.415 1.89-1.07 2.45l-1.594 1.367c-1.007.863-2.589.861-3.594 0L1.61 8.91C.957 8.352.506 7.32.539 6.46l.173-4.497A2.048 2.048 0 0 1 2.752 0Z"
            ></path>
            <mask id="g" fill="#fff">
              <use xlink:href="#e"></use>
            </mask>
            <use xlink:href="#e" fill="url(#f)"></use>
            <path
              fill="url(#a)"
              d="M4.5 6.245A.25.25 0 0 0 4.252 6H3.248A.246.246 0 0 1 3 5.748v-.496C3 5.113 3.118 5 3.248 5h1.004a.246.246 0 0 0 .248-.252v-.496A.249.249 0 0 0 4.248 4h-.496a.249.249 0 0 1-.252-.252v-.496c0-.139.107-.252.252-.252h.496a.248.248 0 0 0 .252-.252v-.496c0-.139.107-.252.252-.252h.496c.139 0 .252.107.252.252v.496c0 .139.107.252.252.252h.496c.139 0 .252.107.252.252v.496A.248.248 0 0 1 6.248 4h-.496a.249.249 0 0 0-.252.252v.496c0 .139.118.252.248.252h1.004C6.89 5 7 5.107 7 5.252v.496A.255.255 0 0 1 6.752 6H5.748a.245.245 0 0 0-.248.245v1.51A.245.245 0 0 1 5.248 8h-.496a.247.247 0 0 1-.252-.245v-1.51Z"
              mask="url(#g)"
            ></path>
            <path
              fill="#1251A1"
              d="M4.097 8.07C2.882 8.26 2 8.828 2 9.5c0 .828 1.343 1.5 3 1.5s3-.672 3-1.5c0-.671-.882-1.24-2.097-1.43a1 1 0 0 0-1.806 0Z"
              mask="url(#g)"
            ></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SL">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#35CE4F"></stop>
            <stop offset="100%" stop-color="#2AB441"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1C87DB"></stop>
            <stop offset="100%" stop-color="#1175C4"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#7CCCF5"></stop>
            <stop offset="100%" stop-color="#62B7E3"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#a)" d="M0 0h21v7H0z"></path>
          <path
            fill="#445F42"
            fill-rule="nonzero"
            d="M8 7a2.5 2.5 0 0 0 1.247 2.164.5.5 0 0 0 .502-.865A1.499 1.499 0 0 1 9 7a.5.5 0 0 0-1 0Zm3.846 2.107A2.498 2.498 0 0 0 13 7a.5.5 0 1 0-1 0 1.5 1.5 0 0 1-.693 1.265.5.5 0 1 0 .539.842Z"
          ></path>
          <ellipse cx="10.5" cy="6.5" fill="#D89F3D" rx="1" ry="1.5"></ellipse>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F13642"></stop>
            <stop offset="100%" stop-color="#E1202C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#17A052"></stop>
            <stop offset="100%" stop-color="#108442"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF166"></stop>
            <stop offset="100%" stop-color="#FDEE54"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
          <path
            fill="url(#c)"
            d="m10.5 8.525-1.469.998.494-1.706-1.403-1.09 1.776-.056L10.5 5l.602 1.671 1.776.056-1.403 1.09.494 1.706z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#5D9FE9"></stop>
            <stop offset="100%" stop-color="#458BDB"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="m10.5 9.255-2.645 1.886.976-3.099L6.22 6.109l3.248-.029L10.5 3l1.032 3.08 3.248.029-2.611 1.933.976 3.099z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#43924C"></stop>
            <stop offset="100%" stop-color="#3A7E42"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#CD153A"></stop>
            <stop offset="100%" stop-color="#B31031"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F5D24B"></stop>
            <stop offset="100%" stop-color="#ECC736"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v3H0zm0 12h21v3H0z"></path>
          <path fill="url(#a)" d="M0 3h21v9H0z"></path>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
          <path
            fill="url(#d)"
            d="m10.5 8.775-1.469.998.494-1.706-1.403-1.09 1.776-.056.602-1.671.602 1.671 1.776.056-1.403 1.09.494 1.706z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E22A32"></stop>
            <stop offset="100%" stop-color="#D61C24"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2CA244"></stop>
            <stop offset="100%" stop-color="#218736"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#185AC6"></stop>
            <stop offset="100%" stop-color="#104CAD"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FDE14A"></stop>
            <stop offset="100%" stop-color="#FCDC34"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v4H0z"></path>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
          <path fill="url(#a)" d="M0 4h21v1H0z"></path>
          <path fill="url(#d)" d="M0 11h21v4H0z"></path>
          <path fill="url(#a)" d="M0 10h21v1H0z"></path>
          <path fill="url(#e)" d="m0 0 10 7.5L0 15z"></path>
          <path
            fill="url(#f)"
            d="m3.836 7.987-.683 1.28-.205-1.437-1.429-.254 1.304-.639-.2-1.437 1.01 1.042 1.306-.634-.679 1.283 1.006 1.046z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ST">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2ACB41"></stop>
            <stop offset="100%" stop-color="#21AC35"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FDD043"></stop>
            <stop offset="100%" stop-color="#FFCD2F"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E71E43"></stop>
            <stop offset="100%" stop-color="#D01739"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0zM0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
          <path fill="url(#d)" d="m0 0 8 7.5L0 15z"></path>
          <path
            fill="url(#e)"
            d="m11 8.32-1.176.798.396-1.365-1.122-.871 1.42-.045L11 5.5l.482 1.337 1.42.045-1.122.871.396 1.365zm5 0-1.176.798.396-1.365-1.122-.871 1.42-.045L16 5.5l.482 1.337 1.42.045-1.122.871.396 1.365z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SV">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1B57C4"></stop>
            <stop offset="100%" stop-color="#154BAD"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#3C7839"></stop>
            <stop offset="100%" stop-color="#31642E"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0zm0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M9.3 5.9a2 2 0 1 0 2.4 0L11 8h-1l-.7-2.1Z"></path>
          <path fill="#F9C92E" d="M10.5 5.5 11 8h-1z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SX">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0740AA"></stop>
            <stop offset="100%" stop-color="#012F85"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F02C33"></stop>
            <stop offset="100%" stop-color="#D82027"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E72C33"></stop>
            <stop offset="100%" stop-color="#D82027"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#78C1F0"></stop>
            <stop offset="100%" stop-color="#67B1E0"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F7E14B"></stop>
            <stop offset="100%" stop-color="#F7DF3E"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 7h21v8H0z"></path>
          <path fill="url(#c)" d="M0 0h21v7H0z"></path>
          <path fill="url(#a)" d="m0 0 10 7.5L0 15z"></path>
          <path
            fill="url(#d)"
            fill-rule="nonzero"
            d="M1.5 7V5.506A.997.997 0 0 1 2.495 4.5h2.01c.55 0 .995.457.995 1.006V7c0 .845-.384 1.447-1.003 1.798a2.304 2.304 0 0 1-1.03.3 2.312 2.312 0 0 1-.964-.3C1.884 8.447 1.5 7.845 1.5 7Z"
          ></path>
          <path
            fill="url(#e)"
            d="M2 7V5.506c0-.28.216-.506.495-.506h2.01c.273 0 .495.232.495.506V7c0 1.5-1.5 1.6-1.5 1.6S2 8.5 2 7Z"
          ></path>
          <path fill="#FFF" d="m3 6.5.5-.5.5.5v1H3z"></path>
          <path
            fill="#F9D835"
            fill-rule="nonzero"
            d="M1.001 9.368A3.389 3.389 0 0 0 3.5 10.5c.948 0 1.915-.448 2.521-1.162a.5.5 0 0 0-.762-.647A2.395 2.395 0 0 1 3.5 9.5a2.39 2.39 0 0 1-1.743-.787.5.5 0 1 0-.756.655Z"
          ></path>
          <circle cx="3.5" cy="4.5" r="1" fill="url(#f)"></circle>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="SY">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E32139"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#128A49"></stop>
            <stop offset="100%" stop-color="#0F7A40"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 10h21v5H0z"></path>
          <path fill="url(#c)" d="M0 0h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="url(#d)"
            d="m7 8.32-1.176.798.396-1.365-1.122-.871 1.42-.045L7 5.5l.482 1.337 1.42.045-1.122.871.396 1.365zm7 0-1.176.798.396-1.365-1.122-.871 1.42-.045L14 5.5l.482 1.337 1.42.045-1.122.871.396 1.365z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="SZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#486BCA"></stop>
            <stop offset="100%" stop-color="#3E5FBA"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFDF20"></stop>
            <stop offset="100%" stop-color="#FFDA00"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#CF1615"></stop>
            <stop offset="100%" stop-color="#B20D0C"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <ellipse id="e" cx="4.5" cy="2.5" rx="4.5" ry="2.5"></ellipse>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v3H0zm0 12h21v3H0z"></path>
          <path fill="url(#c)" d="M0 3h21v9H0z"></path>
          <path fill="url(#d)" d="M0 4h21v7H0z"></path>
          <g transform="translate(6 5)">
            <mask id="g" fill="#fff">
              <use xlink:href="#e"></use>
            </mask>
            <use xlink:href="#e" fill="url(#a)"></use>
            <path fill="url(#f)" d="M0 0h5v5H1z" mask="url(#g)" transform="matrix(-1 0 0 1 5 0)"></path>
            <circle cx="5.5" cy="2.5" r="1" fill="#1A1A1A" mask="url(#g)"></circle>
            <circle cx="3.5" cy="2.5" r="1" fill="#F6F6F6" mask="url(#g)"></circle>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TC">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07319C"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD033"></stop>
            <stop offset="100%" stop-color="#FEC403"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M13 7.5V5c0-.553.444-1 1-1h3c.552 0 1 .441 1 1v2.5c0 2.5-2.5 3.5-2.5 3.5S13 10 13 7.5Z"
          ></path>
          <path
            fill="url(#c)"
            fill-rule="nonzero"
            d="M15.644 10.37c.263-.15.527-.334.772-.554C17.099 9.2 17.5 8.439 17.5 7.5V5c0-.28-.221-.5-.5-.5h-3c-.279 0-.5.222-.5.5v2.5c0 .939.401 1.701 1.084 2.316a4.398 4.398 0 0 0 .916.632c.043-.022.091-.048.144-.078Z"
          ></path>
          <circle cx="16.5" cy="6" r="1" fill="#BA5B1F"></circle>
          <circle cx="14.312" cy="6.03" r="1" fill="#FF9F3E" transform="rotate(-20 14.312 6.03)"></circle>
          <circle cx="14.711" cy="6.047" r="1" fill="#FF937F" transform="rotate(25 14.711 6.047)"></circle>
          <path fill="#01A827" d="m15 8 .5-1 .5 1v1h-1z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#d)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#d)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TD">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DE1D42"></stop>
            <stop offset="100%" stop-color="#C51335"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#083780"></stop>
            <stop offset="100%" stop-color="#032862"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD147"></stop>
            <stop offset="100%" stop-color="#FECA2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TF">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#073AB6"></stop>
            <stop offset="100%" stop-color="#002B93"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F44653"></stop>
            <stop offset="100%" stop-color="#EE2A39"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1035BB"></stop>
            <stop offset="100%" stop-color="#042396"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 0h9.5v7.25c0 .138-.107.25-.254.25H0V0Z"></path>
          <path fill="url(#c)" d="M6 0h3v7H6z"></path>
          <path fill="url(#d)" d="M0 0h3v7H0z"></path>
          <path fill="url(#a)" d="M3 0h3v7H3z"></path>
          <path
            fill="#FFF"
            d="M13 6h5l-.5 1H16v.5h1l-.5 1H16V10h-1V7h-1.5L13 6Zm4 2.5 1 1.5h-2l1-1.5Zm-3 0 1 1.5h-2l1-1.5Zm1.5 3-1-1.5h2l-1 1.5Zm3-3.5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-6 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm4 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD44D"></stop>
            <stop offset="100%" stop-color="#FFCD2F"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#159A74"></stop>
            <stop offset="100%" stop-color="#0C6A4F"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#ED1F45"></stop>
            <stop offset="100%" stop-color="#D01739"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M9 0h12v3H9V0Zm0 6h12v3H9V6Zm-9 6h21v3H0v-3Z"></path>
          <path fill="url(#d)" d="M0 0h9v9H0z"></path>
          <path
            fill="url(#a)"
            d="M4.5 5.67 2.737 6.927l.65-2.065-1.74-1.289 2.165-.02L4.5 1.5l.688 2.053 2.165.02-1.74 1.289.65 2.065z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TH">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F12532"></stop>
            <stop offset="100%" stop-color="#EB212E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#322B6C"></stop>
            <stop offset="100%" stop-color="#241F4E"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v3H0zm0 12h21v3H0z"></path>
          <path fill="url(#a)" d="M0 3h21v9H0z"></path>
          <path fill="url(#c)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TJ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D9101C"></stop>
            <stop offset="100%" stop-color="#CA0814"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0F7811"></stop>
            <stop offset="100%" stop-color="#0A650C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
          <path
            fill="#FAD14E"
            d="M10.066 8A3.266 3.266 0 0 1 10 7.5a.5.5 0 1 1 1 0c0 .09-.024.283-.066.5h.57c.274 0 .496.232.496.5 0 .276-.216.5-.495.5h-2.01A.503.503 0 0 1 9 8.5c0-.276.216-.5.495-.5h.571ZM9.5 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-6 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0637C5"></stop>
            <stop offset="100%" stop-color="#002CAA"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FDD33F"></stop>
            <stop offset="100%" stop-color="#FED02F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#c)"
            d="M4 12h15v1H3l1-1Zm7.5-6c3-2 6.5-4 6.5-4s-1.643 3.073-1.5 4.5C16.69 8.407 19 11 19 11H5s3.5-3 6.5-5Z"
          ></path>
          <path
            fill="#FFF"
            d="m4 9-.707.207L3.5 8.5l-.207-.707L4 8l.707-.207L4.5 8.5l.207.707zm1-6.5-.707.207L4.5 2l-.207-.707L5 1.5l.707-.207L5.5 2l.207.707zm2 3-.707.207L6.5 5l-.207-.707L7 4.5l.707-.207L7.5 5l.207.707zm-5 0-.707.207L1.5 5l-.207-.707L2 4.5l.707-.207L2.5 5l.207.707z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TL">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF323E"></stop>
            <stop offset="100%" stop-color="#FD0D1B"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFCC51"></stop>
            <stop offset="100%" stop-color="#FFC63C"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="m0 0 13 7.5L0 15z"></path>
          <path fill="url(#d)" d="m0 0 9 7.5L0 15z"></path>
          <path
            fill="url(#a)"
            d="m3.92 8.262-1.301.928.48-1.524-1.284-.951L3.413 6.7l.507-1.515.508 1.515 1.598.015-1.284.951.48 1.524z"
            transform="rotate(-30 3.92 7.187)"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="TM">
        <defs>
          <path id="f" fill="#FBAF29" d="M0 0h1.5v1H0zm1.5 1H3v1H1.5z" mask="url(#a)"></path>
        </defs>
        <defs>
          <ellipse id="e" cx="1.5" cy="1" rx="1.5" ry="1"></ellipse>
          <ellipse id="g" cx="1.5" cy="1" rx="1.5" ry="1"></ellipse>
          <ellipse id="i" cx="1.5" cy="1" rx="1.5" ry="1"></ellipse>
          <ellipse id="k" cx="1.5" cy=".5" rx="1.5" ry="1"></ellipse>
          <ellipse id="l" cx="1.5" cy="1" rx="1.5" ry="1"></ellipse>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#30C375"></stop>
            <stop offset="100%" stop-color="#28AE67"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DE414F"></stop>
            <stop offset="100%" stop-color="#CA3745"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 0h21v15H0z"></path>
          <path fill="url(#d)" d="M3 0h3v15H3z"></path>
          <g transform="translate(3 1)">
            <mask id="a" fill="#fff">
              <use xlink:href="#e"></use>
            </mask>
            <use xlink:href="#e" fill="#FFF"></use>
            <circle cx="1.5" cy="1" r="1" fill="#DD404F" mask="url(#a)"></circle>
            <use xlink:href="#f" mask="url(#a)"></use>
          </g>
          <g transform="translate(3 12)">
            <mask id="h" fill="#fff">
              <use xlink:href="#g"></use>
            </mask>
            <use xlink:href="#g" fill="#FFF"></use>
            <circle cx="1.5" cy="1" r="1" fill="#DD404F" mask="url(#h)"></circle>
            <use xlink:href="#f" mask="url(#h)"></use>
          </g>
          <g transform="translate(3 7)">
            <mask id="j" fill="#fff">
              <use xlink:href="#i"></use>
            </mask>
            <use xlink:href="#i" fill="#28AE67"></use>
            <circle cx="1.5" cy="1" r="1" fill="#DD404F" mask="url(#j)"></circle>
          </g>
          <use xlink:href="#k" fill="#28AE67" transform="translate(3 10)"></use>
          <g transform="translate(3 4)">
            <mask id="m" fill="#fff">
              <use xlink:href="#l"></use>
            </mask>
            <use xlink:href="#l" fill="#FBAF29"></use>
            <circle cx="1.5" cy="1" r="1" fill="#DD404F" mask="url(#m)"></circle>
            <path fill="#28AE67" d="M0 0h1v2H0zm2 0h1v2H2z" mask="url(#m)"></path>
          </g>
          <path
            fill="url(#b)"
            d="M11.117 3.179a.5.5 0 1 0 .766.642.5.5 0 0 0-.766-.642ZM9.821 5.117a.5.5 0 1 0-.642.766.5.5 0 0 0 .642-.766Zm-1-1a.5.5 0 1 0-.642.766.5.5 0 0 0 .642-.766Zm2-2a.5.5 0 1 0-.642.766.5.5 0 0 0 .642-.766Zm-.5 1.5a.5.5 0 1 0-.642.766.5.5 0 0 0 .642-.766Z"
          ></path>
          <path
            fill="url(#b)"
            d="M13.107 7.088a3.05 3.05 0 0 1-4.626-.366 3.05 3.05 0 0 0 4.26-4.26 3.05 3.05 0 0 1 .366 4.626Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E92434"></stop>
            <stop offset="100%" stop-color="#E11324"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M11.858 4.273a3.5 3.5 0 1 0 0 6.453 3.25 3.25 0 0 1 0-6.453ZM10.5 12a4.5 4.5 0 1 1 0-9 4.5 4.5 0 0 1 0 9Zm1.766-3.622 1.352.505-.775-1.218.898-1.13-1.398.361-.797-1.204-.088 1.441-1.391.386 1.343.53-.063 1.442.919-1.113Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TO">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E20F1B"></stop>
            <stop offset="100%" stop-color="#C00711"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DF101B"></stop>
            <stop offset="100%" stop-color="#C00711"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M0 0h12v8H0z"></path>
          <path
            fill="url(#c)"
            d="M7 3V1.258C7 1.104 6.89 1 6.755 1h-1.51A.25.25 0 0 0 5 1.258V3H3.258C3.104 3 3 3.11 3 3.245v1.51A.25.25 0 0 0 3.258 5H5v1.742c0 .154.11.258.245.258h1.51A.25.25 0 0 0 7 6.742V5h1.742C8.896 5 9 4.89 9 4.755v-1.51A.25.25 0 0 0 8.742 3H7Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TR">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E92434"></stop>
            <stop offset="100%" stop-color="#E11324"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="M13.052 4.737A3.907 3.907 0 0 0 10.75 4C8.679 4 7 5.567 7 7.5S8.679 11 10.75 11c.868 0 1.667-.275 2.302-.737a4.5 4.5 0 1 1 0-5.526Zm1.214 3.34-.919 1.113.063-1.442-1.343-.53 1.39-.386.09-1.441.796 1.204 1.398-.361-.898 1.13.775 1.217-1.352-.505Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TT">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#ED233C"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M-.004.005h21v15h-21z"></path>
          <path
            fill="url(#a)"
            d="m23-1-7.144-3.061-15.1 17.996L-1.5 16l7.653 3.07L20.977 1.403z"
            transform="matrix(-1 0 0 1 21.5 0)"
          ></path>
          <path
            fill="url(#c)"
            d="M3.09 20.219 21.731-1.996l-3.83-3.214L-.74 17.005l3.83 3.214z"
            transform="matrix(-1 0 0 1 20.991 0)"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TV">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#72AFC8"></stop>
            <stop offset="100%" stop-color="#5D98B0"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0A17A7"></stop>
            <stop offset="100%" stop-color="#030E88"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="#FFCD2F"
            d="m9 13-.707.207.207-.707-.207-.707L9 12l.707-.207-.207.707.207.707L9 13Zm3-1-.707.207.207-.707-.207-.707L12 11l.707-.207-.207.707.207.707L12 12Zm3 0-.707.207.207-.707-.207-.707L15 11l.707-.207-.207.707.207.707L15 12Zm2-2-.707.207.207-.707-.207-.707L17 9l.707-.207-.207.707.207.707L17 10Zm2-2-.707.207.207-.707-.207-.707L19 7l.707-.207-.207.707.207.707L19 8Zm-6 1-.707.207.207-.707-.207-.707L13 8l.707-.207-.207.707.207.707L13 9Zm2-4-.707.207.207-.707-.207-.707L15 4l.707-.207-.207.707.207.707L15 5Zm2-1-.707.207.207-.707-.207-.707L17 3l.707-.207-.207.707.207.707L17 4Zm2-1-.707.207.207-.707-.207-.707L19 2l.707-.207-.207.707.207.707L19 3Z"
          ></path>
          <path fill="url(#c)" d="M0 0h9v7H0z"></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#d)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#d)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="93.767%">
            <stop offset="0%" stop-color="#FE3030"></stop>
            <stop offset="100%" stop-color="red"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0909B6"></stop>
            <stop offset="100%" stop-color="#000096"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 8h11V0H0z"></path>
          <path
            fill="url(#a)"
            d="m5.5 5.25-.957 1.06.073-1.426-1.426.073L4.25 4l-1.06-.957 1.426.073-.073-1.426.957 1.06.957-1.06-.073 1.426 1.426-.073L6.75 4l1.06.957-1.426-.073.073 1.426z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="TZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#33CC4D"></stop>
            <stop offset="100%" stop-color="#2AB441"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2DAFE4"></stop>
            <stop offset="100%" stop-color="#1BA4DC"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD84F"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="m.001 10.004 21-10h-21z"></path>
          <path fill="url(#c)" d="M.001 15.004h21v-10z"></path>
          <path fill="url(#d)" d="M2.313 17.004 22.63 4.309l-3.94-6.305-20.317 12.695z"></path>
          <path fill="url(#e)" d="M-.47 17.308 24.123 1.94l-2.65-4.24L-3.12 13.068z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="UA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#156DD1"></stop>
            <stop offset="100%" stop-color="#0D5EB9"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD948"></stop>
            <stop offset="100%" stop-color="#FFD430"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v8H0z"></path>
          <path fill="url(#c)" d="M0 8h21v7H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="UG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#ED1623"></stop>
            <stop offset="100%" stop-color="#D70915"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FEE044"></stop>
            <stop offset="100%" stop-color="#FCDB32"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v2H0zm0 8h21v2H0z"></path>
          <path fill="url(#c)" d="M0 5h21v3H0z"></path>
          <path fill="url(#d)" d="M0 2h21v3H0z"></path>
          <path fill="url(#c)" d="M0 13h21v2H0z"></path>
          <path fill="url(#d)" d="M0 10h21v3H0z"></path>
          <circle cx="10.5" cy="7.5" r="3.5" fill="url(#a)"></circle>
          <path
            fill="url(#b)"
            d="M9.68 5.68a.253.253 0 0 1 0-.36l.14-.14c.1-.1.252-.27.338-.362l.122-.099c.122.017.317-.036.442-.012l.119.092a.424.424 0 0 1 .043.433l-.268.536a1.298 1.298 0 0 0-.116.482c0 .138.092.296.232.366l.536.268c.128.064.31.194.406.29l.652.652a.36.36 0 0 1 .058.406l-.268.536c-.064.128-.194.154-.297.051l-.138-.138a.253.253 0 0 0-.362 0l-.138.138A.71.71 0 0 0 11 9.25a.69.69 0 0 0 .18.43l.14.14c.1.1.062.18-.068.18h-1.004c-.137 0-.17-.078-.067-.18l.138-.14c.1-.1.181-.296.181-.43a.253.253 0 0 0-.25-.25.691.691 0 0 0-.43.18l-.14.14c-.1.1-.258.102-.36 0l-.14-.14a.253.253 0 0 1 0-.36l.14-.14c.1-.1.287-.18.432-.18h.496c.139 0 .171-.08.08-.172L9.172 7.172a.245.245 0 0 1 .002-.346l.652-.652a.249.249 0 0 0-.007-.355l-.138-.138Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="UM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D02F44"></stop>
            <stop offset="100%" stop-color="#B12537"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#46467F"></stop>
            <stop offset="100%" stop-color="#3C3C6D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#b)"
            d="M0 0h21v1H0V0Zm0 2h21v1H0V2Zm0 2h21v1H0V4Zm0 2h21v1H0V6Zm0 2h21v1H0V8Zm0 2h21v1H0v-1Zm0 2h21v1H0v-1Zm0 2h21v1H0v-1Z"
          ></path>
          <path fill="url(#c)" d="M0 0h9v7H0z"></path>
          <path
            fill="url(#a)"
            d="M1.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-5 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="US">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D02F44"></stop>
            <stop offset="100%" stop-color="#B12537"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#46467F"></stop>
            <stop offset="100%" stop-color="#3C3C6D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#b)"
            d="M0 0h21v1H0V0Zm0 2h21v1H0V2Zm0 2h21v1H0V4Zm0 2h21v1H0V6Zm0 2h21v1H0V8Zm0 2h21v1H0v-1Zm0 2h21v1H0v-1Zm0 2h21v1H0v-1Z"
          ></path>
          <path fill="url(#c)" d="M0 0h9v7H0z"></path>
          <path
            fill="url(#a)"
            d="M1.5 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-5 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm1 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
        viewBox="0 0 21 15"
        id="US-CA"
      >
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E7413D"></stop>
            <stop offset="100%" stop-color="#DB3531"></stop>
          </linearGradient>
          <path
            id="c"
            d="M7.312 6.6c-.15-.14-.144.126-.481.08-.09-.011-.2-.216-.2-.216s-.564-.036-.594-.298c-.03-.262.35-.386.492-.583.111-.156.018-.287.102-.458.084-.171.335-.226.36-.314.016-.054-.133-.264.077-.335.203-.069.391.104.391.104s.001-.242.166-.27c.238-.042.392.166.392.166s1.216-1.007 1.9-1.014c.588-.007.856.363 1.42.423.92.1 1.327-.423 2.261 0 1.195.543 1.27 2.992 1.27 2.992s.301.402.348.623c.045.209 0 .356-.205.521-.204.166-.903.373-1.034.145-.13-.228.61-.399.486-.453-.486-.213-.865-.836-.865-.836s-.518.277-.805.623c-.236.285-.135.666-.49.666-.68 0-.992.066-1.031-.145-.084-.453.882-.118.711-.23-.117-.078-.117-1.327-.117-1.327h-.738s.158 1.437-.114 1.474c-.71.095-.367.084-.96 0-.328-.047.446-.438.446-.438s-.104-.744-.446-.738c-.559.555-1.43 1.58-1.777 1.58-.421 0-.337-.047-.652-.071-.665-.051 0-.558.392-.333.167-.225.758-1.879.758-1.879s-1.076.9-1.463.541Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 12h21v3H0z"></path>
          <path fill="url(#a)" d="M0 0h21v12H0z"></path>
          <path
            fill="#414B52"
            d="M3.333 10.604h.001a.123.123 0 0 1 .072.112.127.127 0 0 1-.022.07.436.436 0 0 1-.378.194.432.432 0 0 1-.284-.094.547.547 0 0 1-.168-.253 1.093 1.093 0 0 1-.054-.353c0-.128.018-.245.054-.351a.553.553 0 0 1 .168-.254.429.429 0 0 1 .284-.095c.152 0 .273.059.362.176a.123.123 0 0 1-.036.182l-.004.002a.116.116 0 0 1-.062.016.116.116 0 0 1-.096-.046.203.203 0 0 0-.164-.086c-.077 0-.139.041-.185.123a.682.682 0 0 0-.069.333c0 .143.023.255.069.336.046.081.108.122.185.122.07 0 .127-.031.172-.094a.123.123 0 0 1 .154-.042l.001.002Zm.867.376c.07 0 .104-.03.104-.09a.215.215 0 0 0-.006-.048L4.02 9.68a.136.136 0 0 0-.044-.07.112.112 0 0 0-.076-.03h-.102a.11.11 0 0 0-.074.03.136.136 0 0 0-.044.07l-.276 1.158a.218.218 0 0 0-.008.056c0 .035.01.058.028.069a.137.137 0 0 0 .072.017h.042a.13.13 0 0 0 .074-.02c.019-.013.033-.038.044-.074l.03-.11.012-.042a.1.1 0 0 1 .031-.051.085.085 0 0 1 .055-.017h.126c.033 0 .056.009.067.027a.267.267 0 0 1 .029.083l.03.11c.01.036.025.06.044.074.019.013.044.02.076.02H4.2Zm-.28-.662a.337.337 0 0 1 .008.06c0 .039-.02.058-.062.058h-.032c-.043 0-.064-.022-.064-.066a.24.24 0 0 1 .006-.054l.026-.144.03-.148a.035.035 0 0 1 .007-.014c.003-.004.006-.006.009-.006.01 0 .015.008.016.024l.028.144.028.146Zm1.136.662a.099.099 0 0 0 .102-.1v-.048c0-.03-.01-.053-.029-.072a.1.1 0 0 0-.073-.028h-.284a.097.097 0 0 1-.073-.03.1.1 0 0 1-.029-.072v-.95a.097.097 0 0 0-.029-.071.097.097 0 0 0-.071-.029h-.062c-.027 0-.05.01-.07.029a.095.095 0 0 0-.03.071v1.2c0 .028.01.052.03.071.02.02.043.029.07.029h.548Zm.37 0a.1.1 0 0 0 .072-.029c.02-.02.03-.043.03-.071V9.678c0-.027-.01-.05-.03-.069a.1.1 0 0 0-.072-.029h-.06c-.027 0-.05.01-.07.029a.093.093 0 0 0-.03.069v1.202c0 .028.01.052.03.071.02.02.043.029.07.029h.06Zm.49 0a.1.1 0 0 0 .072-.029c.02-.02.03-.043.03-.071v-.402a.1.1 0 0 1 .029-.072c.02-.02.043-.03.071-.03h.206c.027 0 .05-.01.069-.029a.094.094 0 0 0 .029-.069v-.052c0-.027-.01-.05-.029-.07a.093.093 0 0 0-.069-.03h-.206a.096.096 0 0 1-.072-.029.098.098 0 0 1-.028-.071V9.93a.1.1 0 0 1 .028-.071.096.096 0 0 1 .072-.029H6.4a.1.1 0 0 0 .072-.029c.02-.02.03-.043.03-.071v-.05c0-.027-.01-.05-.03-.07a.098.098 0 0 0-.072-.03h-.544c-.027 0-.05.01-.07.03a.096.096 0 0 0-.03.07v1.2c0 .028.01.052.029.071.02.02.043.029.071.029h.06Zm.648-.347c.036.106.092.19.168.253.076.063.17.094.284.094a.436.436 0 0 0 .285-.094.55.55 0 0 0 .17-.253c.037-.106.055-.224.055-.353a1.06 1.06 0 0 0-.055-.351.557.557 0 0 0-.17-.254.433.433 0 0 0-.285-.095.429.429 0 0 0-.284.095.553.553 0 0 0-.168.254 1.086 1.086 0 0 0-.054.351c0 .13.018.247.054.353Zm.641-.017c-.047.081-.11.122-.189.122-.077 0-.139-.04-.185-.122a.686.686 0 0 1-.069-.336c0-.14.023-.251.069-.333.046-.082.108-.123.185-.123.079 0 .142.041.189.123a.666.666 0 0 1 .071.333.67.67 0 0 1-.071.336Zm1.299.192c.008.015.012.03.012.044a.082.082 0 0 1-.018.05l-.03.036c-.035.039-.07.058-.104.058a.075.075 0 0 1-.054-.024.613.613 0 0 1-.151-.187.934.934 0 0 1-.073-.187.083.083 0 0 0-.032-.051.098.098 0 0 0-.058-.017c-.07 0-.106.03-.106.09v.278a.093.093 0 0 1-.022.062c-.015.017-.037.026-.068.026h-.062a.116.116 0 0 1-.079-.027.08.08 0 0 1-.031-.061V9.666c0-.023.01-.043.031-.06a.119.119 0 0 1 .079-.026h.3a.401.401 0 0 1 .387.236.523.523 0 0 1-.105.586.08.08 0 0 0-.02.042.257.257 0 0 0 .016.079.562.562 0 0 0 .156.245.151.151 0 0 1 .032.04Zm-.348-.608a.27.27 0 0 0 .054-.166.228.228 0 0 0-.054-.152c-.036-.043-.09-.064-.16-.064a.112.112 0 0 0-.076.026.078.078 0 0 0-.03.06v.282c0 .03.009.053.027.066.018.013.044.02.079.02.07 0 .124-.024.16-.072Zm1.16.762c.02.012.038.018.054.018h.058a.09.09 0 0 0 .067-.031.103.103 0 0 0 .029-.073v-1.19c0-.03-.01-.056-.029-.076a.09.09 0 0 0-.067-.03h-.032a.103.103 0 0 0-.106.106v.652c0 .032-.003.048-.01.048-.004 0-.013-.013-.026-.038l-.354-.7a.113.113 0 0 0-.045-.049.133.133 0 0 0-.071-.019h-.058a.103.103 0 0 0-.106.106v1.19c0 .03.01.054.031.074.02.02.046.03.075.03h.022c.028 0 .052-.01.072-.03a.1.1 0 0 0 .03-.074v-.68c0-.01.002-.017.005-.022.003-.005.007-.008.011-.008.008 0 .015.007.022.02l.388.736c.007.015.02.028.04.04Zm.516.018a.1.1 0 0 0 .072-.029c.02-.02.03-.043.03-.071V9.678c0-.027-.01-.05-.03-.069a.1.1 0 0 0-.072-.029h-.06c-.027 0-.05.01-.07.029a.093.093 0 0 0-.03.069v1.202c0 .028.01.052.03.071.02.02.043.029.07.029h.06Zm1.008 0c.07 0 .104-.03.104-.09a.215.215 0 0 0-.006-.048L10.66 9.68a.136.136 0 0 0-.044-.07.112.112 0 0 0-.076-.03h-.102a.11.11 0 0 0-.074.03.136.136 0 0 0-.044.07l-.276 1.158a.218.218 0 0 0-.008.056c0 .035.01.058.028.069a.137.137 0 0 0 .072.017h.042a.13.13 0 0 0 .074-.02c.019-.013.033-.038.044-.074l.03-.11.012-.042a.1.1 0 0 1 .031-.051.085.085 0 0 1 .055-.017h.126c.033 0 .056.009.067.027a.267.267 0 0 1 .029.083l.03.11c.01.036.025.06.044.074.019.013.044.02.076.02h.044Zm-.28-.662a.337.337 0 0 1 .008.06c0 .039-.02.058-.062.058h-.032c-.043 0-.064-.022-.064-.066a.24.24 0 0 1 .006-.054l.026-.144.03-.148a.035.035 0 0 1 .007-.014c.003-.004.006-.006.009-.006.01 0 .015.008.016.024l.028.144.028.146Zm1.662.49c.008.015.012.03.012.044a.082.082 0 0 1-.018.05l-.03.036c-.035.039-.07.058-.104.058a.075.075 0 0 1-.054-.024.613.613 0 0 1-.151-.187.934.934 0 0 1-.073-.187.083.083 0 0 0-.032-.051.098.098 0 0 0-.058-.017c-.07 0-.106.03-.106.09v.278a.093.093 0 0 1-.022.062c-.015.017-.037.026-.068.026h-.062a.116.116 0 0 1-.079-.027.08.08 0 0 1-.031-.061V9.666c0-.023.01-.043.031-.06a.119.119 0 0 1 .079-.026h.3a.401.401 0 0 1 .387.236.523.523 0 0 1-.105.586.08.08 0 0 0-.02.042.257.257 0 0 0 .016.079.562.562 0 0 0 .156.245.151.151 0 0 1 .032.04Zm-.348-.608a.27.27 0 0 0 .054-.166.228.228 0 0 0-.054-.152c-.036-.043-.09-.064-.16-.064a.112.112 0 0 0-.076.026.078.078 0 0 0-.03.06v.282c0 .03.009.053.027.066.018.013.044.02.079.02.07 0 .124-.024.16-.072Zm1.108.78a.099.099 0 0 0 .1-.102v-.048c0-.027-.01-.05-.029-.07a.095.095 0 0 0-.071-.03h-.286a.094.094 0 0 1-.068-.03.094.094 0 0 1-.03-.068v-.156c0-.028.01-.052.029-.071a.094.094 0 0 1 .069-.029h.172c.028 0 .052-.01.071-.029a.094.094 0 0 0 .029-.069v-.054c0-.027-.01-.05-.029-.07a.095.095 0 0 0-.071-.03h-.172a.094.094 0 0 1-.068-.03.094.094 0 0 1-.03-.068V9.93a.1.1 0 0 1 .03-.071.092.092 0 0 1 .068-.031h.286a.1.1 0 0 0 .071-.028.091.091 0 0 0 .029-.068v-.054c0-.027-.01-.05-.029-.069a.097.097 0 0 0-.071-.029h-.542a.1.1 0 0 0-.073.028.093.093 0 0 0-.029.07v1.2a.099.099 0 0 0 .102.102h.542Zm.314-.026a.085.085 0 0 0 .062.026h.082a.087.087 0 0 0 .064-.026.087.087 0 0 0 .026-.064v-.268a.09.09 0 0 1 .026-.065.083.083 0 0 1 .062-.027.56.56 0 0 0 .285-.07.483.483 0 0 0 .247-.42.487.487 0 0 0-.057-.238.402.402 0 0 0-.167-.163.556.556 0 0 0-.266-.059h-.302a.085.085 0 0 0-.062.026.087.087 0 0 0-.026.064v1.22c0 .025.009.047.026.064Zm.322-.674a.085.085 0 0 1-.062-.026.087.087 0 0 1-.026-.064v-.276a.09.09 0 0 1 .026-.065.083.083 0 0 1 .062-.027h.012a.31.31 0 0 1 .189.053c.047.035.071.091.071.167a.22.22 0 0 1-.074.171.267.267 0 0 1-.186.067h-.012Zm1.232-.675a.084.084 0 0 0-.026.063v.838a.274.274 0 0 1-.043.167c-.029.038-.077.057-.145.057-.067 0-.115-.019-.144-.056a.258.258 0 0 1-.044-.162v-.844a.082.082 0 0 0-.028-.062.094.094 0 0 0-.066-.026h-.068a.09.09 0 0 0-.067.025.085.085 0 0 0-.025.063v.828c0 .161.04.282.121.363a.44.44 0 0 0 .325.121.43.43 0 0 0 .321-.121c.08-.08.119-.202.119-.363v-.828a.08.08 0 0 0-.029-.062.097.097 0 0 0-.067-.026h-.068a.091.091 0 0 0-.066.025Zm.324 1.352a.08.08 0 0 0 .058.023h.32c.164 0 .286-.04.366-.119a.42.42 0 0 0 .12-.311v-.068a.27.27 0 0 0-.051-.157.344.344 0 0 0-.133-.107c-.003 0-.004-.002-.004-.006l.002-.002a.258.258 0 0 0 .105-.124.454.454 0 0 0 .035-.18.284.284 0 0 0-.117-.235.528.528 0 0 0-.331-.091h-.312a.08.08 0 0 0-.082.08v1.24c0 .023.008.042.024.057Zm.322-.843c-.035 0-.057-.005-.068-.016-.01-.01-.016-.033-.016-.066V9.91c0-.032.005-.054.015-.065.01-.011.033-.017.069-.017h.016c.077 0 .133.012.167.035a.106.106 0 0 1 .051.091.15.15 0 0 1-.05.113c-.033.031-.089.047-.166.047h-.018Zm0 .618c-.032 0-.054-.006-.066-.017-.012-.011-.018-.033-.018-.065v-.224c0-.035.006-.057.018-.067.012-.01.034-.015.066-.015h.074a.24.24 0 0 1 .157.05c.04.033.061.077.061.132v.024c0 .121-.072.182-.216.182h-.076Zm1.334.248a.099.099 0 0 0 .102-.1v-.048c0-.03-.01-.053-.029-.072a.1.1 0 0 0-.073-.028h-.284a.097.097 0 0 1-.073-.03.1.1 0 0 1-.029-.072v-.95a.097.097 0 0 0-.029-.071.097.097 0 0 0-.071-.029h-.062c-.027 0-.05.01-.07.029a.095.095 0 0 0-.03.071v1.2c0 .028.01.052.03.071.02.02.043.029.07.029h.548Zm.37 0a.1.1 0 0 0 .072-.029c.02-.02.03-.043.03-.071V9.678c0-.027-.01-.05-.03-.069a.1.1 0 0 0-.072-.029h-.06c-.027 0-.05.01-.07.029a.093.093 0 0 0-.03.069v1.202c0 .028.01.052.03.071.02.02.043.029.07.029h.06Zm1.091-.376h.001a.123.123 0 0 1 .072.112.127.127 0 0 1-.022.07.436.436 0 0 1-.378.194.432.432 0 0 1-.284-.094.547.547 0 0 1-.168-.253 1.093 1.093 0 0 1-.054-.353c0-.128.018-.245.054-.351a.553.553 0 0 1 .168-.254.429.429 0 0 1 .284-.095c.152 0 .273.059.362.176a.123.123 0 0 1-.036.182l-.004.002a.116.116 0 0 1-.062.016.116.116 0 0 1-.096-.046.203.203 0 0 0-.164-.086c-.077 0-.139.041-.185.123a.682.682 0 0 0-.069.333c0 .143.023.255.069.336.046.081.108.122.185.122.07 0 .127-.031.172-.094a.123.123 0 0 1 .154-.042l.001.002Z"
          ></path>
          <path
            fill="#319400"
            d="M6.273 8.636c-.815-.021-.832-.156-.026-.294 0 0 2.724-.54 4.686-.54 2.038 0 4.627.533 4.627.533.801.145.787.28-.029.302l-4.505.121-4.753-.122Z"
          ></path>
          <use xlink:href="#c" fill="#944200"></use>
          <path
            stroke="#391800"
            stroke-width=".5"
            d="M6.911 6.436a.332.332 0 0 1-.047-.003.146.146 0 0 1 .063.022l-.016-.019Zm.325-1.706-.023-.077a.246.246 0 0 1-.009-.037c.003.032-.029.088-.056.097.02-.007.05-.002.088.017Zm.476-.173a.176.176 0 0 1 .007-.028c0 .003-.018.02-.052.027a.113.113 0 0 1 .045 0Zm6.916 3.38a1.996 1.996 0 0 1-.434.105c.057.098.061.094.139.054.023-.012.173-.083.209-.103a.475.475 0 0 0 .086-.056Zm-2.405-.02a9.7 9.7 0 0 0-.277.004c-.376.009-.438-.001-.428.055a.108.108 0 0 1-.044.062.419.419 0 0 1 .15-.012c.049.002.101.008.168.017.09.013.137.02.172.021.043.023.044.023.259-.148Zm-1.661-.167a.488.488 0 0 1-.067.005c-.016 0-.243-.041-.406-.065.077.011.185.144.114.282-.005.01.023-.015.068-.047a3.537 3.537 0 0 1 .291-.175Zm-2.347.341a1.177 1.177 0 0 1-.274-.025l-.052-.012a1.806 1.806 0 0 0-.245-.033c-.093-.007-.02.14-.064.175.08-.063.233-.087.313-.041l.193.11.129-.174Zm3.204-.554a1.086 1.086 0 0 1 .238-.01 14.438 14.438 0 0 1-.039-.813h-.217a8.065 8.065 0 0 1 .018.823Zm-.364.648Z"
          ></path>
          <path
            stroke="#391800"
            stroke-linecap="round"
            stroke-width=".5"
            d="M8.985 6.204s.303-.827.29-1.14c-.012-.297-.183-1.03-.289-.615-.106.416-.565.128-.565.128m3.625 1.733s.983-.753.983-1.321"
          ></path>
          <path
            fill="url(#b)"
            d="m3.5 4.267-1.176.851.447-1.381-1.173-.855 1.451-.003L3.5 1.5l.451 1.379 1.451.003-1.173.855.447 1.381z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="UY">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0E4DC5"></stop>
            <stop offset="100%" stop-color="#073DA6"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FED443"></stop>
            <stop offset="100%" stop-color="#FCD036"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M10 0h11v2H10V0Zm0 4h11v2H10V4Zm0 4h11v2H10V8ZM0 12h21v2H0v-2ZM0 0h10v10H0V0Z"></path>
          <path
            fill="url(#c)"
            d="m5 6.991-.668.996L4.163 6.8l-1.033.608.362-1.143-1.195.1.823-.873L2 5.062l1.12-.428-.823-.873 1.195.1-.362-1.144 1.033.608.17-1.187.667.996.668-.996.169 1.187 1.033-.608-.362 1.143 1.195-.099-.823.873L8 5.063l-1.12.429.823.872-1.195-.099.362 1.143L5.837 6.8l-.17 1.187L5 6.991Zm0-.02a1.91 1.91 0 1 0 0-3.817 1.91 1.91 0 0 0 0 3.818ZM5 6.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3Z"
          ></path>
          <path
            fill="#C6A326"
            fill-rule="nonzero"
            d="M4.125 5a.125.125 0 0 1 .25 0A.622.622 0 0 0 5 5.625c.243 0 .46-.14.564-.355l.038-.07.014-.023c.048-.08.062-.119.062-.177a.125.125 0 0 1 .25 0 .534.534 0 0 1-.097.304l-.013.022-.028.052A.875.875 0 0 1 4.125 5ZM5.5 4.75a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5Zm-1 0a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="UZ">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#04AAC8"></stop>
            <stop offset="100%" stop-color="#009AB6"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#23C840"></stop>
            <stop offset="100%" stop-color="#1EB639"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path
            fill="url(#a)"
            d="M0 5h21v5H0zm4.334-3.747a1.5 1.5 0 1 0 0 2.495 1.25 1.25 0 1 1 0-2.495ZM5.5 4a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2-2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 2a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="VA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FDE048"></stop>
            <stop offset="100%" stop-color="#FFDF32"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#CDCCCC"></stop>
            <stop offset="100%" stop-color="#E4E4E4"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#CD9D25"></stop>
            <stop offset="100%" stop-color="#EBB93A"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F5252C"></stop>
            <stop offset="100%" stop-color="#F6151C"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#a)" d="M10 0h11v15H10z"></path>
          <path
            fill="url(#c)"
            d="M18.682 8.025a1.5 1.5 0 1 0-2.415-.414l-2.181 2.182-.354-.354-.353-.353-.707.707.353.353.707.708.354.353.353-.353 2.536-2.536a1.5 1.5 0 0 0 1.707-.293Z"
            transform="matrix(1 0 0 -1 0 16.672)"
          ></path>
          <path
            fill="url(#d)"
            d="M14.025 8.318a1.5 1.5 0 1 1 .708-.707l2.181 2.182.354-.354.353-.353.707.707-.353.353-.707.708-.354.353-.353-.353-2.536-2.536Z"
            transform="matrix(1 0 0 -1 0 16.672)"
          ></path>
          <path
            fill="url(#d)"
            d="M15.5 5c-.828 0-1.5-.224-1.5-.5s.672-.5 1.5-.5 1.5.224 1.5.5-.672.5-1.5.5Zm0-2.5c-.414 0-.75-.112-.75-.25s.336-.25.75-.25.75.112.75.25-.336.25-.75.25Zm0 1.167c-.552 0-1-.15-1-.334 0-.184.448-.333 1-.333s1 .15 1 .333c0 .184-.448.334-1 .334Z"
          ></path>
          <path
            fill="url(#e)"
            fill-rule="nonzero"
            d="M13.026 10.658c.08.242.247.576.527.912.48.576 1.13.93 1.947.93.817 0 1.467-.354 1.947-.93.28-.336.447-.67.527-.912a.5.5 0 1 0-.948-.316 1.98 1.98 0 0 1-.348.588c-.301.362-.683.57-1.178.57-.495 0-.877-.208-1.178-.57a1.98 1.98 0 0 1-.348-.588.5.5 0 1 0-.948.316Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="VC">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#08C47A"></stop>
            <stop offset="100%" stop-color="#009F60"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#0C87E1"></stop>
            <stop offset="100%" stop-color="#0073C7"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD147"></stop>
            <stop offset="100%" stop-color="#FECA2F"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#00C778"></stop>
            <stop offset="100%" stop-color="#009F60"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#d)" d="M6 0h9v15H6z"></path>
          <path
            fill="url(#e)"
            d="m11 6 1.5-3L14 6l-1.5 3L11 6ZM7 6l1.5-3L10 6 8.5 9 7 6Zm2 4 1.5-3 1.5 3-1.5 3L9 10Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="VE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#063191"></stop>
            <stop offset="100%" stop-color="#03287C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E2213B"></stop>
            <stop offset="100%" stop-color="#CD1931"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD044"></stop>
            <stop offset="100%" stop-color="#FFCB2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 5h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path
            fill="url(#a)"
            d="M10.5 7a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm-2 .5a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm4 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1ZM7.5 9a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm6 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
          <path fill="url(#d)" d="M0 0h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="VG">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#07319C"></stop>
            <stop offset="100%" stop-color="#00247E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#008339"></stop>
            <stop offset="100%" stop-color="#00612A"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD033"></stop>
            <stop offset="100%" stop-color="#FEC403"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#DB1E36"></stop>
            <stop offset="100%" stop-color="#D51931"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#c)"
            d="M13 7.5V5c0-.553.444-1 1-1h3c.552 0 1 .441 1 1v2.5c0 2.5-2.5 3.5-2.5 3.5S13 10 13 7.5Z"
          ></path>
          <path
            fill="url(#d)"
            d="M14.5 6a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0 1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0-1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0-1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm0-1a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"
          ></path>
          <ellipse cx="15.5" cy="7" fill="url(#a)" rx="1" ry="1.5"></ellipse>
          <path
            fill="url(#d)"
            fill-rule="nonzero"
            d="M12.5 10c0 .954 1.366 1.5 3 1.5s3-.546 3-1.5a.5.5 0 1 0-1 0c0 .01-.121.124-.418.243-.403.161-.97.257-1.582.257-.612 0-1.18-.096-1.582-.257-.297-.119-.418-.233-.418-.243a.5.5 0 1 0-1 0Z"
          ></path>
          <path
            fill="url(#a)"
            fill-rule="nonzero"
            d="M3 3.23-1.352-.5H.66L4.16 2h.697L9.5-.902V.25c0 .303-.167.627-.418.806L6 3.257v.513l3.137 2.69c.462.395.204 1.04-.387 1.04-.245 0-.545-.096-.75-.242L4.84 5h-.697L-.5 7.902v-1.66l3.5-2.5V3.23Z"
          ></path>
          <path
            fill="url(#e)"
            d="M3.5 3 0 0h.5L4 2.5h1L9 0v.25a.537.537 0 0 1-.208.399L5.5 3v1l3.312 2.839c.104.089.072.161-.062.161a.898.898 0 0 1-.458-.149L5 4.5H4L0 7v-.5L3.5 4V3Z"
          ></path>
          <path
            fill="url(#a)"
            d="M0 2.5v2h3.5v2.505c0 .273.214.495.505.495h.99a.496.496 0 0 0 .505-.495V4.5h3.51a.49.49 0 0 0 .49-.505v-.99a.495.495 0 0 0-.49-.505H5.5V0h-2v2.5H0Z"
          ></path>
          <path fill="url(#e)" d="M0 3h4V0h1v3h4v1H5v3H4V4H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="VI">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F8CE61"></stop>
            <stop offset="100%" stop-color="#F3C44B"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1E357F"></stop>
            <stop offset="100%" stop-color="#162966"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#BC1443"></stop>
            <stop offset="100%" stop-color="#A30B35"></stop>
          </linearGradient>
          <path
            id="b"
            d="M15 6.5s.036.665-.803 1c-.839.335-1.697 0-1.697 0s.618.363 1 1 .182.983.5 1.301c.318.318.891.101 1.118.373.227.273.21.584-.118.826-.328.242-.432.13-.803-.118-.371-.248-.197-.495-.197-.495s-.64-.331-1.128-.474C12.5 9.218 12 9 12 9v.5s1 .513 1 1c0 .213-.462.916-1 1.417-.692.644-1.5.822-1.5.822V5.5l3-.5s-1.381-1.087 1.75-1.847l3.78-.917c.536-.13.74.14.442.605 0 0-.024.099-.472.659-.448.56-.546.66-1 1-.454.34-.454.09-1 .5-.546.41-.567.783-1 1-.433.217-1 0-1 0v.5Zm-9 0V6s-.567.217-1 0c-.434-.217-.454-.59-1-1-.547-.41-.547-.16-1-.5-.454-.34-.552-.44-1-1-.448-.56-.472-.659-.472-.659-.299-.464-.094-.735.442-.605l3.78.917C8.88 3.913 7.5 5 7.5 5l3 .5v7.24s-.808-.179-1.5-.823c-.538-.5-1-1.204-1-1.417 0-.487 1-1 1-1V9s-.5.218-.872.913c-.489.143-1.128.474-1.128.474s.174.247-.197.495c-.372.247-.476.36-.803.118-.328-.242-.346-.553-.119-.826.227-.272.801-.055 1.119-.373.317-.318.117-.664.5-1.301.382-.637 1-1 1-1s-.858.335-1.697 0C5.964 7.165 6 6.5 6 6.5Zm3.248-1.774c-.02-.139-.318-.25-.185-.284.247-.064.371-.143.493-.353.054-.092-.187-.032-.109-.123.412-.477.498-.847.234-.972-.571-.269-.641.427-.618.14.016-.204.037-.369.063-.451.115-.366.697-.344.733-.415.146-.293.314-.32.641-.268.327.053.475.209.605.469.098.196.07.502.178.794.07.19.17.294.247.483.044.11-.289-.108-.247 0 .113.294.396.281.566.547.07.109-.256-.02-.235.149C11.63 4.555 12 5 12 5H9s.266-.153.248-.274Z"
          ></path>
          <path
            id="d"
            d="M0 2.5V0s.498.489 1.163.489C1.827.489 2.5 0 2.5 0s.627.489 1.251.489C4.376.489 5 0 5 0v2.5C5 5 2.5 6 2.5 6S0 5 0 2.5Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path
            fill="#1583C4"
            fill-rule="nonzero"
            d="m16.35 6.505-3.072 5.88a.25.25 0 0 0 .444.23l3.07-5.879a.25.25 0 0 0-.443-.231Z"
          ></path>
          <path
            fill="#1583C4"
            fill-rule="nonzero"
            d="m16.78 7.813-3.478 4.535a.25.25 0 0 0 .396.304l3.48-4.534a.25.25 0 1 0-.397-.305Z"
          ></path>
          <path
            fill="#1583C4"
            fill-rule="nonzero"
            d="m15.223 7.409-1.956 5a.25.25 0 0 0 .466.182l1.955-5a.25.25 0 0 0-.465-.182Z"
          ></path>
          <path
            fill="#409347"
            fill-rule="nonzero"
            d="M4.26 6.573c.03.093.08.256.15.464.117.347.242.694.37 1.019.15.373.294.693.432.945l.074.128c.16.266.413.614.742 1.026a36.319 36.319 0 0 0 1.287 1.513.25.25 0 0 0 .37-.336 35.831 35.831 0 0 1-1.267-1.49 9.854 9.854 0 0 1-.704-.97 3.41 3.41 0 0 1-.063-.112 8.185 8.185 0 0 1-.405-.889 19.401 19.401 0 0 1-.507-1.444.25.25 0 1 0-.478.146Z"
          ></path>
          <path
            fill="#1583C4"
            fill-rule="nonzero"
            d="M19 6.5V9a.5.5 0 1 0 1 0V6.5a.5.5 0 1 0-1 0ZM2.5 7.654l-.536-1.34a.5.5 0 0 0-.928.372l1 2.5a.5.5 0 0 0 .928 0l1-2.5a.5.5 0 0 0-.928-.372L2.5 7.654Z"
          ></path>
          <use xlink:href="#b" fill="url(#c)"></use>
          <path
            stroke="#000"
            stroke-opacity=".08"
            stroke-width=".5"
            d="m14.123 10.169.247.127-.159.225c-.013.034-.001.069.125.153.302.201.305.203.348.21.026.004.068-.012.168-.085.2-.149.218-.293.074-.465-.031-.037-.105-.057-.328-.078l-.129-.013a1.484 1.484 0 0 1-.346-.074Zm-.172-.086a.819.819 0 0 1-.128-.105c-.173-.173-.233-.329-.288-.627-.064-.347-.104-.48-.25-.722a2.52 2.52 0 0 0-.32-.421 2.84 2.84 0 0 0-.592-.492l.218-.449c.037.015.113.04.22.064.41.097.845.101 1.244-.044l.05-.02a1.14 1.14 0 0 0 .476-.33.683.683 0 0 0 .17-.427v.003L14.75 6.5v-.863l.34.13c.021.008.068.023.131.038.165.04.333.054.481.03a.648.648 0 0 0 .186-.059c.127-.063.207-.138.325-.294.336-.443.369-.481.637-.682.267-.2.412-.266.645-.324l.014-.003a.807.807 0 0 0 .341-.173c.433-.325.517-.409.955-.956.311-.39.424-.562.457-.638.174-.27.148-.305-.173-.227l-.716.173-3.064.744c-.659.16-1.136.34-1.45.532-.468.289-.498.512-.31.761a.664.664 0 0 0 .106.115l.444.35-3.349.558v6.686l.044-.017a3.423 3.423 0 0 0 1.036-.647c.457-.426.92-1.097.92-1.234 0-.007 0-.015-.002-.024-.022-.115-.168-.285-.399-.46a3.357 3.357 0 0 0-.463-.294l-.136-.07V8.619l.35.153c.194.085.466.28.732.62.074.097.145.2.21.312a7.035 7.035 0 0 1 .481.184c.16.069.307.137.428.196Zm0 0 .164.082.008.004a.826.826 0 0 1-.172-.086ZM10.25 5.712l.209.035-.21-.247v.212Zm0 6.686v.341l.304-.244a2.326 2.326 0 0 1-.304-.097ZM7.958 9.703c-.017.03-.034.06-.05.092l.15-.122a3.45 3.45 0 0 0-.1.03Zm-1.17.818.007.01-.007-.011v.001Zm.261-.438c-.063.03-.118.058-.164.082l-.008.004a.826.826 0 0 0 .172-.086Zm2.45-5.333h1.996a.655.655 0 0 1-.129-.277.336.336 0 0 1 .043-.233c-.19-.12-.287-.217-.36-.404-.051-.134-.007-.247.078-.312a1.269 1.269 0 0 1-.117-.295 2.559 2.559 0 0 1-.07-.38c-.02-.154-.035-.221-.059-.269-.11-.22-.204-.298-.42-.333-.261-.042-.298-.029-.378.133-.055.108-.112.133-.238.165.042-.01-.216.047-.282.07a.503.503 0 0 0-.138.065.834.834 0 0 1 .362.088c.432.203.374.664-.001 1.175a.285.285 0 0 1-.014.272.892.892 0 0 1-.32.341.383.383 0 0 1 .047.194Z"
          ></path>
          <g transform="translate(8 4)">
            <mask id="f" fill="#fff">
              <use xlink:href="#d"></use>
            </mask>
            <use xlink:href="#d" fill="url(#a)"></use>
            <path fill="url(#e)" d="M0 0h5v2H0z" mask="url(#f)"></path>
            <path fill="url(#g)" d="M0 2h1v4H0V2Zm2 0h1v4H2V2Zm2 0h1v4H4V2Z" mask="url(#f)"></path>
          </g>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="VN">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EA403F"></stop>
            <stop offset="100%" stop-color="#D82827"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFFE4E"></stop>
            <stop offset="100%" stop-color="#FFFE38"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#c)"
            d="m10.5 9.255-2.645 1.886.976-3.099L6.22 6.109l3.248-.029L10.5 3l1.032 3.08 3.248.029-2.611 1.933.976 3.099z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="VU">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#27AB53"></stop>
            <stop offset="100%" stop-color="#219447"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EC2547"></stop>
            <stop offset="100%" stop-color="#CE1A39"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD449"></stop>
            <stop offset="100%" stop-color="#FDCD34"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M.2 9h21v6H.2z"></path>
          <path fill="url(#c)" d="M.2 0h21v6H.2z"></path>
          <path fill="url(#d)" d="M8.2 6h13v3h-13l-8 6V0l8 6Z"></path>
          <path
            fill="url(#e)"
            fill-rule="nonzero"
            d="M6.867 7.5-.6 1.9l-.4-.3.6-.8.4.3L7.867 7H21.2v1H7.7l.3-.1-8 6-.4.3-.6-.8.4-.3 7.467-5.6Z"
          ></path>
          <path
            fill="url(#e)"
            d="M2.7 9a1.5 1.5 0 1 1 1.5-1.5c0 .727-.813 2.363-1.5 2.5-.096.02.101-1 0-1Zm0-.75c.276.25.5-.474.5-.75a.5.5 0 0 0-1 0c0 .276.224 1 .5.75Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="WF">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F44653"></stop>
            <stop offset="100%" stop-color="#EE2A39"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1035BB"></stop>
            <stop offset="100%" stop-color="#042396"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M10 0h11v15H10z"></path>
          <path fill="url(#c)" d="M0 0h7v15H0z"></path>
          <path fill="url(#a)" d="M7 0h7v15H7z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="WS">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E31F37"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#083B9A"></stop>
            <stop offset="100%" stop-color="#042E7D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M0 8h11V0H0z"></path>
          <path
            fill="url(#a)"
            d="m5 7-.707.207L4.5 6.5l-.207-.707L5 6l.707-.207L5.5 6.5l.207.707L5 7Zm0-5-.707.207L4.5 1.5 4.293.793 5 1l.707-.207L5.5 1.5l.207.707L5 2ZM3 4.5l-.707.207L2.5 4l-.207-.707L3 3.5l.707-.207L3.5 4l.207.707L3 4.5ZM7.5 4l-.707.207L7 3.5l-.207-.707L7.5 3l.707-.207L8 3.5l.207.707L7.5 4ZM6.25 5.5a.25.25 0 1 1 0-.5.25.25 0 0 1 0 .5Z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 23 17" id="WW">
        <defs>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#19BFBF"></stop>
            <stop offset="100%" stop-color="#10ACAC"></stop>
          </linearGradient>
          <filter id="b" width="200%" height="200%" x="-50%" y="-50%" filterUnits="objectBoundingBox">
            <feOffset dy=".5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feGaussianBlur in="shadowOffsetOuter1" result="shadowBlurOuter1" stdDeviation=".5"></feGaussianBlur>
            <feColorMatrix in="shadowBlurOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.16 0"></feColorMatrix>
          </filter>
          <filter id="g" width="200%" height="200%" x="-50%" y="-50%" filterUnits="objectBoundingBox">
            <feOffset dy=".5" in="SourceAlpha" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <rect id="a" width="21" height="15" x="0" y="0" rx="1.5"></rect>
          <path
            id="f"
            d="M10.21 11.99a4.568 4.568 0 0 0 .58 0c.686-.812 1.126-2.303 1.2-3.99H9.01c.074 1.687.514 3.178 1.2 3.99Zm-1.373-.307A4.504 4.504 0 0 1 6.027 8H8.01c.055 1.396.34 2.69.827 3.683Zm1.374-8.674a4.568 4.568 0 0 1 .578 0c.687.813 1.127 2.304 1.2 3.991H9.011c.073-1.687.513-3.178 1.2-3.99Zm-1.374.308A4.504 4.504 0 0 0 6.027 7H8.01c.055-1.396.34-2.69.827-3.683Zm3.326 8.366A4.504 4.504 0 0 0 14.973 8H12.99c-.055 1.396-.34 2.69-.827 3.683Zm0-8.366A4.504 4.504 0 0 1 14.973 7H12.99c-.055-1.396-.34-2.69-.827-3.683ZM10.5 13a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z"
          ></path>
        </defs>
        <g fill="none" fill-rule="evenodd" transform="translate(1 1)">
          <mask id="e" fill="#fff">
            <use xlink:href="#a"></use>
          </mask>
          <use xlink:href="#a" fill="#000" filter="url(#b)"></use>
          <use xlink:href="#a" fill="url(#c)"></use>
          <path fill="url(#d)" d="M0 0h21v15H0z" mask="url(#e)"></path>
          <g mask="url(#e)">
            <use xlink:href="#f" fill="#000" filter="url(#g)"></use>
            <use xlink:href="#f" fill="url(#c)"></use>
          </g>
          <rect width="21" height="15" mask="url(#e)" rx="1.5"></rect>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="XK">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#2F5FBF"></stop>
            <stop offset="100%" stop-color="#244EA3"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E9C072"></stop>
            <stop offset="100%" stop-color="#CFA557"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#a)"
            d="m9 3.5-.707.207L8.5 3l-.207-.707L9 2.5l.707-.207L9.5 3l.207.707L9 3.5Zm3 0-.707.207L11.5 3l-.207-.707L12 2.5l.707-.207L12.5 3l.207.707L12 3.5Zm3 1-.707.207L14.5 4l-.207-.707L15 3.5l.707-.207L15.5 4l.207.707L15 4.5Zm2 2-.707.207L16.5 6l-.207-.707L17 5.5l.707-.207L17.5 6l.207.707L17 6.5Zm-13 0-.707.207L3.5 6l-.207-.707L4 5.5l.707-.207L4.5 6l.207.707L4 6.5Zm2-2-.707.207L5.5 4l-.207-.707L6 3.5l.707-.207L6.5 4l.207.707L6 4.5Z"
          ></path>
          <path
            fill="url(#c)"
            d="m9 10-1-.5-1-2h1l1-1 .5-1 1-.5.5.5 1 .5v.5l.5.5L14 8l-.5 1.5L12 11l-.5-1-1.5 1v1l-.5-.5z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="YE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E32138"></stop>
            <stop offset="100%" stop-color="#CC162C"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v5H0z"></path>
          <path fill="url(#c)" d="M0 10h21v5H0z"></path>
          <path fill="url(#a)" d="M0 5h21v5H0z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 21 15" id="YT">
        <defs>
          <path
            id="k"
            fill="url(#a)"
            d="M1.039 1.726v-.464L1.5 1S1.045.444 1.27.444C1.545.444 2.7.81 3 1c.3.19.453.418.496.85.042.431-.316.981-.316.981L3 3.25l.788-.179s.128.826-.452 1.429c-.58.603-1.395.49-1.395.49l-.164-.49s-.53.206-.843.674C.62 5.642.533 6.45 1.039 6.95s1.341.457 1.74-.245c0 0 .159-.62-.21-.912-.367-.291-.616.311-.628.278-.071-.21-.164-.57.428-.57s.896.637.81 1.126c-.084.489-.255.953-1.402 1.083C.631 7.84.336 6.386.336 6.386s-.292-1.356 0-2.335c.292-.98.725-1.004 1.605-1.541.88-.538-.531-.183-.531-.183s-.67.504-.88.32c-.21-.183.509-.921.509-.921Z"
          ></path>
        </defs>
        <defs>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="g" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1B2CA9"></stop>
            <stop offset="100%" stop-color="#132294"></stop>
          </linearGradient>
          <linearGradient id="j" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#E6402C"></stop>
            <stop offset="100%" stop-color="#D1321F"></stop>
          </linearGradient>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#D0D0D0"></stop>
            <stop offset="100%" stop-color="#C4C4C4"></stop>
          </linearGradient>
          <linearGradient id="l" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="m" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F7E04B"></stop>
            <stop offset="100%" stop-color="#EAD135"></stop>
          </linearGradient>
          <path
            id="c"
            d="M0 .491A.49.49 0 0 1 .498 0h4.004A.5.5 0 0 1 5 .491v5.018a.535.535 0 0 1-.5.522S3 6 2.5 6.94C2 6 .5 6.03.5 6.03a.54.54 0 0 1-.5-.522V.491Z"
          ></path>
          <path id="e" d="M0 0h5v3H0z"></path>
          <path id="h" d="M0 3h5v4H0z"></path>
          <filter id="f" width="130%" height="150%" x="-15%" y="-25%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius=".25" result="shadowSpreadOuter1"></feMorphology>
            <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
          <filter id="i" width="130%" height="137.5%" x="-15%" y="-18.8%" filterUnits="objectBoundingBox">
            <feMorphology in="SourceAlpha" operator="dilate" radius=".25" result="shadowSpreadOuter1"></feMorphology>
            <feOffset in="shadowSpreadOuter1" result="shadowOffsetOuter1"></feOffset>
            <feColorMatrix in="shadowOffsetOuter1" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"></feColorMatrix>
          </filter>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <g transform="translate(8 4)">
            <mask id="d" fill="#fff">
              <use xlink:href="#c"></use>
            </mask>
            <use xlink:href="#c" fill="#D8D8D8"></use>
            <path
              stroke="#979797"
              d="M4.5.5V.491.5Zm0 0h.002H4.5Zm-4 0v5.009s.02.022-.01.022H.5c.342-.004.793.048 1.25.213.285.102.538.24.75.418.212-.178.465-.316.75-.418.444-.16.882-.214 1.22-.213.02-.005.03-.017.03-.022V.5h-4Z"
            ></path>
            <g mask="url(#d)">
              <use xlink:href="#e" fill="#000" filter="url(#f)"></use>
              <use xlink:href="#e" fill="url(#g)"></use>
            </g>
            <g mask="url(#d)">
              <use xlink:href="#h" fill="#000" filter="url(#i)"></use>
              <use xlink:href="#h" fill="url(#j)"></use>
            </g>
          </g>
          <g transform="translate(14 3)">
            <use xlink:href="#k"></use>
            <circle cx="1.75" cy="1.75" r="1" fill="url(#l)" fill-opacity=".3"></circle>
          </g>
          <g transform="matrix(-1 0 0 1 7 3)">
            <use xlink:href="#k"></use>
            <circle cx="1.75" cy="1.75" r="1" fill="url(#l)" fill-opacity=".3"></circle>
          </g>
          <path fill="url(#b)" d="M9.634 5a1 1 0 1 0 1.732 0 1 1 0 0 1-1.732 0Z"></path>
          <path fill="url(#m)" d="M9.5 9a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Zm2 0a.5.5 0 1 1 0-1 .5.5 0 0 1 0 1Z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ZA">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#06A86E"></stop>
            <stop offset="100%" stop-color="#007A4E"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFBF2E"></stop>
            <stop offset="100%" stop-color="#FFB612"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F44E46"></stop>
            <stop offset="100%" stop-color="#DF3931"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#072CB4"></stop>
            <stop offset="100%" stop-color="#042396"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="m0 2 7 5.5L0 13z"></path>
          <path fill="url(#d)" d="M-1 2.25 5.75 7.5-1 12.75z"></path>
          <path fill="#FFF" d="M9 6 2 0h19v6z"></path>
          <path fill="url(#e)" d="m9.25 5-6-5H21v5z"></path>
          <path fill="#FFF" d="M2 15h19V9H9z"></path>
          <path fill="url(#f)" d="M3.25 15H21v-5H9.25z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ZM">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="100%" y2="0%">
            <stop offset="0%" stop-color="#2A8815"></stop>
            <stop offset="100%" stop-color="#35A51D"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EF8A34"></stop>
            <stop offset="100%" stop-color="#EC7E21"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F48D36"></stop>
            <stop offset="100%" stop-color="#EC7E21"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="f" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EC322B"></stop>
            <stop offset="100%" stop-color="#DB261F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path
            fill="url(#c)"
            d="M16.196 3.624s-.403.153-.834 0c-.342-.122-.687-.534-.97-.677-.164-.083.14-.478-.184-.371-.325.106-.855-.39-.855-.39s-.548-.667.259-.667 2.51.58 2.51.58.063-.3.202-.438.242-.265.47-.23c.227.034.353.355.353.355l-.354.135v.266s2.362-.724 2.92-.668c.558.056.109.669-.228 1.057-.13.15-.556.456-.815.21-.259-.245-.163.266-.43.43-.438.27-.602.516-.753.587-.15.072-.479 0-.479 0l.096.247s.027.296-.096.414-.208.202-.508.166c-.3-.035-.441.04-.541-.29-.1-.33.237-.716.237-.716Zm.247-.342v.772l.339-.284-.34-.488Z"
          ></path>
          <path fill="url(#d)" d="M18 6h3v9h-3z"></path>
          <path fill="url(#e)" d="M15 6h3v9h-3z"></path>
          <path fill="url(#f)" d="M12 6h3v9h-3z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="ZW">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#369D0C"></stop>
            <stop offset="100%" stop-color="#319209"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFD40E"></stop>
            <stop offset="100%" stop-color="#FFD201"></stop>
          </linearGradient>
          <linearGradient id="e" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#F12F1F"></stop>
            <stop offset="100%" stop-color="#DE2010"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v2H0zm0 13h21v2H0zm0-9h21v2H0zm0 5h21v2H0z"></path>
          <path fill="url(#c)" d="M0 6h21v3H0z"></path>
          <path fill="url(#d)" d="M0 2h21v2H0zm0 9h21v2H0z"></path>
          <path fill="url(#c)" fill-rule="nonzero" d="M-1 15V0h1l10 7.5L0 15z"></path>
          <path fill="url(#a)" fill-rule="nonzero" d="M0 13.75 8.333 7.5 0 1.25z"></path>
          <path
            fill="url(#e)"
            d="M3 8.475 1.531 9.523l.542-1.722L.622 6.727l1.805-.016L3 5l.573 1.711 1.805.016-1.451 1.074.542 1.722z"
          ></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AD">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#1537D1"></stop>
            <stop offset="100%" stop-color="#0522A5"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#EA3058"></stop>
            <stop offset="100%" stop-color="#CE173E"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFCF3C"></stop>
            <stop offset="100%" stop-color="#FECB2F"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M0 0h21v15H0z"></path>
          <path fill="url(#c)" d="M10 0h11v15H10z"></path>
          <path fill="url(#d)" d="M7 0h7v15H7z"></path>
          <path fill="#FFEDB1" d="M9.5 6.5h1V7h-1z"></path>
          <path
            fill="#D32E28"
            fill-rule="nonzero"
            d="M9.665 7.96c.025.295.292.54.587.54h.496a.607.607 0 0 0 .587-.54l.122-1.46H9.543l.122 1.46Zm-.624-1.465A.446.446 0 0 1 9.495 6h2.01c.273 0 .477.216.454.495l-.126 1.506c-.046.552-.53.999-1.085.999h-.496a1.105 1.105 0 0 1-1.085-.999L9.04 6.495Z"
          ></path>
          <path fill="#D32E28" d="M9.5 7h2v.5h-2z"></path>
        </g>
      </symbol>
      <symbol xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 15" id="AE">
        <defs>
          <linearGradient id="a" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FFF"></stop>
            <stop offset="100%" stop-color="#F0F0F0"></stop>
          </linearGradient>
          <linearGradient id="b" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#12833B"></stop>
            <stop offset="100%" stop-color="#0D7332"></stop>
          </linearGradient>
          <linearGradient id="c" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#262626"></stop>
            <stop offset="100%" stop-color="#0D0D0D"></stop>
          </linearGradient>
          <linearGradient id="d" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stop-color="#FF323E"></stop>
            <stop offset="100%" stop-color="#FD0D1B"></stop>
          </linearGradient>
        </defs>
        <g fill="none" fill-rule="evenodd">
          <path fill="url(#a)" d="M0 0h21v15H0z"></path>
          <path fill="url(#b)" d="M6 0h15v5H6z"></path>
          <path fill="url(#c)" d="M6 10h15v5H6z"></path>
          <path fill="url(#a)" d="M6 5h15v5H6z"></path>
          <path fill="url(#d)" d="M0 0h6v15H0z"></path>
        </g>
      </symbol>
    </defs>
  </svg>
`;
